export default [
  {
    name: "北京市",
    code: "110000",
    areaCode: "010",
    cities: [
      {
        name: "北京市市辖区",
        code: "110100",
        areaCode: "010",
        cities: [
          {
            name: "东城区",
            code: "110101",
            areaCode: "010",
          },
          {
            name: "西城区",
            code: "110102",
            areaCode: "010",
          },
          {
            name: "朝阳区",
            code: "110105",
            areaCode: "010",
          },
          {
            name: "丰台区",
            code: "110106",
            areaCode: "010",
          },
          {
            name: "石景山区",
            code: "110107",
            areaCode: "010",
          },
          {
            name: "海淀区",
            code: "110108",
            areaCode: "010",
          },
          {
            name: "门头沟区",
            code: "110109",
            areaCode: "010",
          },
          {
            name: "房山区",
            code: "110111",
            areaCode: "010",
          },
          {
            name: "通州区",
            code: "110112",
            areaCode: "010",
          },
          {
            name: "顺义区",
            code: "110113",
            areaCode: "010",
          },
          {
            name: "昌平区",
            code: "110114",
            areaCode: "010",
          },
          {
            name: "大兴区",
            code: "110115",
            areaCode: "010",
          },
          {
            name: "怀柔区",
            code: "110116",
            areaCode: "010",
          },
          {
            name: "平谷区",
            code: "110117",
            areaCode: "010",
          },
          {
            name: "密云区",
            code: "110118",
            areaCode: "010",
          },
          {
            name: "延庆区",
            code: "110119",
            areaCode: "010",
          },
        ],
      },
    ],
  },
  {
    name: "天津市",
    code: "120000",
    areaCode: "022",
    cities: [
      {
        name: "天津市市辖区",
        code: "120100",
        areaCode: "022",
        cities: [
          {
            name: "和平区",
            code: "120101",
            areaCode: "022",
          },
          {
            name: "河东区",
            code: "120102",
            areaCode: "022",
          },
          {
            name: "河西区",
            code: "120103",
            areaCode: "022",
          },
          {
            name: "南开区",
            code: "120104",
            areaCode: "022",
          },
          {
            name: "河北区",
            code: "120105",
            areaCode: "022",
          },
          {
            name: "红桥区",
            code: "120106",
            areaCode: "022",
          },
          {
            name: "东丽区",
            code: "120110",
            areaCode: "022",
          },
          {
            name: "西青区",
            code: "120111",
            areaCode: "022",
          },
          {
            name: "津南区",
            code: "120112",
            areaCode: "022",
          },
          {
            name: "北辰区",
            code: "120113",
            areaCode: "022",
          },
          {
            name: "武清区",
            code: "120114",
            areaCode: "022",
          },
          {
            name: "宝坻区",
            code: "120115",
            areaCode: "022",
          },
          {
            name: "滨海新区",
            code: "120116",
            areaCode: "022",
          },
          {
            name: "宁河区",
            code: "120117",
            areaCode: "022",
          },
          {
            name: "静海区",
            code: "120118",
            areaCode: "022",
          },
          {
            name: "蓟州区",
            code: "120119",
            areaCode: "022",
          },
        ],
      },
    ],
  },
  {
    name: "河北省",
    code: "130000",
    areaCode: "",
    cities: [
      {
        name: "石家庄市",
        code: "130100",
        areaCode: "0311",
        cities: [
          {
            name: "石家庄市市辖区",
            code: "130101",
            areaCode: "0311",
          },
          {
            name: "长安区",
            code: "130102",
            areaCode: "0311",
          },
          {
            name: "桥西区",
            code: "130104",
            areaCode: "0311",
          },
          {
            name: "新华区",
            code: "130105",
            areaCode: "0311",
          },
          {
            name: "井陉矿区",
            code: "130107",
            areaCode: "0311",
          },
          {
            name: "裕华区",
            code: "130108",
            areaCode: "0311",
          },
          {
            name: "藁城区",
            code: "130109",
            areaCode: "0311",
          },
          {
            name: "鹿泉区",
            code: "130110",
            areaCode: "0311",
          },
          {
            name: "栾城区",
            code: "130111",
            areaCode: "0311",
          },
          {
            name: "井陉县",
            code: "130121",
            areaCode: "0311",
          },
          {
            name: "正定县",
            code: "130123",
            areaCode: "0311",
          },
          {
            name: "行唐县",
            code: "130125",
            areaCode: "0311",
          },
          {
            name: "灵寿县",
            code: "130126",
            areaCode: "0311",
          },
          {
            name: "高邑县",
            code: "130127",
            areaCode: "0311",
          },
          {
            name: "深泽县",
            code: "130128",
            areaCode: "0311",
          },
          {
            name: "赞皇县",
            code: "130129",
            areaCode: "0311",
          },
          {
            name: "无极县",
            code: "130130",
            areaCode: "0311",
          },
          {
            name: "平山县",
            code: "130131",
            areaCode: "0311",
          },
          {
            name: "元氏县",
            code: "130132",
            areaCode: "0311",
          },
          {
            name: "赵县",
            code: "130133",
            areaCode: "0311",
          },
          {
            name: "辛集市",
            code: "130181",
            areaCode: "0311",
          },
          {
            name: "晋州市",
            code: "130183",
            areaCode: "0311",
          },
          {
            name: "新乐市",
            code: "130184",
            areaCode: "0311",
          },
        ],
      },
      {
        name: "唐山市",
        code: "130200",
        areaCode: "0315",
        cities: [
          {
            name: "唐山市市辖区",
            code: "130201",
            areaCode: "0315",
          },
          {
            name: "路南区",
            code: "130202",
            areaCode: "0315",
          },
          {
            name: "路北区",
            code: "130203",
            areaCode: "0315",
          },
          {
            name: "古冶区",
            code: "130204",
            areaCode: "0315",
          },
          {
            name: "开平区",
            code: "130205",
            areaCode: "0315",
          },
          {
            name: "丰南区",
            code: "130207",
            areaCode: "0315",
          },
          {
            name: "丰润区",
            code: "130208",
            areaCode: "0315",
          },
          {
            name: "曹妃甸区",
            code: "130209",
            areaCode: "0315",
          },
          {
            name: "滦州市",
            code: "130284",
            areaCode: "0315",
          },
          {
            name: "滦南县",
            code: "130224",
            areaCode: "0315",
          },
          {
            name: "乐亭县",
            code: "130225",
            areaCode: "0315",
          },
          {
            name: "迁西县",
            code: "130227",
            areaCode: "0315",
          },
          {
            name: "玉田县",
            code: "130229",
            areaCode: "0315",
          },
          {
            name: "遵化市",
            code: "130281",
            areaCode: "0315",
          },
          {
            name: "迁安市",
            code: "130283",
            areaCode: "0315",
          },
        ],
      },
      {
        name: "秦皇岛市",
        code: "130300",
        areaCode: "0335",
        cities: [
          {
            name: "秦皇岛市市辖区",
            code: "130301",
            areaCode: "0335",
          },
          {
            name: "海港区",
            code: "130302",
            areaCode: "0335",
          },
          {
            name: "山海关区",
            code: "130303",
            areaCode: "0335",
          },
          {
            name: "北戴河区",
            code: "130304",
            areaCode: "0335",
          },
          {
            name: "抚宁区",
            code: "130306",
            areaCode: "0335",
          },
          {
            name: "青龙满族自治县",
            code: "130321",
            areaCode: "0335",
          },
          {
            name: "昌黎县",
            code: "130322",
            areaCode: "0335",
          },
          {
            name: "卢龙县",
            code: "130324",
            areaCode: "0335",
          },
        ],
      },
      {
        name: "邯郸市",
        code: "130400",
        areaCode: "0310",
        cities: [
          {
            name: "邯郸市市辖区",
            code: "130401",
            areaCode: "0310",
          },
          {
            name: "邯山区",
            code: "130402",
            areaCode: "0310",
          },
          {
            name: "丛台区",
            code: "130403",
            areaCode: "0310",
          },
          {
            name: "复兴区",
            code: "130404",
            areaCode: "0310",
          },
          {
            name: "峰峰矿区",
            code: "130406",
            areaCode: "0310",
          },
          {
            name: "肥乡区",
            code: "130407",
            areaCode: "0310",
          },
          {
            name: "永年区",
            code: "130408",
            areaCode: "0310",
          },
          {
            name: "临漳县",
            code: "130423",
            areaCode: "0310",
          },
          {
            name: "成安县",
            code: "130424",
            areaCode: "0310",
          },
          {
            name: "大名县",
            code: "130425",
            areaCode: "0310",
          },
          {
            name: "涉县",
            code: "130426",
            areaCode: "0310",
          },
          {
            name: "磁县",
            code: "130427",
            areaCode: "0310",
          },
          {
            name: "邱县",
            code: "130430",
            areaCode: "0310",
          },
          {
            name: "鸡泽县",
            code: "130431",
            areaCode: "0310",
          },
          {
            name: "广平县",
            code: "130432",
            areaCode: "0310",
          },
          {
            name: "馆陶县",
            code: "130433",
            areaCode: "0310",
          },
          {
            name: "魏县",
            code: "130434",
            areaCode: "0310",
          },
          {
            name: "曲周县",
            code: "130435",
            areaCode: "0310",
          },
          {
            name: "武安市",
            code: "130481",
            areaCode: "0310",
          },
        ],
      },
      {
        name: "邢台市",
        code: "130500",
        areaCode: "0319",
        cities: [
          {
            name: "邢台市市辖区",
            code: "130501",
            areaCode: "0319",
          },
          {
            name: "襄都区",
            code: "130502",
            areaCode: "0319",
          },
          {
            name: "信都区",
            code: "130503",
            areaCode: "0319",
          },
          {
            name: "临城县",
            code: "130522",
            areaCode: "0319",
          },
          {
            name: "内丘县",
            code: "130523",
            areaCode: "0319",
          },
          {
            name: "柏乡县",
            code: "130524",
            areaCode: "0319",
          },
          {
            name: "隆尧县",
            code: "130525",
            areaCode: "0319",
          },
          {
            name: "任泽区",
            code: "130505",
            areaCode: "0319",
          },
          {
            name: "南和区",
            code: "130506",
            areaCode: "0319",
          },
          {
            name: "宁晋县",
            code: "130528",
            areaCode: "0319",
          },
          {
            name: "巨鹿县",
            code: "130529",
            areaCode: "0319",
          },
          {
            name: "新河县",
            code: "130530",
            areaCode: "0319",
          },
          {
            name: "广宗县",
            code: "130531",
            areaCode: "0319",
          },
          {
            name: "平乡县",
            code: "130532",
            areaCode: "0319",
          },
          {
            name: "威县",
            code: "130533",
            areaCode: "0319",
          },
          {
            name: "清河县",
            code: "130534",
            areaCode: "0319",
          },
          {
            name: "临西县",
            code: "130535",
            areaCode: "0319",
          },
          {
            name: "南宫市",
            code: "130581",
            areaCode: "0319",
          },
          {
            name: "沙河市",
            code: "130582",
            areaCode: "0319",
          },
        ],
      },
      {
        name: "保定市",
        code: "130600",
        areaCode: "0312",
        cities: [
          {
            name: "保定市市辖区",
            code: "130601",
            areaCode: "0312",
          },
          {
            name: "竞秀区",
            code: "130602",
            areaCode: "0312",
          },
          {
            name: "莲池区",
            code: "130606",
            areaCode: "0312",
          },
          {
            name: "满城区",
            code: "130607",
            areaCode: "0312",
          },
          {
            name: "清苑区",
            code: "130608",
            areaCode: "0312",
          },
          {
            name: "徐水区",
            code: "130609",
            areaCode: "0312",
          },
          {
            name: "涞水县",
            code: "130623",
            areaCode: "0312",
          },
          {
            name: "阜平县",
            code: "130624",
            areaCode: "0312",
          },
          {
            name: "定兴县",
            code: "130626",
            areaCode: "0312",
          },
          {
            name: "唐县",
            code: "130627",
            areaCode: "0312",
          },
          {
            name: "高阳县",
            code: "130628",
            areaCode: "0312",
          },
          {
            name: "容城县",
            code: "130629",
            areaCode: "0312",
          },
          {
            name: "涞源县",
            code: "130630",
            areaCode: "0312",
          },
          {
            name: "望都县",
            code: "130631",
            areaCode: "0312",
          },
          {
            name: "安新县",
            code: "130632",
            areaCode: "0312",
          },
          {
            name: "易县",
            code: "130633",
            areaCode: "0312",
          },
          {
            name: "曲阳县",
            code: "130634",
            areaCode: "0312",
          },
          {
            name: "蠡县",
            code: "130635",
            areaCode: "0312",
          },
          {
            name: "顺平县",
            code: "130636",
            areaCode: "0312",
          },
          {
            name: "博野县",
            code: "130637",
            areaCode: "0312",
          },
          {
            name: "雄县",
            code: "130638",
            areaCode: "0312",
          },
          {
            name: "涿州市",
            code: "130681",
            areaCode: "0312",
          },
          {
            name: "定州市",
            code: "130682",
            areaCode: "0312",
          },
          {
            name: "安国市",
            code: "130683",
            areaCode: "0312",
          },
          {
            name: "高碑店市",
            code: "130684",
            areaCode: "0312",
          },
        ],
      },
      {
        name: "张家口市",
        code: "130700",
        areaCode: "0313",
        cities: [
          {
            name: "张家口市市辖区",
            code: "130701",
            areaCode: "0313",
          },
          {
            name: "桥东区",
            code: "130702",
            areaCode: "0313",
          },
          {
            name: "桥西区",
            code: "130703",
            areaCode: "0313",
          },
          {
            name: "宣化区",
            code: "130705",
            areaCode: "0313",
          },
          {
            name: "下花园区",
            code: "130706",
            areaCode: "0313",
          },
          {
            name: "万全区",
            code: "130708",
            areaCode: "0313",
          },
          {
            name: "崇礼区",
            code: "130709",
            areaCode: "0313",
          },
          {
            name: "张北县",
            code: "130722",
            areaCode: "0313",
          },
          {
            name: "康保县",
            code: "130723",
            areaCode: "0313",
          },
          {
            name: "沽源县",
            code: "130724",
            areaCode: "0313",
          },
          {
            name: "尚义县",
            code: "130725",
            areaCode: "0313",
          },
          {
            name: "蔚县",
            code: "130726",
            areaCode: "0313",
          },
          {
            name: "阳原县",
            code: "130727",
            areaCode: "0313",
          },
          {
            name: "怀安县",
            code: "130728",
            areaCode: "0313",
          },
          {
            name: "怀来县",
            code: "130730",
            areaCode: "0313",
          },
          {
            name: "涿鹿县",
            code: "130731",
            areaCode: "0313",
          },
          {
            name: "赤城县",
            code: "130732",
            areaCode: "0313",
          },
        ],
      },
      {
        name: "承德市",
        code: "130800",
        areaCode: "0314",
        cities: [
          {
            name: "承德市市辖区",
            code: "130801",
            areaCode: "0314",
          },
          {
            name: "双桥区",
            code: "130802",
            areaCode: "0314",
          },
          {
            name: "双滦区",
            code: "130803",
            areaCode: "0314",
          },
          {
            name: "鹰手营子矿区",
            code: "130804",
            areaCode: "0314",
          },
          {
            name: "承德县",
            code: "130821",
            areaCode: "0314",
          },
          {
            name: "兴隆县",
            code: "130822",
            areaCode: "0314",
          },
          {
            name: "滦平县",
            code: "130824",
            areaCode: "0314",
          },
          {
            name: "隆化县",
            code: "130825",
            areaCode: "0314",
          },
          {
            name: "丰宁满族自治县",
            code: "130826",
            areaCode: "0314",
          },
          {
            name: "宽城满族自治县",
            code: "130827",
            areaCode: "0314",
          },
          {
            name: "围场满族蒙古族自治县",
            code: "130828",
            areaCode: "0314",
          },
          {
            name: "平泉市",
            code: "130881",
            areaCode: "0314",
          },
        ],
      },
      {
        name: "沧州市",
        code: "130900",
        areaCode: "0317",
        cities: [
          {
            name: "沧州市市辖区",
            code: "130901",
            areaCode: "0317",
          },
          {
            name: "新华区",
            code: "130902",
            areaCode: "0317",
          },
          {
            name: "运河区",
            code: "130903",
            areaCode: "0317",
          },
          {
            name: "沧县",
            code: "130921",
            areaCode: "0317",
          },
          {
            name: "青县",
            code: "130922",
            areaCode: "0317",
          },
          {
            name: "东光县",
            code: "130923",
            areaCode: "0317",
          },
          {
            name: "海兴县",
            code: "130924",
            areaCode: "0317",
          },
          {
            name: "盐山县",
            code: "130925",
            areaCode: "0317",
          },
          {
            name: "肃宁县",
            code: "130926",
            areaCode: "0317",
          },
          {
            name: "南皮县",
            code: "130927",
            areaCode: "0317",
          },
          {
            name: "吴桥县",
            code: "130928",
            areaCode: "0317",
          },
          {
            name: "献县",
            code: "130929",
            areaCode: "0317",
          },
          {
            name: "孟村回族自治县",
            code: "130930",
            areaCode: "0317",
          },
          {
            name: "泊头市",
            code: "130981",
            areaCode: "0317",
          },
          {
            name: "任丘市",
            code: "130982",
            areaCode: "0317",
          },
          {
            name: "黄骅市",
            code: "130983",
            areaCode: "0317",
          },
          {
            name: "河间市",
            code: "130984",
            areaCode: "0317",
          },
        ],
      },
      {
        name: "廊坊市",
        code: "131000",
        areaCode: "0316",
        cities: [
          {
            name: "廊坊市市辖区",
            code: "131001",
            areaCode: "0316",
          },
          {
            name: "安次区",
            code: "131002",
            areaCode: "0316",
          },
          {
            name: "广阳区",
            code: "131003",
            areaCode: "0316",
          },
          {
            name: "固安县",
            code: "131022",
            areaCode: "0316",
          },
          {
            name: "永清县",
            code: "131023",
            areaCode: "0316",
          },
          {
            name: "香河县",
            code: "131024",
            areaCode: "0316",
          },
          {
            name: "大城县",
            code: "131025",
            areaCode: "0316",
          },
          {
            name: "文安县",
            code: "131026",
            areaCode: "0316",
          },
          {
            name: "大厂回族自治县",
            code: "131028",
            areaCode: "0316",
          },
          {
            name: "霸州市",
            code: "131081",
            areaCode: "0316",
          },
          {
            name: "三河市",
            code: "131082",
            areaCode: "0316",
          },
        ],
      },
      {
        name: "衡水市",
        code: "131100",
        areaCode: "0318",
        cities: [
          {
            name: "衡水市市辖区",
            code: "131101",
            areaCode: "0318",
          },
          {
            name: "桃城区",
            code: "131102",
            areaCode: "0318",
          },
          {
            name: "冀州区",
            code: "131103",
            areaCode: "0318",
          },
          {
            name: "枣强县",
            code: "131121",
            areaCode: "0318",
          },
          {
            name: "武邑县",
            code: "131122",
            areaCode: "0318",
          },
          {
            name: "武强县",
            code: "131123",
            areaCode: "0318",
          },
          {
            name: "饶阳县",
            code: "131124",
            areaCode: "0318",
          },
          {
            name: "安平县",
            code: "131125",
            areaCode: "0318",
          },
          {
            name: "故城县",
            code: "131126",
            areaCode: "0318",
          },
          {
            name: "景县",
            code: "131127",
            areaCode: "0318",
          },
          {
            name: "阜城县",
            code: "131128",
            areaCode: "0318",
          },
          {
            name: "深州市",
            code: "131182",
            areaCode: "0318",
          },
        ],
      },
    ],
  },
  {
    name: "山西省",
    code: "140000",
    areaCode: "",
    cities: [
      {
        name: "太原市",
        code: "140100",
        areaCode: "0351",
        cities: [
          {
            name: "太原市市辖区",
            code: "140101",
            areaCode: "0351",
          },
          {
            name: "小店区",
            code: "140105",
            areaCode: "0351",
          },
          {
            name: "迎泽区",
            code: "140106",
            areaCode: "0351",
          },
          {
            name: "杏花岭区",
            code: "140107",
            areaCode: "0351",
          },
          {
            name: "尖草坪区",
            code: "140108",
            areaCode: "0351",
          },
          {
            name: "万柏林区",
            code: "140109",
            areaCode: "0351",
          },
          {
            name: "晋源区",
            code: "140110",
            areaCode: "0351",
          },
          {
            name: "清徐县",
            code: "140121",
            areaCode: "0351",
          },
          {
            name: "阳曲县",
            code: "140122",
            areaCode: "0351",
          },
          {
            name: "娄烦县",
            code: "140123",
            areaCode: "0351",
          },
          {
            name: "古交市",
            code: "140181",
            areaCode: "0351",
          },
        ],
      },
      {
        name: "大同市",
        code: "140200",
        areaCode: "0352",
        cities: [
          {
            name: "大同市市辖区",
            code: "140201",
            areaCode: "0352",
          },
          {
            name: "平城区",
            code: "140213",
            areaCode: "0352",
          },
          {
            name: "云冈区",
            code: "140214",
            areaCode: "0352",
          },
          {
            name: "新荣区",
            code: "140212",
            areaCode: "0352",
          },
          {
            name: "阳高县",
            code: "140221",
            areaCode: "0352",
          },
          {
            name: "天镇县",
            code: "140222",
            areaCode: "0352",
          },
          {
            name: "广灵县",
            code: "140223",
            areaCode: "0352",
          },
          {
            name: "灵丘县",
            code: "140224",
            areaCode: "0352",
          },
          {
            name: "浑源县",
            code: "140225",
            areaCode: "0352",
          },
          {
            name: "左云县",
            code: "140226",
            areaCode: "0352",
          },
          {
            name: "云州区",
            code: "140215",
            areaCode: "0352",
          },
        ],
      },
      {
        name: "阳泉市",
        code: "140300",
        areaCode: "0353",
        cities: [
          {
            name: "阳泉市市辖区",
            code: "140301",
            areaCode: "0353",
          },
          {
            name: "城区",
            code: "140302",
            areaCode: "0353",
          },
          {
            name: "矿区",
            code: "140303",
            areaCode: "0353",
          },
          {
            name: "郊区",
            code: "140311",
            areaCode: "0353",
          },
          {
            name: "平定县",
            code: "140321",
            areaCode: "0353",
          },
          {
            name: "盂县",
            code: "140322",
            areaCode: "0353",
          },
        ],
      },
      {
        name: "长治市",
        code: "140400",
        areaCode: "0355",
        cities: [
          {
            name: "长治市市辖区",
            code: "140401",
            areaCode: "0355",
          },
          {
            name: "潞州区",
            code: "140403",
            areaCode: "0355",
          },
          {
            name: "上党区",
            code: "140404",
            areaCode: "0355",
          },
          {
            name: "襄垣县",
            code: "140423",
            areaCode: "0355",
          },
          {
            name: "屯留区",
            code: "140405",
            areaCode: "0355",
          },
          {
            name: "平顺县",
            code: "140425",
            areaCode: "0355",
          },
          {
            name: "黎城县",
            code: "140426",
            areaCode: "0355",
          },
          {
            name: "壶关县",
            code: "140427",
            areaCode: "0355",
          },
          {
            name: "长子县",
            code: "140428",
            areaCode: "0355",
          },
          {
            name: "武乡县",
            code: "140429",
            areaCode: "0355",
          },
          {
            name: "沁县",
            code: "140430",
            areaCode: "0355",
          },
          {
            name: "沁源县",
            code: "140431",
            areaCode: "0355",
          },
          {
            name: "潞城区",
            code: "140406",
            areaCode: "0355",
          },
        ],
      },
      {
        name: "晋城市",
        code: "140500",
        areaCode: "0356",
        cities: [
          {
            name: "晋城市市辖区",
            code: "140501",
            areaCode: "0356",
          },
          {
            name: "城区",
            code: "140502",
            areaCode: "0356",
          },
          {
            name: "沁水县",
            code: "140521",
            areaCode: "0356",
          },
          {
            name: "阳城县",
            code: "140522",
            areaCode: "0356",
          },
          {
            name: "陵川县",
            code: "140524",
            areaCode: "0356",
          },
          {
            name: "泽州县",
            code: "140525",
            areaCode: "0356",
          },
          {
            name: "高平市",
            code: "140581",
            areaCode: "0356",
          },
        ],
      },
      {
        name: "朔州市",
        code: "140600",
        areaCode: "0349",
        cities: [
          {
            name: "朔州市市辖区",
            code: "140601",
            areaCode: "0349",
          },
          {
            name: "朔城区",
            code: "140602",
            areaCode: "0349",
          },
          {
            name: "平鲁区",
            code: "140603",
            areaCode: "0349",
          },
          {
            name: "山阴县",
            code: "140621",
            areaCode: "0349",
          },
          {
            name: "应县",
            code: "140622",
            areaCode: "0349",
          },
          {
            name: "右玉县",
            code: "140623",
            areaCode: "0349",
          },
          {
            name: "怀仁市",
            code: "140681",
            areaCode: "0349",
          },
        ],
      },
      {
        name: "晋中市",
        code: "140700",
        areaCode: "0354",
        cities: [
          {
            name: "晋中市市辖区",
            code: "140701",
            areaCode: "0354",
          },
          {
            name: "榆次区",
            code: "140702",
            areaCode: "0354",
          },
          {
            name: "榆社县",
            code: "140721",
            areaCode: "0354",
          },
          {
            name: "左权县",
            code: "140722",
            areaCode: "0354",
          },
          {
            name: "和顺县",
            code: "140723",
            areaCode: "0354",
          },
          {
            name: "昔阳县",
            code: "140724",
            areaCode: "0354",
          },
          {
            name: "寿阳县",
            code: "140725",
            areaCode: "0354",
          },
          {
            name: "太谷区",
            code: "140703",
            areaCode: "0354",
          },
          {
            name: "祁县",
            code: "140727",
            areaCode: "0354",
          },
          {
            name: "平遥县",
            code: "140728",
            areaCode: "0354",
          },
          {
            name: "灵石县",
            code: "140729",
            areaCode: "0354",
          },
          {
            name: "介休市",
            code: "140781",
            areaCode: "0354",
          },
        ],
      },
      {
        name: "运城市",
        code: "140800",
        areaCode: "0359",
        cities: [
          {
            name: "运城市市辖区",
            code: "140801",
            areaCode: "0359",
          },
          {
            name: "盐湖区",
            code: "140802",
            areaCode: "0359",
          },
          {
            name: "临猗县",
            code: "140821",
            areaCode: "0359",
          },
          {
            name: "万荣县",
            code: "140822",
            areaCode: "0359",
          },
          {
            name: "闻喜县",
            code: "140823",
            areaCode: "0359",
          },
          {
            name: "稷山县",
            code: "140824",
            areaCode: "0359",
          },
          {
            name: "新绛县",
            code: "140825",
            areaCode: "0359",
          },
          {
            name: "绛县",
            code: "140826",
            areaCode: "0359",
          },
          {
            name: "垣曲县",
            code: "140827",
            areaCode: "0359",
          },
          {
            name: "夏县",
            code: "140828",
            areaCode: "0359",
          },
          {
            name: "平陆县",
            code: "140829",
            areaCode: "0359",
          },
          {
            name: "芮城县",
            code: "140830",
            areaCode: "0359",
          },
          {
            name: "永济市",
            code: "140881",
            areaCode: "0359",
          },
          {
            name: "河津市",
            code: "140882",
            areaCode: "0359",
          },
        ],
      },
      {
        name: "忻州市",
        code: "140900",
        areaCode: "0350",
        cities: [
          {
            name: "忻州市市辖区",
            code: "140901",
            areaCode: "0350",
          },
          {
            name: "忻府区",
            code: "140902",
            areaCode: "0350",
          },
          {
            name: "定襄县",
            code: "140921",
            areaCode: "0350",
          },
          {
            name: "五台县",
            code: "140922",
            areaCode: "0350",
          },
          {
            name: "代县",
            code: "140923",
            areaCode: "0350",
          },
          {
            name: "繁峙县",
            code: "140924",
            areaCode: "0350",
          },
          {
            name: "宁武县",
            code: "140925",
            areaCode: "0350",
          },
          {
            name: "静乐县",
            code: "140926",
            areaCode: "0350",
          },
          {
            name: "神池县",
            code: "140927",
            areaCode: "0350",
          },
          {
            name: "五寨县",
            code: "140928",
            areaCode: "0350",
          },
          {
            name: "岢岚县",
            code: "140929",
            areaCode: "0350",
          },
          {
            name: "河曲县",
            code: "140930",
            areaCode: "0350",
          },
          {
            name: "保德县",
            code: "140931",
            areaCode: "0350",
          },
          {
            name: "偏关县",
            code: "140932",
            areaCode: "0350",
          },
          {
            name: "原平市",
            code: "140981",
            areaCode: "0350",
          },
        ],
      },
      {
        name: "临汾市",
        code: "141000",
        areaCode: "0357",
        cities: [
          {
            name: "临汾市市辖区",
            code: "141001",
            areaCode: "0357",
          },
          {
            name: "尧都区",
            code: "141002",
            areaCode: "0357",
          },
          {
            name: "曲沃县",
            code: "141021",
            areaCode: "0357",
          },
          {
            name: "翼城县",
            code: "141022",
            areaCode: "0357",
          },
          {
            name: "襄汾县",
            code: "141023",
            areaCode: "0357",
          },
          {
            name: "洪洞县",
            code: "141024",
            areaCode: "0357",
          },
          {
            name: "古县",
            code: "141025",
            areaCode: "0357",
          },
          {
            name: "安泽县",
            code: "141026",
            areaCode: "0357",
          },
          {
            name: "浮山县",
            code: "141027",
            areaCode: "0357",
          },
          {
            name: "吉县",
            code: "141028",
            areaCode: "0357",
          },
          {
            name: "乡宁县",
            code: "141029",
            areaCode: "0357",
          },
          {
            name: "大宁县",
            code: "141030",
            areaCode: "0357",
          },
          {
            name: "隰县",
            code: "141031",
            areaCode: "0357",
          },
          {
            name: "永和县",
            code: "141032",
            areaCode: "0357",
          },
          {
            name: "蒲县",
            code: "141033",
            areaCode: "0357",
          },
          {
            name: "汾西县",
            code: "141034",
            areaCode: "0357",
          },
          {
            name: "侯马市",
            code: "141081",
            areaCode: "0357",
          },
          {
            name: "霍州市",
            code: "141082",
            areaCode: "0357",
          },
        ],
      },
      {
        name: "吕梁市",
        code: "141100",
        areaCode: "0358",
        cities: [
          {
            name: "吕梁市市辖区",
            code: "141101",
            areaCode: "0358",
          },
          {
            name: "离石区",
            code: "141102",
            areaCode: "0358",
          },
          {
            name: "文水县",
            code: "141121",
            areaCode: "0358",
          },
          {
            name: "交城县",
            code: "141122",
            areaCode: "0358",
          },
          {
            name: "兴县",
            code: "141123",
            areaCode: "0358",
          },
          {
            name: "临县",
            code: "141124",
            areaCode: "0358",
          },
          {
            name: "柳林县",
            code: "141125",
            areaCode: "0358",
          },
          {
            name: "石楼县",
            code: "141126",
            areaCode: "0358",
          },
          {
            name: "岚县",
            code: "141127",
            areaCode: "0358",
          },
          {
            name: "方山县",
            code: "141128",
            areaCode: "0358",
          },
          {
            name: "中阳县",
            code: "141129",
            areaCode: "0358",
          },
          {
            name: "交口县",
            code: "141130",
            areaCode: "0358",
          },
          {
            name: "孝义市",
            code: "141181",
            areaCode: "0358",
          },
          {
            name: "汾阳市",
            code: "141182",
            areaCode: "0358",
          },
        ],
      },
    ],
  },
  {
    name: "内蒙古自治区",
    code: "150000",
    areaCode: "",
    cities: [
      {
        name: "呼和浩特市",
        code: "150100",
        areaCode: "0471",
        cities: [
          {
            name: "呼和浩特市市辖区",
            code: "150101",
            areaCode: "0471",
          },
          {
            name: "新城区",
            code: "150102",
            areaCode: "0471",
          },
          {
            name: "回民区",
            code: "150103",
            areaCode: "0471",
          },
          {
            name: "玉泉区",
            code: "150104",
            areaCode: "0471",
          },
          {
            name: "赛罕区",
            code: "150105",
            areaCode: "0471",
          },
          {
            name: "土默特左旗",
            code: "150121",
            areaCode: "0471",
          },
          {
            name: "托克托县",
            code: "150122",
            areaCode: "0471",
          },
          {
            name: "和林格尔县",
            code: "150123",
            areaCode: "0471",
          },
          {
            name: "清水河县",
            code: "150124",
            areaCode: "0471",
          },
          {
            name: "武川县",
            code: "150125",
            areaCode: "0471",
          },
        ],
      },
      {
        name: "包头市",
        code: "150200",
        areaCode: "0472",
        cities: [
          {
            name: "包头市市辖区",
            code: "150201",
            areaCode: "0472",
          },
          {
            name: "东河区",
            code: "150202",
            areaCode: "0472",
          },
          {
            name: "昆都仑区",
            code: "150203",
            areaCode: "0472",
          },
          {
            name: "青山区",
            code: "150204",
            areaCode: "0472",
          },
          {
            name: "石拐区",
            code: "150205",
            areaCode: "0472",
          },
          {
            name: "白云鄂博矿区",
            code: "150206",
            areaCode: "0472",
          },
          {
            name: "九原区",
            code: "150207",
            areaCode: "0472",
          },
          {
            name: "土默特右旗",
            code: "150221",
            areaCode: "0472",
          },
          {
            name: "固阳县",
            code: "150222",
            areaCode: "0472",
          },
          {
            name: "达尔罕茂明安联合旗",
            code: "150223",
            areaCode: "0472",
          },
        ],
      },
      {
        name: "乌海市",
        code: "150300",
        areaCode: "0473",
        cities: [
          {
            name: "乌海市市辖区",
            code: "150301",
            areaCode: "0473",
          },
          {
            name: "海勃湾区",
            code: "150302",
            areaCode: "0473",
          },
          {
            name: "海南区",
            code: "150303",
            areaCode: "0473",
          },
          {
            name: "乌达区",
            code: "150304",
            areaCode: "0473",
          },
        ],
      },
      {
        name: "赤峰市",
        code: "150400",
        areaCode: "0476",
        cities: [
          {
            name: "赤峰市市辖区",
            code: "150401",
            areaCode: "0476",
          },
          {
            name: "红山区",
            code: "150402",
            areaCode: "0476",
          },
          {
            name: "元宝山区",
            code: "150403",
            areaCode: "0476",
          },
          {
            name: "松山区",
            code: "150404",
            areaCode: "0476",
          },
          {
            name: "阿鲁科尔沁旗",
            code: "150421",
            areaCode: "0476",
          },
          {
            name: "巴林左旗",
            code: "150422",
            areaCode: "0476",
          },
          {
            name: "巴林右旗",
            code: "150423",
            areaCode: "0476",
          },
          {
            name: "林西县",
            code: "150424",
            areaCode: "0476",
          },
          {
            name: "克什克腾旗",
            code: "150425",
            areaCode: "0476",
          },
          {
            name: "翁牛特旗",
            code: "150426",
            areaCode: "0476",
          },
          {
            name: "喀喇沁旗",
            code: "150428",
            areaCode: "0476",
          },
          {
            name: "宁城县",
            code: "150429",
            areaCode: "0476",
          },
          {
            name: "敖汉旗",
            code: "150430",
            areaCode: "0476",
          },
        ],
      },
      {
        name: "通辽市",
        code: "150500",
        areaCode: "0475",
        cities: [
          {
            name: "通辽市市辖区",
            code: "150501",
            areaCode: "0475",
          },
          {
            name: "科尔沁区",
            code: "150502",
            areaCode: "0475",
          },
          {
            name: "科尔沁左翼中旗",
            code: "150521",
            areaCode: "0475",
          },
          {
            name: "科尔沁左翼后旗",
            code: "150522",
            areaCode: "0475",
          },
          {
            name: "开鲁县",
            code: "150523",
            areaCode: "0475",
          },
          {
            name: "库伦旗",
            code: "150524",
            areaCode: "0475",
          },
          {
            name: "奈曼旗",
            code: "150525",
            areaCode: "0475",
          },
          {
            name: "扎鲁特旗",
            code: "150526",
            areaCode: "0475",
          },
          {
            name: "霍林郭勒市",
            code: "150581",
            areaCode: "0475",
          },
        ],
      },
      {
        name: "鄂尔多斯市",
        code: "150600",
        areaCode: "0477",
        cities: [
          {
            name: "鄂尔多斯市市辖区",
            code: "150601",
            areaCode: "0477",
          },
          {
            name: "东胜区",
            code: "150602",
            areaCode: "0477",
          },
          {
            name: "康巴什区",
            code: "150603",
            areaCode: "0477",
          },
          {
            name: "达拉特旗",
            code: "150621",
            areaCode: "0477",
          },
          {
            name: "准格尔旗",
            code: "150622",
            areaCode: "0477",
          },
          {
            name: "鄂托克前旗",
            code: "150623",
            areaCode: "0477",
          },
          {
            name: "鄂托克旗",
            code: "150624",
            areaCode: "0477",
          },
          {
            name: "杭锦旗",
            code: "150625",
            areaCode: "0477",
          },
          {
            name: "乌审旗",
            code: "150626",
            areaCode: "0477",
          },
          {
            name: "伊金霍洛旗",
            code: "150627",
            areaCode: "0477",
          },
        ],
      },
      {
        name: "呼伦贝尔市",
        code: "150700",
        areaCode: "0470",
        cities: [
          {
            name: "呼伦贝尔市市辖区",
            code: "150701",
            areaCode: "0470",
          },
          {
            name: "海拉尔区",
            code: "150702",
            areaCode: "0470",
          },
          {
            name: "扎赉诺尔区",
            code: "150703",
            areaCode: "0470",
          },
          {
            name: "阿荣旗",
            code: "150721",
            areaCode: "0470",
          },
          {
            name: "莫力达瓦达斡尔族自治旗",
            code: "150722",
            areaCode: "0470",
          },
          {
            name: "鄂伦春自治旗",
            code: "150723",
            areaCode: "0470",
          },
          {
            name: "鄂温克族自治旗",
            code: "150724",
            areaCode: "0470",
          },
          {
            name: "陈巴尔虎旗",
            code: "150725",
            areaCode: "0470",
          },
          {
            name: "新巴尔虎左旗",
            code: "150726",
            areaCode: "0470",
          },
          {
            name: "新巴尔虎右旗",
            code: "150727",
            areaCode: "0470",
          },
          {
            name: "满洲里市",
            code: "150781",
            areaCode: "0470",
          },
          {
            name: "牙克石市",
            code: "150782",
            areaCode: "0470",
          },
          {
            name: "扎兰屯市",
            code: "150783",
            areaCode: "0470",
          },
          {
            name: "额尔古纳市",
            code: "150784",
            areaCode: "0470",
          },
          {
            name: "根河市",
            code: "150785",
            areaCode: "0470",
          },
        ],
      },
      {
        name: "巴彦淖尔市",
        code: "150800",
        areaCode: "0478",
        cities: [
          {
            name: "巴彦淖尔市市辖区",
            code: "150801",
            areaCode: "0478",
          },
          {
            name: "临河区",
            code: "150802",
            areaCode: "0478",
          },
          {
            name: "五原县",
            code: "150821",
            areaCode: "0478",
          },
          {
            name: "磴口县",
            code: "150822",
            areaCode: "0478",
          },
          {
            name: "乌拉特前旗",
            code: "150823",
            areaCode: "0478",
          },
          {
            name: "乌拉特中旗",
            code: "150824",
            areaCode: "0478",
          },
          {
            name: "乌拉特后旗",
            code: "150825",
            areaCode: "0478",
          },
          {
            name: "杭锦后旗",
            code: "150826",
            areaCode: "0478",
          },
        ],
      },
      {
        name: "乌兰察布市",
        code: "150900",
        areaCode: "0474",
        cities: [
          {
            name: "乌兰察布市市辖区",
            code: "150901",
            areaCode: "0474",
          },
          {
            name: "集宁区",
            code: "150902",
            areaCode: "0474",
          },
          {
            name: "卓资县",
            code: "150921",
            areaCode: "0474",
          },
          {
            name: "化德县",
            code: "150922",
            areaCode: "0474",
          },
          {
            name: "商都县",
            code: "150923",
            areaCode: "0474",
          },
          {
            name: "兴和县",
            code: "150924",
            areaCode: "0474",
          },
          {
            name: "凉城县",
            code: "150925",
            areaCode: "0474",
          },
          {
            name: "察哈尔右翼前旗",
            code: "150926",
            areaCode: "0474",
          },
          {
            name: "察哈尔右翼中旗",
            code: "150927",
            areaCode: "0474",
          },
          {
            name: "察哈尔右翼后旗",
            code: "150928",
            areaCode: "0474",
          },
          {
            name: "四子王旗",
            code: "150929",
            areaCode: "0474",
          },
          {
            name: "丰镇市",
            code: "150981",
            areaCode: "0474",
          },
        ],
      },
      {
        name: "兴安盟",
        code: "152200",
        areaCode: "0482",
        cities: [
          {
            name: "乌兰浩特市",
            code: "152201",
            areaCode: "0482",
          },
          {
            name: "阿尔山市",
            code: "152202",
            areaCode: "0482",
          },
          {
            name: "科尔沁右翼前旗",
            code: "152221",
            areaCode: "0482",
          },
          {
            name: "科尔沁右翼中旗",
            code: "152222",
            areaCode: "0482",
          },
          {
            name: "扎赉特旗",
            code: "152223",
            areaCode: "0482",
          },
          {
            name: "突泉县",
            code: "152224",
            areaCode: "0482",
          },
        ],
      },
      {
        name: "锡林郭勒盟",
        code: "152500",
        areaCode: "0479",
        cities: [
          {
            name: "二连浩特市",
            code: "152501",
            areaCode: "0479",
          },
          {
            name: "锡林浩特市",
            code: "152502",
            areaCode: "0479",
          },
          {
            name: "阿巴嘎旗",
            code: "152522",
            areaCode: "0479",
          },
          {
            name: "苏尼特左旗",
            code: "152523",
            areaCode: "0479",
          },
          {
            name: "苏尼特右旗",
            code: "152524",
            areaCode: "0479",
          },
          {
            name: "东乌珠穆沁旗",
            code: "152525",
            areaCode: "0479",
          },
          {
            name: "西乌珠穆沁旗",
            code: "152526",
            areaCode: "0479",
          },
          {
            name: "太仆寺旗",
            code: "152527",
            areaCode: "0479",
          },
          {
            name: "镶黄旗",
            code: "152528",
            areaCode: "0479",
          },
          {
            name: "正镶白旗",
            code: "152529",
            areaCode: "0479",
          },
          {
            name: "正蓝旗",
            code: "152530",
            areaCode: "0479",
          },
          {
            name: "多伦县",
            code: "152531",
            areaCode: "0479",
          },
        ],
      },
      {
        name: "阿拉善盟",
        code: "152900",
        areaCode: "0483",
        cities: [
          {
            name: "阿拉善左旗",
            code: "152921",
            areaCode: "0483",
          },
          {
            name: "阿拉善右旗",
            code: "152922",
            areaCode: "0483",
          },
          {
            name: "额济纳旗",
            code: "152923",
            areaCode: "0483",
          },
        ],
      },
    ],
  },
  {
    name: "辽宁省",
    code: "210000",
    areaCode: "",
    cities: [
      {
        name: "沈阳市",
        code: "210100",
        areaCode: "024",
        cities: [
          {
            name: "沈阳市市辖区",
            code: "210101",
            areaCode: "024",
          },
          {
            name: "和平区",
            code: "210102",
            areaCode: "024",
          },
          {
            name: "沈河区",
            code: "210103",
            areaCode: "024",
          },
          {
            name: "大东区",
            code: "210104",
            areaCode: "024",
          },
          {
            name: "皇姑区",
            code: "210105",
            areaCode: "024",
          },
          {
            name: "铁西区",
            code: "210106",
            areaCode: "024",
          },
          {
            name: "苏家屯区",
            code: "210111",
            areaCode: "024",
          },
          {
            name: "浑南区",
            code: "210112",
            areaCode: "024",
          },
          {
            name: "沈北新区",
            code: "210113",
            areaCode: "024",
          },
          {
            name: "于洪区",
            code: "210114",
            areaCode: "024",
          },
          {
            name: "辽中区",
            code: "210115",
            areaCode: "024",
          },
          {
            name: "康平县",
            code: "210123",
            areaCode: "024",
          },
          {
            name: "法库县",
            code: "210124",
            areaCode: "024",
          },
          {
            name: "新民市",
            code: "210181",
            areaCode: "024",
          },
        ],
      },
      {
        name: "大连市",
        code: "210200",
        areaCode: "0411",
        cities: [
          {
            name: "大连市市辖区",
            code: "210201",
            areaCode: "0411",
          },
          {
            name: "中山区",
            code: "210202",
            areaCode: "0411",
          },
          {
            name: "西岗区",
            code: "210203",
            areaCode: "0411",
          },
          {
            name: "沙河口区",
            code: "210204",
            areaCode: "0411",
          },
          {
            name: "甘井子区",
            code: "210211",
            areaCode: "0411",
          },
          {
            name: "旅顺口区",
            code: "210212",
            areaCode: "0411",
          },
          {
            name: "金州区",
            code: "210213",
            areaCode: "0411",
          },
          {
            name: "普兰店区",
            code: "210214",
            areaCode: "0411",
          },
          {
            name: "长海县",
            code: "210224",
            areaCode: "0411",
          },
          {
            name: "瓦房店市",
            code: "210281",
            areaCode: "0411",
          },
          {
            name: "庄河市",
            code: "210283",
            areaCode: "0411",
          },
        ],
      },
      {
        name: "鞍山市",
        code: "210300",
        areaCode: "0412",
        cities: [
          {
            name: "鞍山市市辖区",
            code: "210301",
            areaCode: "0412",
          },
          {
            name: "铁东区",
            code: "210302",
            areaCode: "0412",
          },
          {
            name: "铁西区",
            code: "210303",
            areaCode: "0412",
          },
          {
            name: "立山区",
            code: "210304",
            areaCode: "0412",
          },
          {
            name: "千山区",
            code: "210311",
            areaCode: "0412",
          },
          {
            name: "台安县",
            code: "210321",
            areaCode: "0412",
          },
          {
            name: "岫岩满族自治县",
            code: "210323",
            areaCode: "0412",
          },
          {
            name: "海城市",
            code: "210381",
            areaCode: "0412",
          },
        ],
      },
      {
        name: "抚顺市",
        code: "210400",
        areaCode: "0413",
        cities: [
          {
            name: "抚顺市市辖区",
            code: "210401",
            areaCode: "0413",
          },
          {
            name: "新抚区",
            code: "210402",
            areaCode: "0413",
          },
          {
            name: "东洲区",
            code: "210403",
            areaCode: "0413",
          },
          {
            name: "望花区",
            code: "210404",
            areaCode: "0413",
          },
          {
            name: "顺城区",
            code: "210411",
            areaCode: "0413",
          },
          {
            name: "抚顺县",
            code: "210421",
            areaCode: "0413",
          },
          {
            name: "新宾满族自治县",
            code: "210422",
            areaCode: "0413",
          },
          {
            name: "清原满族自治县",
            code: "210423",
            areaCode: "0413",
          },
        ],
      },
      {
        name: "本溪市",
        code: "210500",
        areaCode: "0414",
        cities: [
          {
            name: "本溪市市辖区",
            code: "210501",
            areaCode: "0414",
          },
          {
            name: "平山区",
            code: "210502",
            areaCode: "0414",
          },
          {
            name: "溪湖区",
            code: "210503",
            areaCode: "0414",
          },
          {
            name: "明山区",
            code: "210504",
            areaCode: "0414",
          },
          {
            name: "南芬区",
            code: "210505",
            areaCode: "0414",
          },
          {
            name: "本溪满族自治县",
            code: "210521",
            areaCode: "0414",
          },
          {
            name: "桓仁满族自治县",
            code: "210522",
            areaCode: "0414",
          },
        ],
      },
      {
        name: "丹东市",
        code: "210600",
        areaCode: "0415",
        cities: [
          {
            name: "丹东市市辖区",
            code: "210601",
            areaCode: "0415",
          },
          {
            name: "元宝区",
            code: "210602",
            areaCode: "0415",
          },
          {
            name: "振兴区",
            code: "210603",
            areaCode: "0415",
          },
          {
            name: "振安区",
            code: "210604",
            areaCode: "0415",
          },
          {
            name: "宽甸满族自治县",
            code: "210624",
            areaCode: "0415",
          },
          {
            name: "东港市",
            code: "210681",
            areaCode: "0415",
          },
          {
            name: "凤城市",
            code: "210682",
            areaCode: "0415",
          },
        ],
      },
      {
        name: "锦州市",
        code: "210700",
        areaCode: "0416",
        cities: [
          {
            name: "锦州市市辖区",
            code: "210701",
            areaCode: "0416",
          },
          {
            name: "古塔区",
            code: "210702",
            areaCode: "0416",
          },
          {
            name: "凌河区",
            code: "210703",
            areaCode: "0416",
          },
          {
            name: "太和区",
            code: "210711",
            areaCode: "0416",
          },
          {
            name: "黑山县",
            code: "210726",
            areaCode: "0416",
          },
          {
            name: "义县",
            code: "210727",
            areaCode: "0416",
          },
          {
            name: "凌海市",
            code: "210781",
            areaCode: "0416",
          },
          {
            name: "北镇市",
            code: "210782",
            areaCode: "0416",
          },
        ],
      },
      {
        name: "营口市",
        code: "210800",
        areaCode: "0417",
        cities: [
          {
            name: "营口市市辖区",
            code: "210801",
            areaCode: "0417",
          },
          {
            name: "站前区",
            code: "210802",
            areaCode: "0417",
          },
          {
            name: "西市区",
            code: "210803",
            areaCode: "0417",
          },
          {
            name: "鲅鱼圈区",
            code: "210804",
            areaCode: "0417",
          },
          {
            name: "老边区",
            code: "210811",
            areaCode: "0417",
          },
          {
            name: "盖州市",
            code: "210881",
            areaCode: "0417",
          },
          {
            name: "大石桥市",
            code: "210882",
            areaCode: "0417",
          },
        ],
      },
      {
        name: "阜新市",
        code: "210900",
        areaCode: "0418",
        cities: [
          {
            name: "阜新市市辖区",
            code: "210901",
            areaCode: "0418",
          },
          {
            name: "海州区",
            code: "210902",
            areaCode: "0418",
          },
          {
            name: "新邱区",
            code: "210903",
            areaCode: "0418",
          },
          {
            name: "太平区",
            code: "210904",
            areaCode: "0418",
          },
          {
            name: "清河门区",
            code: "210905",
            areaCode: "0418",
          },
          {
            name: "细河区",
            code: "210911",
            areaCode: "0418",
          },
          {
            name: "阜新蒙古族自治县",
            code: "210921",
            areaCode: "0418",
          },
          {
            name: "彰武县",
            code: "210922",
            areaCode: "0418",
          },
        ],
      },
      {
        name: "辽阳市",
        code: "211000",
        areaCode: "0419",
        cities: [
          {
            name: "辽阳市市辖区",
            code: "211001",
            areaCode: "0419",
          },
          {
            name: "白塔区",
            code: "211002",
            areaCode: "0419",
          },
          {
            name: "文圣区",
            code: "211003",
            areaCode: "0419",
          },
          {
            name: "宏伟区",
            code: "211004",
            areaCode: "0419",
          },
          {
            name: "弓长岭区",
            code: "211005",
            areaCode: "0419",
          },
          {
            name: "太子河区",
            code: "211011",
            areaCode: "0419",
          },
          {
            name: "辽阳县",
            code: "211021",
            areaCode: "0419",
          },
          {
            name: "灯塔市",
            code: "211081",
            areaCode: "0419",
          },
        ],
      },
      {
        name: "盘锦市",
        code: "211100",
        areaCode: "0427",
        cities: [
          {
            name: "盘锦市市辖区",
            code: "211101",
            areaCode: "0427",
          },
          {
            name: "双台子区",
            code: "211102",
            areaCode: "0427",
          },
          {
            name: "兴隆台区",
            code: "211103",
            areaCode: "0427",
          },
          {
            name: "大洼区",
            code: "211104",
            areaCode: "0427",
          },
          {
            name: "盘山县",
            code: "211122",
            areaCode: "0427",
          },
        ],
      },
      {
        name: "铁岭市",
        code: "211200",
        areaCode: "0410",
        cities: [
          {
            name: "铁岭市市辖区",
            code: "211201",
            areaCode: "0410",
          },
          {
            name: "银州区",
            code: "211202",
            areaCode: "0410",
          },
          {
            name: "清河区",
            code: "211204",
            areaCode: "0410",
          },
          {
            name: "铁岭县",
            code: "211221",
            areaCode: "0410",
          },
          {
            name: "西丰县",
            code: "211223",
            areaCode: "0410",
          },
          {
            name: "昌图县",
            code: "211224",
            areaCode: "0410",
          },
          {
            name: "调兵山市",
            code: "211281",
            areaCode: "0410",
          },
          {
            name: "开原市",
            code: "211282",
            areaCode: "0410",
          },
        ],
      },
      {
        name: "朝阳市",
        code: "211300",
        areaCode: "0421",
        cities: [
          {
            name: "朝阳市市辖区",
            code: "211301",
            areaCode: "0421",
          },
          {
            name: "双塔区",
            code: "211302",
            areaCode: "0421",
          },
          {
            name: "龙城区",
            code: "211303",
            areaCode: "0421",
          },
          {
            name: "朝阳县",
            code: "211321",
            areaCode: "0421",
          },
          {
            name: "建平县",
            code: "211322",
            areaCode: "0421",
          },
          {
            name: "喀喇沁左翼蒙古族自治县",
            code: "211324",
            areaCode: "0421",
          },
          {
            name: "北票市",
            code: "211381",
            areaCode: "0421",
          },
          {
            name: "凌源市",
            code: "211382",
            areaCode: "0421",
          },
        ],
      },
      {
        name: "葫芦岛市",
        code: "211400",
        areaCode: "0429",
        cities: [
          {
            name: "葫芦岛市市辖区",
            code: "211401",
            areaCode: "0429",
          },
          {
            name: "连山区",
            code: "211402",
            areaCode: "0429",
          },
          {
            name: "龙港区",
            code: "211403",
            areaCode: "0429",
          },
          {
            name: "南票区",
            code: "211404",
            areaCode: "0429",
          },
          {
            name: "绥中县",
            code: "211421",
            areaCode: "0429",
          },
          {
            name: "建昌县",
            code: "211422",
            areaCode: "0429",
          },
          {
            name: "兴城市",
            code: "211481",
            areaCode: "0429",
          },
        ],
      },
    ],
  },
  {
    name: "吉林省",
    code: "220000",
    areaCode: "",
    cities: [
      {
        name: "长春市",
        code: "220100",
        areaCode: "0431",
        cities: [
          {
            name: "长春市市辖区",
            code: "220101",
            areaCode: "0431",
          },
          {
            name: "南关区",
            code: "220102",
            areaCode: "0431",
          },
          {
            name: "宽城区",
            code: "220103",
            areaCode: "0431",
          },
          {
            name: "朝阳区",
            code: "220104",
            areaCode: "0431",
          },
          {
            name: "二道区",
            code: "220105",
            areaCode: "0431",
          },
          {
            name: "绿园区",
            code: "220106",
            areaCode: "0431",
          },
          {
            name: "双阳区",
            code: "220112",
            areaCode: "0431",
          },
          {
            name: "九台区",
            code: "220113",
            areaCode: "0431",
          },
          {
            name: "农安县",
            code: "220122",
            areaCode: "0431",
          },
          {
            name: "榆树市",
            code: "220182",
            areaCode: "0431",
          },
          {
            name: "德惠市",
            code: "220183",
            areaCode: "0431",
          },
          {
            name: "公主岭市",
            code: "220184",
            areaCode: "0434",
          },
        ],
      },
      {
        name: "吉林市",
        code: "220200",
        areaCode: "0432",
        cities: [
          {
            name: "吉林市市辖区",
            code: "220201",
            areaCode: "0432",
          },
          {
            name: "昌邑区",
            code: "220202",
            areaCode: "0432",
          },
          {
            name: "龙潭区",
            code: "220203",
            areaCode: "0432",
          },
          {
            name: "船营区",
            code: "220204",
            areaCode: "0432",
          },
          {
            name: "丰满区",
            code: "220211",
            areaCode: "0432",
          },
          {
            name: "永吉县",
            code: "220221",
            areaCode: "0432",
          },
          {
            name: "蛟河市",
            code: "220281",
            areaCode: "0432",
          },
          {
            name: "桦甸市",
            code: "220282",
            areaCode: "0432",
          },
          {
            name: "舒兰市",
            code: "220283",
            areaCode: "0432",
          },
          {
            name: "磐石市",
            code: "220284",
            areaCode: "0432",
          },
        ],
      },
      {
        name: "四平市",
        code: "220300",
        areaCode: "0434",
        cities: [
          {
            name: "四平市市辖区",
            code: "220301",
            areaCode: "0434",
          },
          {
            name: "铁西区",
            code: "220302",
            areaCode: "0434",
          },
          {
            name: "铁东区",
            code: "220303",
            areaCode: "0434",
          },
          {
            name: "梨树县",
            code: "220322",
            areaCode: "0434",
          },
          {
            name: "伊通满族自治县",
            code: "220323",
            areaCode: "0434",
          },
          {
            name: "双辽市",
            code: "220382",
            areaCode: "0434",
          },
        ],
      },
      {
        name: "辽源市",
        code: "220400",
        areaCode: "0437",
        cities: [
          {
            name: "辽源市市辖区",
            code: "220401",
            areaCode: "0437",
          },
          {
            name: "龙山区",
            code: "220402",
            areaCode: "0437",
          },
          {
            name: "西安区",
            code: "220403",
            areaCode: "0437",
          },
          {
            name: "东丰县",
            code: "220421",
            areaCode: "0437",
          },
          {
            name: "东辽县",
            code: "220422",
            areaCode: "0437",
          },
        ],
      },
      {
        name: "通化市",
        code: "220500",
        areaCode: "0435",
        cities: [
          {
            name: "通化市市辖区",
            code: "220501",
            areaCode: "0435",
          },
          {
            name: "东昌区",
            code: "220502",
            areaCode: "0435",
          },
          {
            name: "二道江区",
            code: "220503",
            areaCode: "0435",
          },
          {
            name: "通化县",
            code: "220521",
            areaCode: "0435",
          },
          {
            name: "辉南县",
            code: "220523",
            areaCode: "0435",
          },
          {
            name: "柳河县",
            code: "220524",
            areaCode: "0435",
          },
          {
            name: "梅河口市",
            code: "220581",
            areaCode: "0435",
          },
          {
            name: "集安市",
            code: "220582",
            areaCode: "0435",
          },
        ],
      },
      {
        name: "白山市",
        code: "220600",
        areaCode: "0439",
        cities: [
          {
            name: "白山市市辖区",
            code: "220601",
            areaCode: "0439",
          },
          {
            name: "浑江区",
            code: "220602",
            areaCode: "0439",
          },
          {
            name: "江源区",
            code: "220605",
            areaCode: "0439",
          },
          {
            name: "抚松县",
            code: "220621",
            areaCode: "0439",
          },
          {
            name: "靖宇县",
            code: "220622",
            areaCode: "0439",
          },
          {
            name: "长白朝鲜族自治县",
            code: "220623",
            areaCode: "0439",
          },
          {
            name: "临江市",
            code: "220681",
            areaCode: "0439",
          },
        ],
      },
      {
        name: "松原市",
        code: "220700",
        areaCode: "0438",
        cities: [
          {
            name: "松原市市辖区",
            code: "220701",
            areaCode: "0438",
          },
          {
            name: "宁江区",
            code: "220702",
            areaCode: "0438",
          },
          {
            name: "前郭尔罗斯蒙古族自治县",
            code: "220721",
            areaCode: "0438",
          },
          {
            name: "长岭县",
            code: "220722",
            areaCode: "0438",
          },
          {
            name: "乾安县",
            code: "220723",
            areaCode: "0438",
          },
          {
            name: "扶余市",
            code: "220781",
            areaCode: "0438",
          },
        ],
      },
      {
        name: "白城市",
        code: "220800",
        areaCode: "0436",
        cities: [
          {
            name: "白城市市辖区",
            code: "220801",
            areaCode: "0436",
          },
          {
            name: "洮北区",
            code: "220802",
            areaCode: "0436",
          },
          {
            name: "镇赉县",
            code: "220821",
            areaCode: "0436",
          },
          {
            name: "通榆县",
            code: "220822",
            areaCode: "0436",
          },
          {
            name: "洮南市",
            code: "220881",
            areaCode: "0436",
          },
          {
            name: "大安市",
            code: "220882",
            areaCode: "0436",
          },
        ],
      },
      {
        name: "延边朝鲜族自治州",
        code: "222400",
        areaCode: "1433",
        cities: [
          {
            name: "延吉市",
            code: "222401",
            areaCode: "1433",
          },
          {
            name: "图们市",
            code: "222402",
            areaCode: "1433",
          },
          {
            name: "敦化市",
            code: "222403",
            areaCode: "1433",
          },
          {
            name: "珲春市",
            code: "222404",
            areaCode: "1433",
          },
          {
            name: "龙井市",
            code: "222405",
            areaCode: "1433",
          },
          {
            name: "和龙市",
            code: "222406",
            areaCode: "1433",
          },
          {
            name: "汪清县",
            code: "222424",
            areaCode: "1433",
          },
          {
            name: "安图县",
            code: "222426",
            areaCode: "1433",
          },
        ],
      },
    ],
  },
  {
    name: "黑龙江省",
    code: "230000",
    areaCode: "",
    cities: [
      {
        name: "哈尔滨市",
        code: "230100",
        areaCode: "0451",
        cities: [
          {
            name: "哈尔滨市市辖区",
            code: "230101",
            areaCode: "0451",
          },
          {
            name: "道里区",
            code: "230102",
            areaCode: "0451",
          },
          {
            name: "南岗区",
            code: "230103",
            areaCode: "0451",
          },
          {
            name: "道外区",
            code: "230104",
            areaCode: "0451",
          },
          {
            name: "平房区",
            code: "230108",
            areaCode: "0451",
          },
          {
            name: "松北区",
            code: "230109",
            areaCode: "0451",
          },
          {
            name: "香坊区",
            code: "230110",
            areaCode: "0451",
          },
          {
            name: "呼兰区",
            code: "230111",
            areaCode: "0451",
          },
          {
            name: "阿城区",
            code: "230112",
            areaCode: "0451",
          },
          {
            name: "双城区",
            code: "230113",
            areaCode: "0451",
          },
          {
            name: "依兰县",
            code: "230123",
            areaCode: "0451",
          },
          {
            name: "方正县",
            code: "230124",
            areaCode: "0451",
          },
          {
            name: "宾县",
            code: "230125",
            areaCode: "0451",
          },
          {
            name: "巴彦县",
            code: "230126",
            areaCode: "0451",
          },
          {
            name: "木兰县",
            code: "230127",
            areaCode: "0451",
          },
          {
            name: "通河县",
            code: "230128",
            areaCode: "0451",
          },
          {
            name: "延寿县",
            code: "230129",
            areaCode: "0451",
          },
          {
            name: "尚志市",
            code: "230183",
            areaCode: "0451",
          },
          {
            name: "五常市",
            code: "230184",
            areaCode: "0451",
          },
        ],
      },
      {
        name: "齐齐哈尔市",
        code: "230200",
        areaCode: "0452",
        cities: [
          {
            name: "齐齐哈尔市市辖区",
            code: "230201",
            areaCode: "0452",
          },
          {
            name: "龙沙区",
            code: "230202",
            areaCode: "0452",
          },
          {
            name: "建华区",
            code: "230203",
            areaCode: "0452",
          },
          {
            name: "铁锋区",
            code: "230204",
            areaCode: "0452",
          },
          {
            name: "昂昂溪区",
            code: "230205",
            areaCode: "0452",
          },
          {
            name: "富拉尔基区",
            code: "230206",
            areaCode: "0452",
          },
          {
            name: "碾子山区",
            code: "230207",
            areaCode: "0452",
          },
          {
            name: "梅里斯达斡尔族区",
            code: "230208",
            areaCode: "0452",
          },
          {
            name: "龙江县",
            code: "230221",
            areaCode: "0452",
          },
          {
            name: "依安县",
            code: "230223",
            areaCode: "0452",
          },
          {
            name: "泰来县",
            code: "230224",
            areaCode: "0452",
          },
          {
            name: "甘南县",
            code: "230225",
            areaCode: "0452",
          },
          {
            name: "富裕县",
            code: "230227",
            areaCode: "0452",
          },
          {
            name: "克山县",
            code: "230229",
            areaCode: "0452",
          },
          {
            name: "克东县",
            code: "230230",
            areaCode: "0452",
          },
          {
            name: "拜泉县",
            code: "230231",
            areaCode: "0452",
          },
          {
            name: "讷河市",
            code: "230281",
            areaCode: "0452",
          },
        ],
      },
      {
        name: "鸡西市",
        code: "230300",
        areaCode: "0467",
        cities: [
          {
            name: "鸡西市市辖区",
            code: "230301",
            areaCode: "0467",
          },
          {
            name: "鸡冠区",
            code: "230302",
            areaCode: "0467",
          },
          {
            name: "恒山区",
            code: "230303",
            areaCode: "0467",
          },
          {
            name: "滴道区",
            code: "230304",
            areaCode: "0467",
          },
          {
            name: "梨树区",
            code: "230305",
            areaCode: "0467",
          },
          {
            name: "城子河区",
            code: "230306",
            areaCode: "0467",
          },
          {
            name: "麻山区",
            code: "230307",
            areaCode: "0467",
          },
          {
            name: "鸡东县",
            code: "230321",
            areaCode: "0467",
          },
          {
            name: "虎林市",
            code: "230381",
            areaCode: "0467",
          },
          {
            name: "密山市",
            code: "230382",
            areaCode: "0467",
          },
        ],
      },
      {
        name: "鹤岗市",
        code: "230400",
        areaCode: "0468",
        cities: [
          {
            name: "鹤岗市市辖区",
            code: "230401",
            areaCode: "0468",
          },
          {
            name: "向阳区",
            code: "230402",
            areaCode: "0468",
          },
          {
            name: "工农区",
            code: "230403",
            areaCode: "0468",
          },
          {
            name: "南山区",
            code: "230404",
            areaCode: "0468",
          },
          {
            name: "兴安区",
            code: "230405",
            areaCode: "0468",
          },
          {
            name: "东山区",
            code: "230406",
            areaCode: "0468",
          },
          {
            name: "兴山区",
            code: "230407",
            areaCode: "0468",
          },
          {
            name: "萝北县",
            code: "230421",
            areaCode: "0468",
          },
          {
            name: "绥滨县",
            code: "230422",
            areaCode: "0468",
          },
        ],
      },
      {
        name: "双鸭山市",
        code: "230500",
        areaCode: "0469",
        cities: [
          {
            name: "双鸭山市市辖区",
            code: "230501",
            areaCode: "0469",
          },
          {
            name: "尖山区",
            code: "230502",
            areaCode: "0469",
          },
          {
            name: "岭东区",
            code: "230503",
            areaCode: "0469",
          },
          {
            name: "四方台区",
            code: "230505",
            areaCode: "0469",
          },
          {
            name: "宝山区",
            code: "230506",
            areaCode: "0469",
          },
          {
            name: "集贤县",
            code: "230521",
            areaCode: "0469",
          },
          {
            name: "友谊县",
            code: "230522",
            areaCode: "0469",
          },
          {
            name: "宝清县",
            code: "230523",
            areaCode: "0469",
          },
          {
            name: "饶河县",
            code: "230524",
            areaCode: "0469",
          },
        ],
      },
      {
        name: "大庆市",
        code: "230600",
        areaCode: "0459",
        cities: [
          {
            name: "大庆市市辖区",
            code: "230601",
            areaCode: "0459",
          },
          {
            name: "萨尔图区",
            code: "230602",
            areaCode: "0459",
          },
          {
            name: "龙凤区",
            code: "230603",
            areaCode: "0459",
          },
          {
            name: "让胡路区",
            code: "230604",
            areaCode: "0459",
          },
          {
            name: "红岗区",
            code: "230605",
            areaCode: "0459",
          },
          {
            name: "大同区",
            code: "230606",
            areaCode: "0459",
          },
          {
            name: "肇州县",
            code: "230621",
            areaCode: "0459",
          },
          {
            name: "肇源县",
            code: "230622",
            areaCode: "0459",
          },
          {
            name: "林甸县",
            code: "230623",
            areaCode: "0459",
          },
          {
            name: "杜尔伯特蒙古族自治县",
            code: "230624",
            areaCode: "0459",
          },
        ],
      },
      {
        name: "伊春市",
        code: "230700",
        areaCode: "0458",
        cities: [
          {
            name: "伊春市市辖区",
            code: "230701",
            areaCode: "0458",
          },
          {
            name: "汤旺河区",
            code: "230712",
            areaCode: "0458",
          },
          {
            name: "伊美区",
            code: "230717",
            areaCode: "0458",
          },
          {
            name: "乌翠区",
            code: "230718",
            areaCode: "0458",
          },
          {
            name: "友好区",
            code: "230719",
            areaCode: "0458",
          },
          {
            name: "嘉荫县",
            code: "230722",
            areaCode: "0458",
          },
          {
            name: "汤旺县",
            code: "230723",
            areaCode: "0458",
          },
          {
            name: "丰林县",
            code: "230724",
            areaCode: "0458",
          },
          {
            name: "大箐山县",
            code: "230725",
            areaCode: "0458",
          },
          {
            name: "南岔县",
            code: "230726",
            areaCode: "0458",
          },
          {
            name: "金林区",
            code: "230751",
            areaCode: "0458",
          },
          {
            name: "铁力市",
            code: "230781",
            areaCode: "0458",
          },
        ],
      },
      {
        name: "佳木斯市",
        code: "230800",
        areaCode: "0454",
        cities: [
          {
            name: "佳木斯市市辖区",
            code: "230801",
            areaCode: "0454",
          },
          {
            name: "向阳区",
            code: "230803",
            areaCode: "0454",
          },
          {
            name: "前进区",
            code: "230804",
            areaCode: "0454",
          },
          {
            name: "东风区",
            code: "230805",
            areaCode: "0454",
          },
          {
            name: "郊区",
            code: "230811",
            areaCode: "0454",
          },
          {
            name: "桦南县",
            code: "230822",
            areaCode: "0454",
          },
          {
            name: "桦川县",
            code: "230826",
            areaCode: "0454",
          },
          {
            name: "汤原县",
            code: "230828",
            areaCode: "0454",
          },
          {
            name: "同江市",
            code: "230881",
            areaCode: "0454",
          },
          {
            name: "富锦市",
            code: "230882",
            areaCode: "0454",
          },
          {
            name: "抚远市",
            code: "230883",
            areaCode: "0454",
          },
        ],
      },
      {
        name: "七台河市",
        code: "230900",
        areaCode: "0464",
        cities: [
          {
            name: "七台河市市辖区",
            code: "230901",
            areaCode: "0464",
          },
          {
            name: "新兴区",
            code: "230902",
            areaCode: "0464",
          },
          {
            name: "桃山区",
            code: "230903",
            areaCode: "0464",
          },
          {
            name: "茄子河区",
            code: "230904",
            areaCode: "0464",
          },
          {
            name: "勃利县",
            code: "230921",
            areaCode: "0464",
          },
        ],
      },
      {
        name: "牡丹江市",
        code: "231000",
        areaCode: "0453",
        cities: [
          {
            name: "牡丹江市市辖区",
            code: "231001",
            areaCode: "0453",
          },
          {
            name: "东安区",
            code: "231002",
            areaCode: "0453",
          },
          {
            name: "阳明区",
            code: "231003",
            areaCode: "0453",
          },
          {
            name: "爱民区",
            code: "231004",
            areaCode: "0453",
          },
          {
            name: "西安区",
            code: "231005",
            areaCode: "0453",
          },
          {
            name: "林口县",
            code: "231025",
            areaCode: "0453",
          },
          {
            name: "绥芬河市",
            code: "231081",
            areaCode: "0453",
          },
          {
            name: "海林市",
            code: "231083",
            areaCode: "0453",
          },
          {
            name: "宁安市",
            code: "231084",
            areaCode: "0453",
          },
          {
            name: "穆棱市",
            code: "231085",
            areaCode: "0453",
          },
          {
            name: "东宁市",
            code: "231086",
            areaCode: "0453",
          },
        ],
      },
      {
        name: "黑河市",
        code: "231100",
        areaCode: "0456",
        cities: [
          {
            name: "黑河市市辖区",
            code: "231101",
            areaCode: "0456",
          },
          {
            name: "爱辉区",
            code: "231102",
            areaCode: "0456",
          },
          {
            name: "嫩江市",
            code: "231183",
            areaCode: "0456",
          },
          {
            name: "逊克县",
            code: "231123",
            areaCode: "0456",
          },
          {
            name: "孙吴县",
            code: "231124",
            areaCode: "0456",
          },
          {
            name: "北安市",
            code: "231181",
            areaCode: "0456",
          },
          {
            name: "五大连池市",
            code: "231182",
            areaCode: "0456",
          },
        ],
      },
      {
        name: "绥化市",
        code: "231200",
        areaCode: "0455",
        cities: [
          {
            name: "绥化市市辖区",
            code: "231201",
            areaCode: "0455",
          },
          {
            name: "北林区",
            code: "231202",
            areaCode: "0455",
          },
          {
            name: "望奎县",
            code: "231221",
            areaCode: "0455",
          },
          {
            name: "兰西县",
            code: "231222",
            areaCode: "0455",
          },
          {
            name: "青冈县",
            code: "231223",
            areaCode: "0455",
          },
          {
            name: "庆安县",
            code: "231224",
            areaCode: "0455",
          },
          {
            name: "明水县",
            code: "231225",
            areaCode: "0455",
          },
          {
            name: "绥棱县",
            code: "231226",
            areaCode: "0455",
          },
          {
            name: "安达市",
            code: "231281",
            areaCode: "0455",
          },
          {
            name: "肇东市",
            code: "231282",
            areaCode: "0455",
          },
          {
            name: "海伦市",
            code: "231283",
            areaCode: "0455",
          },
        ],
      },
      {
        name: "大兴安岭地区",
        code: "232700",
        areaCode: "0457",
        cities: [
          {
            name: "加格达奇区",
            code: "232718",
            areaCode: "0457",
          },
          {
            name: "呼玛县",
            code: "232721",
            areaCode: "0457",
          },
          {
            name: "塔河县",
            code: "232722",
            areaCode: "0457",
          },
          {
            name: "漠河市",
            code: "232701",
            areaCode: "0457",
          },
        ],
      },
    ],
  },
  {
    name: "上海市",
    code: "310000",
    areaCode: "021",
    cities: [
      {
        name: "上海市市辖区",
        code: "310100",
        areaCode: "021",
        cities: [
          {
            name: "黄浦区",
            code: "310101",
            areaCode: "021",
          },
          {
            name: "徐汇区",
            code: "310104",
            areaCode: "021",
          },
          {
            name: "长宁区",
            code: "310105",
            areaCode: "021",
          },
          {
            name: "静安区",
            code: "310106",
            areaCode: "021",
          },
          {
            name: "普陀区",
            code: "310107",
            areaCode: "021",
          },
          {
            name: "虹口区",
            code: "310109",
            areaCode: "021",
          },
          {
            name: "杨浦区",
            code: "310110",
            areaCode: "021",
          },
          {
            name: "闵行区",
            code: "310112",
            areaCode: "021",
          },
          {
            name: "宝山区",
            code: "310113",
            areaCode: "021",
          },
          {
            name: "嘉定区",
            code: "310114",
            areaCode: "021",
          },
          {
            name: "浦东新区",
            code: "310115",
            areaCode: "021",
          },
          {
            name: "金山区",
            code: "310116",
            areaCode: "021",
          },
          {
            name: "松江区",
            code: "310117",
            areaCode: "021",
          },
          {
            name: "青浦区",
            code: "310118",
            areaCode: "021",
          },
          {
            name: "奉贤区",
            code: "310120",
            areaCode: "021",
          },
          {
            name: "崇明区",
            code: "310151",
            areaCode: "021",
          },
        ],
      },
    ],
  },
  {
    name: "江苏省",
    code: "320000",
    areaCode: "",
    cities: [
      {
        name: "南京市",
        code: "320100",
        areaCode: "025",
        cities: [
          {
            name: "南京市市辖区",
            code: "320101",
            areaCode: "025",
          },
          {
            name: "玄武区",
            code: "320102",
            areaCode: "025",
          },
          {
            name: "秦淮区",
            code: "320104",
            areaCode: "025",
          },
          {
            name: "建邺区",
            code: "320105",
            areaCode: "025",
          },
          {
            name: "鼓楼区",
            code: "320106",
            areaCode: "025",
          },
          {
            name: "浦口区",
            code: "320111",
            areaCode: "025",
          },
          {
            name: "栖霞区",
            code: "320113",
            areaCode: "025",
          },
          {
            name: "雨花台区",
            code: "320114",
            areaCode: "025",
          },
          {
            name: "江宁区",
            code: "320115",
            areaCode: "025",
          },
          {
            name: "六合区",
            code: "320116",
            areaCode: "025",
          },
          {
            name: "溧水区",
            code: "320117",
            areaCode: "025",
          },
          {
            name: "高淳区",
            code: "320118",
            areaCode: "025",
          },
        ],
      },
      {
        name: "无锡市",
        code: "320200",
        areaCode: "0510",
        cities: [
          {
            name: "无锡市市辖区",
            code: "320201",
            areaCode: "0510",
          },
          {
            name: "锡山区",
            code: "320205",
            areaCode: "0510",
          },
          {
            name: "惠山区",
            code: "320206",
            areaCode: "0510",
          },
          {
            name: "滨湖区",
            code: "320211",
            areaCode: "0510",
          },
          {
            name: "梁溪区",
            code: "320213",
            areaCode: "0510",
          },
          {
            name: "新吴区",
            code: "320214",
            areaCode: "0510",
          },
          {
            name: "江阴市",
            code: "320281",
            areaCode: "0510",
          },
          {
            name: "宜兴市",
            code: "320282",
            areaCode: "0510",
          },
        ],
      },
      {
        name: "徐州市",
        code: "320300",
        areaCode: "0516",
        cities: [
          {
            name: "徐州市市辖区",
            code: "320301",
            areaCode: "0516",
          },
          {
            name: "鼓楼区",
            code: "320302",
            areaCode: "0516",
          },
          {
            name: "云龙区",
            code: "320303",
            areaCode: "0516",
          },
          {
            name: "贾汪区",
            code: "320305",
            areaCode: "0516",
          },
          {
            name: "泉山区",
            code: "320311",
            areaCode: "0516",
          },
          {
            name: "铜山区",
            code: "320312",
            areaCode: "0516",
          },
          {
            name: "丰县",
            code: "320321",
            areaCode: "0516",
          },
          {
            name: "沛县",
            code: "320322",
            areaCode: "0516",
          },
          {
            name: "睢宁县",
            code: "320324",
            areaCode: "0516",
          },
          {
            name: "新沂市",
            code: "320381",
            areaCode: "0516",
          },
          {
            name: "邳州市",
            code: "320382",
            areaCode: "0516",
          },
        ],
      },
      {
        name: "常州市",
        code: "320400",
        areaCode: "0519",
        cities: [
          {
            name: "常州市市辖区",
            code: "320401",
            areaCode: "0519",
          },
          {
            name: "天宁区",
            code: "320402",
            areaCode: "0519",
          },
          {
            name: "钟楼区",
            code: "320404",
            areaCode: "0519",
          },
          {
            name: "新北区",
            code: "320411",
            areaCode: "0519",
          },
          {
            name: "武进区",
            code: "320412",
            areaCode: "0519",
          },
          {
            name: "金坛区",
            code: "320413",
            areaCode: "0519",
          },
          {
            name: "溧阳市",
            code: "320481",
            areaCode: "0519",
          },
        ],
      },
      {
        name: "苏州市",
        code: "320500",
        areaCode: "0512",
        cities: [
          {
            name: "苏州市市辖区",
            code: "320501",
            areaCode: "0512",
          },
          {
            name: "虎丘区",
            code: "320505",
            areaCode: "0512",
          },
          {
            name: "吴中区",
            code: "320506",
            areaCode: "0512",
          },
          {
            name: "相城区",
            code: "320507",
            areaCode: "0512",
          },
          {
            name: "姑苏区",
            code: "320508",
            areaCode: "0512",
          },
          {
            name: "吴江区",
            code: "320509",
            areaCode: "0512",
          },
          {
            name: "苏州工业园区",
            code: "320571",
            areaCode: "0512",
          },
          {
            name: "常熟市",
            code: "320581",
            areaCode: "0512",
          },
          {
            name: "张家港市",
            code: "320582",
            areaCode: "0512",
          },
          {
            name: "昆山市",
            code: "320583",
            areaCode: "0512",
          },
          {
            name: "太仓市",
            code: "320585",
            areaCode: "0512",
          },
        ],
      },
      {
        name: "南通市",
        code: "320600",
        areaCode: "0513",
        cities: [
          {
            name: "南通市市辖区",
            code: "320601",
            areaCode: "0513",
          },
          {
            name: "崇川区",
            code: "320602",
            areaCode: "0513",
          },
          {
            name: "通州区",
            code: "320612",
            areaCode: "0513",
          },
          {
            name: "海安市",
            code: "320685",
            areaCode: "0513",
          },
          {
            name: "如东县",
            code: "320623",
            areaCode: "0513",
          },
          {
            name: "启东市",
            code: "320681",
            areaCode: "0513",
          },
          {
            name: "如皋市",
            code: "320682",
            areaCode: "0513",
          },
          {
            name: "海门区",
            code: "320684",
            areaCode: "0513",
          },
        ],
      },
      {
        name: "连云港市",
        code: "320700",
        areaCode: "0518",
        cities: [
          {
            name: "连云港市市辖区",
            code: "320701",
            areaCode: "0518",
          },
          {
            name: "连云区",
            code: "320703",
            areaCode: "0518",
          },
          {
            name: "海州区",
            code: "320706",
            areaCode: "0518",
          },
          {
            name: "赣榆区",
            code: "320707",
            areaCode: "0518",
          },
          {
            name: "东海县",
            code: "320722",
            areaCode: "0518",
          },
          {
            name: "灌云县",
            code: "320723",
            areaCode: "0518",
          },
          {
            name: "灌南县",
            code: "320724",
            areaCode: "0518",
          },
        ],
      },
      {
        name: "淮安市",
        code: "320800",
        areaCode: "0517",
        cities: [
          {
            name: "淮安市市辖区",
            code: "320801",
            areaCode: "0517",
          },
          {
            name: "淮安区",
            code: "320803",
            areaCode: "0517",
          },
          {
            name: "淮阴区",
            code: "320804",
            areaCode: "0517",
          },
          {
            name: "清江浦区",
            code: "320812",
            areaCode: "0517",
          },
          {
            name: "洪泽区",
            code: "320813",
            areaCode: "0517",
          },
          {
            name: "涟水县",
            code: "320826",
            areaCode: "0517",
          },
          {
            name: "盱眙县",
            code: "320830",
            areaCode: "0517",
          },
          {
            name: "金湖县",
            code: "320831",
            areaCode: "0517",
          },
        ],
      },
      {
        name: "盐城市",
        code: "320900",
        areaCode: "0515",
        cities: [
          {
            name: "盐城市市辖区",
            code: "320901",
            areaCode: "0515",
          },
          {
            name: "亭湖区",
            code: "320902",
            areaCode: "0515",
          },
          {
            name: "盐都区",
            code: "320903",
            areaCode: "0515",
          },
          {
            name: "大丰区",
            code: "320904",
            areaCode: "0515",
          },
          {
            name: "响水县",
            code: "320921",
            areaCode: "0515",
          },
          {
            name: "滨海县",
            code: "320922",
            areaCode: "0515",
          },
          {
            name: "阜宁县",
            code: "320923",
            areaCode: "0515",
          },
          {
            name: "射阳县",
            code: "320924",
            areaCode: "0515",
          },
          {
            name: "建湖县",
            code: "320925",
            areaCode: "0515",
          },
          {
            name: "东台市",
            code: "320981",
            areaCode: "0515",
          },
        ],
      },
      {
        name: "扬州市",
        code: "321000",
        areaCode: "0514",
        cities: [
          {
            name: "扬州市市辖区",
            code: "321001",
            areaCode: "0514",
          },
          {
            name: "广陵区",
            code: "321002",
            areaCode: "0514",
          },
          {
            name: "邗江区",
            code: "321003",
            areaCode: "0514",
          },
          {
            name: "江都区",
            code: "321012",
            areaCode: "0514",
          },
          {
            name: "宝应县",
            code: "321023",
            areaCode: "0514",
          },
          {
            name: "仪征市",
            code: "321081",
            areaCode: "0514",
          },
          {
            name: "高邮市",
            code: "321084",
            areaCode: "0514",
          },
        ],
      },
      {
        name: "镇江市",
        code: "321100",
        areaCode: "0511",
        cities: [
          {
            name: "镇江市市辖区",
            code: "321101",
            areaCode: "0511",
          },
          {
            name: "京口区",
            code: "321102",
            areaCode: "0511",
          },
          {
            name: "润州区",
            code: "321111",
            areaCode: "0511",
          },
          {
            name: "丹徒区",
            code: "321112",
            areaCode: "0511",
          },
          {
            name: "丹阳市",
            code: "321181",
            areaCode: "0511",
          },
          {
            name: "扬中市",
            code: "321182",
            areaCode: "0511",
          },
          {
            name: "句容市",
            code: "321183",
            areaCode: "0511",
          },
        ],
      },
      {
        name: "泰州市",
        code: "321200",
        areaCode: "0523",
        cities: [
          {
            name: "泰州市市辖区",
            code: "321201",
            areaCode: "0523",
          },
          {
            name: "海陵区",
            code: "321202",
            areaCode: "0523",
          },
          {
            name: "高港区",
            code: "321203",
            areaCode: "0523",
          },
          {
            name: "姜堰区",
            code: "321204",
            areaCode: "0523",
          },
          {
            name: "兴化市",
            code: "321281",
            areaCode: "0523",
          },
          {
            name: "靖江市",
            code: "321282",
            areaCode: "0523",
          },
          {
            name: "泰兴市",
            code: "321283",
            areaCode: "0523",
          },
        ],
      },
      {
        name: "宿迁市",
        code: "321300",
        areaCode: "0527",
        cities: [
          {
            name: "宿迁市市辖区",
            code: "321301",
            areaCode: "0527",
          },
          {
            name: "宿城区",
            code: "321302",
            areaCode: "0527",
          },
          {
            name: "宿豫区",
            code: "321311",
            areaCode: "0527",
          },
          {
            name: "沭阳县",
            code: "321322",
            areaCode: "0527",
          },
          {
            name: "泗阳县",
            code: "321323",
            areaCode: "0527",
          },
          {
            name: "泗洪县",
            code: "321324",
            areaCode: "0527",
          },
        ],
      },
    ],
  },
  {
    name: "浙江省",
    code: "330000",
    areaCode: "",
    cities: [
      {
        name: "杭州市",
        code: "330100",
        areaCode: "0571",
        cities: [
          {
            name: "杭州市市辖区",
            code: "330101",
            areaCode: "0571",
          },
          {
            name: "上城区",
            code: "330102",
            areaCode: "0571",
          },
          {
            name: "下城区",
            code: "330103",
            areaCode: "0571",
          },
          {
            name: "江干区",
            code: "330104",
            areaCode: "0571",
          },
          {
            name: "拱墅区",
            code: "330105",
            areaCode: "0571",
          },
          {
            name: "西湖区",
            code: "330106",
            areaCode: "0571",
          },
          {
            name: "滨江区",
            code: "330108",
            areaCode: "0571",
          },
          {
            name: "萧山区",
            code: "330109",
            areaCode: "0571",
          },
          {
            name: "余杭区",
            code: "330110",
            areaCode: "0571",
          },
          {
            name: "富阳区",
            code: "330111",
            areaCode: "0571",
          },
          {
            name: "临安区",
            code: "330112",
            areaCode: "0571",
          },
          {
            name: "桐庐县",
            code: "330122",
            areaCode: "0571",
          },
          {
            name: "淳安县",
            code: "330127",
            areaCode: "0571",
          },
          {
            name: "建德市",
            code: "330182",
            areaCode: "0571",
          },
        ],
      },
      {
        name: "宁波市",
        code: "330200",
        areaCode: "0574",
        cities: [
          {
            name: "宁波市市辖区",
            code: "330201",
            areaCode: "0574",
          },
          {
            name: "海曙区",
            code: "330203",
            areaCode: "0574",
          },
          {
            name: "江北区",
            code: "330205",
            areaCode: "0574",
          },
          {
            name: "北仑区",
            code: "330206",
            areaCode: "0574",
          },
          {
            name: "镇海区",
            code: "330211",
            areaCode: "0574",
          },
          {
            name: "鄞州区",
            code: "330212",
            areaCode: "0574",
          },
          {
            name: "奉化区",
            code: "330213",
            areaCode: "0574",
          },
          {
            name: "象山县",
            code: "330225",
            areaCode: "0574",
          },
          {
            name: "宁海县",
            code: "330226",
            areaCode: "0574",
          },
          {
            name: "余姚市",
            code: "330281",
            areaCode: "0574",
          },
          {
            name: "慈溪市",
            code: "330282",
            areaCode: "0574",
          },
        ],
      },
      {
        name: "温州市",
        code: "330300",
        areaCode: "0577",
        cities: [
          {
            name: "温州市市辖区",
            code: "330301",
            areaCode: "0577",
          },
          {
            name: "鹿城区",
            code: "330302",
            areaCode: "0577",
          },
          {
            name: "龙湾区",
            code: "330303",
            areaCode: "0577",
          },
          {
            name: "瓯海区",
            code: "330304",
            areaCode: "0577",
          },
          {
            name: "洞头区",
            code: "330305",
            areaCode: "0577",
          },
          {
            name: "永嘉县",
            code: "330324",
            areaCode: "0577",
          },
          {
            name: "平阳县",
            code: "330326",
            areaCode: "0577",
          },
          {
            name: "苍南县",
            code: "330327",
            areaCode: "0577",
          },
          {
            name: "文成县",
            code: "330328",
            areaCode: "0577",
          },
          {
            name: "泰顺县",
            code: "330329",
            areaCode: "0577",
          },
          {
            name: "瑞安市",
            code: "330381",
            areaCode: "0577",
          },
          {
            name: "乐清市",
            code: "330382",
            areaCode: "0577",
          },
          {
            name: "龙港市",
            code: "330383",
            areaCode: "0577",
          },
        ],
      },
      {
        name: "嘉兴市",
        code: "330400",
        areaCode: "0573",
        cities: [
          {
            name: "嘉兴市市辖区",
            code: "330401",
            areaCode: "0573",
          },
          {
            name: "南湖区",
            code: "330402",
            areaCode: "0573",
          },
          {
            name: "秀洲区",
            code: "330411",
            areaCode: "0573",
          },
          {
            name: "嘉善县",
            code: "330421",
            areaCode: "0573",
          },
          {
            name: "海盐县",
            code: "330424",
            areaCode: "0573",
          },
          {
            name: "海宁市",
            code: "330481",
            areaCode: "0573",
          },
          {
            name: "平湖市",
            code: "330482",
            areaCode: "0573",
          },
          {
            name: "桐乡市",
            code: "330483",
            areaCode: "0573",
          },
        ],
      },
      {
        name: "湖州市",
        code: "330500",
        areaCode: "0572",
        cities: [
          {
            name: "湖州市市辖区",
            code: "330501",
            areaCode: "0572",
          },
          {
            name: "吴兴区",
            code: "330502",
            areaCode: "0572",
          },
          {
            name: "南浔区",
            code: "330503",
            areaCode: "0572",
          },
          {
            name: "德清县",
            code: "330521",
            areaCode: "0572",
          },
          {
            name: "长兴县",
            code: "330522",
            areaCode: "0572",
          },
          {
            name: "安吉县",
            code: "330523",
            areaCode: "0572",
          },
        ],
      },
      {
        name: "绍兴市",
        code: "330600",
        areaCode: "0575",
        cities: [
          {
            name: "绍兴市市辖区",
            code: "330601",
            areaCode: "0575",
          },
          {
            name: "越城区",
            code: "330602",
            areaCode: "0575",
          },
          {
            name: "柯桥区",
            code: "330603",
            areaCode: "0575",
          },
          {
            name: "上虞区",
            code: "330604",
            areaCode: "0575",
          },
          {
            name: "新昌县",
            code: "330624",
            areaCode: "0575",
          },
          {
            name: "诸暨市",
            code: "330681",
            areaCode: "0575",
          },
          {
            name: "嵊州市",
            code: "330683",
            areaCode: "0575",
          },
        ],
      },
      {
        name: "金华市",
        code: "330700",
        areaCode: "0579",
        cities: [
          {
            name: "金华市市辖区",
            code: "330701",
            areaCode: "0579",
          },
          {
            name: "婺城区",
            code: "330702",
            areaCode: "0579",
          },
          {
            name: "金东区",
            code: "330703",
            areaCode: "0579",
          },
          {
            name: "武义县",
            code: "330723",
            areaCode: "0579",
          },
          {
            name: "浦江县",
            code: "330726",
            areaCode: "0579",
          },
          {
            name: "磐安县",
            code: "330727",
            areaCode: "0579",
          },
          {
            name: "兰溪市",
            code: "330781",
            areaCode: "0579",
          },
          {
            name: "义乌市",
            code: "330782",
            areaCode: "0579",
          },
          {
            name: "东阳市",
            code: "330783",
            areaCode: "0579",
          },
          {
            name: "永康市",
            code: "330784",
            areaCode: "0579",
          },
        ],
      },
      {
        name: "衢州市",
        code: "330800",
        areaCode: "0570",
        cities: [
          {
            name: "衢州市市辖区",
            code: "330801",
            areaCode: "0570",
          },
          {
            name: "柯城区",
            code: "330802",
            areaCode: "0570",
          },
          {
            name: "衢江区",
            code: "330803",
            areaCode: "0570",
          },
          {
            name: "常山县",
            code: "330822",
            areaCode: "0570",
          },
          {
            name: "开化县",
            code: "330824",
            areaCode: "0570",
          },
          {
            name: "龙游县",
            code: "330825",
            areaCode: "0570",
          },
          {
            name: "江山市",
            code: "330881",
            areaCode: "0570",
          },
        ],
      },
      {
        name: "舟山市",
        code: "330900",
        areaCode: "0580",
        cities: [
          {
            name: "舟山市市辖区",
            code: "330901",
            areaCode: "0580",
          },
          {
            name: "定海区",
            code: "330902",
            areaCode: "0580",
          },
          {
            name: "普陀区",
            code: "330903",
            areaCode: "0580",
          },
          {
            name: "岱山县",
            code: "330921",
            areaCode: "0580",
          },
          {
            name: "嵊泗县",
            code: "330922",
            areaCode: "0580",
          },
        ],
      },
      {
        name: "台州市",
        code: "331000",
        areaCode: "0576",
        cities: [
          {
            name: "台州市市辖区",
            code: "331001",
            areaCode: "0576",
          },
          {
            name: "椒江区",
            code: "331002",
            areaCode: "0576",
          },
          {
            name: "黄岩区",
            code: "331003",
            areaCode: "0576",
          },
          {
            name: "路桥区",
            code: "331004",
            areaCode: "0576",
          },
          {
            name: "三门县",
            code: "331022",
            areaCode: "0576",
          },
          {
            name: "天台县",
            code: "331023",
            areaCode: "0576",
          },
          {
            name: "仙居县",
            code: "331024",
            areaCode: "0576",
          },
          {
            name: "温岭市",
            code: "331081",
            areaCode: "0576",
          },
          {
            name: "临海市",
            code: "331082",
            areaCode: "0576",
          },
          {
            name: "玉环市",
            code: "331083",
            areaCode: "0576",
          },
        ],
      },
      {
        name: "丽水市",
        code: "331100",
        areaCode: "0578",
        cities: [
          {
            name: "丽水市市辖区",
            code: "331101",
            areaCode: "0578",
          },
          {
            name: "莲都区",
            code: "331102",
            areaCode: "0578",
          },
          {
            name: "青田县",
            code: "331121",
            areaCode: "0578",
          },
          {
            name: "缙云县",
            code: "331122",
            areaCode: "0578",
          },
          {
            name: "遂昌县",
            code: "331123",
            areaCode: "0578",
          },
          {
            name: "松阳县",
            code: "331124",
            areaCode: "0578",
          },
          {
            name: "云和县",
            code: "331125",
            areaCode: "0578",
          },
          {
            name: "庆元县",
            code: "331126",
            areaCode: "0578",
          },
          {
            name: "景宁畲族自治县",
            code: "331127",
            areaCode: "0578",
          },
          {
            name: "龙泉市",
            code: "331181",
            areaCode: "0578",
          },
        ],
      },
    ],
  },
  {
    name: "安徽省",
    code: "340000",
    areaCode: "",
    cities: [
      {
        name: "合肥市",
        code: "340100",
        areaCode: "0551",
        cities: [
          {
            name: "合肥市市辖区",
            code: "340101",
            areaCode: "0551",
          },
          {
            name: "瑶海区",
            code: "340102",
            areaCode: "0551",
          },
          {
            name: "庐阳区",
            code: "340103",
            areaCode: "0551",
          },
          {
            name: "蜀山区",
            code: "340104",
            areaCode: "0551",
          },
          {
            name: "包河区",
            code: "340111",
            areaCode: "0551",
          },
          {
            name: "长丰县",
            code: "340121",
            areaCode: "0551",
          },
          {
            name: "肥东县",
            code: "340122",
            areaCode: "0551",
          },
          {
            name: "肥西县",
            code: "340123",
            areaCode: "0551",
          },
          {
            name: "庐江县",
            code: "340124",
            areaCode: "0551",
          },
          {
            name: "巢湖市",
            code: "340181",
            areaCode: "0551",
          },
        ],
      },
      {
        name: "芜湖市",
        code: "340200",
        areaCode: "0553",
        cities: [
          {
            name: "芜湖市市辖区",
            code: "340201",
            areaCode: "0553",
          },
          {
            name: "镜湖区",
            code: "340202",
            areaCode: "0553",
          },
          {
            name: "弋江区",
            code: "340203",
            areaCode: "0553",
          },
          {
            name: "鸠江区",
            code: "340207",
            areaCode: "0553",
          },
          {
            name: "湾沚区",
            code: "340221",
            areaCode: "0553",
          },
          {
            name: "繁昌区",
            code: "340222",
            areaCode: "0553",
          },
          {
            name: "南陵县",
            code: "340223",
            areaCode: "0553",
          },
          {
            name: "无为市",
            code: "340281",
            areaCode: "0553",
          },
        ],
      },
      {
        name: "蚌埠市",
        code: "340300",
        areaCode: "0552",
        cities: [
          {
            name: "蚌埠市市辖区",
            code: "340301",
            areaCode: "0552",
          },
          {
            name: "龙子湖区",
            code: "340302",
            areaCode: "0552",
          },
          {
            name: "蚌山区",
            code: "340303",
            areaCode: "0552",
          },
          {
            name: "禹会区",
            code: "340304",
            areaCode: "0552",
          },
          {
            name: "淮上区",
            code: "340311",
            areaCode: "0552",
          },
          {
            name: "怀远县",
            code: "340321",
            areaCode: "0552",
          },
          {
            name: "五河县",
            code: "340322",
            areaCode: "0552",
          },
          {
            name: "固镇县",
            code: "340323",
            areaCode: "0552",
          },
        ],
      },
      {
        name: "淮南市",
        code: "340400",
        areaCode: "0554",
        cities: [
          {
            name: "淮南市市辖区",
            code: "340401",
            areaCode: "0554",
          },
          {
            name: "大通区",
            code: "340402",
            areaCode: "0554",
          },
          {
            name: "田家庵区",
            code: "340403",
            areaCode: "0554",
          },
          {
            name: "谢家集区",
            code: "340404",
            areaCode: "0554",
          },
          {
            name: "八公山区",
            code: "340405",
            areaCode: "0554",
          },
          {
            name: "潘集区",
            code: "340406",
            areaCode: "0554",
          },
          {
            name: "凤台县",
            code: "340421",
            areaCode: "0554",
          },
          {
            name: "寿县",
            code: "340422",
            areaCode: "0554",
          },
        ],
      },
      {
        name: "马鞍山市",
        code: "340500",
        areaCode: "0555",
        cities: [
          {
            name: "马鞍山市市辖区",
            code: "340501",
            areaCode: "0555",
          },
          {
            name: "花山区",
            code: "340503",
            areaCode: "0555",
          },
          {
            name: "雨山区",
            code: "340504",
            areaCode: "0555",
          },
          {
            name: "博望区",
            code: "340506",
            areaCode: "0555",
          },
          {
            name: "当涂县",
            code: "340521",
            areaCode: "0555",
          },
          {
            name: "含山县",
            code: "340522",
            areaCode: "0555",
          },
          {
            name: "和县",
            code: "340523",
            areaCode: "0555",
          },
        ],
      },
      {
        name: "淮北市",
        code: "340600",
        areaCode: "0561",
        cities: [
          {
            name: "淮北市市辖区",
            code: "340601",
            areaCode: "0561",
          },
          {
            name: "杜集区",
            code: "340602",
            areaCode: "0561",
          },
          {
            name: "相山区",
            code: "340603",
            areaCode: "0561",
          },
          {
            name: "烈山区",
            code: "340604",
            areaCode: "0561",
          },
          {
            name: "濉溪县",
            code: "340621",
            areaCode: "0561",
          },
        ],
      },
      {
        name: "铜陵市",
        code: "340700",
        areaCode: "0562",
        cities: [
          {
            name: "铜陵市市辖区",
            code: "340701",
            areaCode: "0562",
          },
          {
            name: "铜官区",
            code: "340705",
            areaCode: "0562",
          },
          {
            name: "义安区",
            code: "340706",
            areaCode: "0562",
          },
          {
            name: "郊区",
            code: "340711",
            areaCode: "0562",
          },
          {
            name: "枞阳县",
            code: "340722",
            areaCode: "0562",
          },
        ],
      },
      {
        name: "安庆市",
        code: "340800",
        areaCode: "0556",
        cities: [
          {
            name: "安庆市市辖区",
            code: "340801",
            areaCode: "0556",
          },
          {
            name: "迎江区",
            code: "340802",
            areaCode: "0556",
          },
          {
            name: "大观区",
            code: "340803",
            areaCode: "0556",
          },
          {
            name: "宜秀区",
            code: "340811",
            areaCode: "0556",
          },
          {
            name: "怀宁县",
            code: "340822",
            areaCode: "0556",
          },
          {
            name: "潜山市",
            code: "340882",
            areaCode: "0556",
          },
          {
            name: "太湖县",
            code: "340825",
            areaCode: "0556",
          },
          {
            name: "宿松县",
            code: "340826",
            areaCode: "0556",
          },
          {
            name: "望江县",
            code: "340827",
            areaCode: "0556",
          },
          {
            name: "岳西县",
            code: "340828",
            areaCode: "0556",
          },
          {
            name: "桐城市",
            code: "340881",
            areaCode: "0556",
          },
        ],
      },
      {
        name: "黄山市",
        code: "341000",
        areaCode: "0559",
        cities: [
          {
            name: "黄山市市辖区",
            code: "341001",
            areaCode: "0559",
          },
          {
            name: "屯溪区",
            code: "341002",
            areaCode: "0559",
          },
          {
            name: "黄山区",
            code: "341003",
            areaCode: "0559",
          },
          {
            name: "徽州区",
            code: "341004",
            areaCode: "0559",
          },
          {
            name: "歙县",
            code: "341021",
            areaCode: "0559",
          },
          {
            name: "休宁县",
            code: "341022",
            areaCode: "0559",
          },
          {
            name: "黟县",
            code: "341023",
            areaCode: "0559",
          },
          {
            name: "祁门县",
            code: "341024",
            areaCode: "0559",
          },
        ],
      },
      {
        name: "滁州市",
        code: "341100",
        areaCode: "0550",
        cities: [
          {
            name: "滁州市市辖区",
            code: "341101",
            areaCode: "0550",
          },
          {
            name: "琅琊区",
            code: "341102",
            areaCode: "0550",
          },
          {
            name: "南谯区",
            code: "341103",
            areaCode: "0550",
          },
          {
            name: "来安县",
            code: "341122",
            areaCode: "0550",
          },
          {
            name: "全椒县",
            code: "341124",
            areaCode: "0550",
          },
          {
            name: "定远县",
            code: "341125",
            areaCode: "0550",
          },
          {
            name: "凤阳县",
            code: "341126",
            areaCode: "0550",
          },
          {
            name: "天长市",
            code: "341181",
            areaCode: "0550",
          },
          {
            name: "明光市",
            code: "341182",
            areaCode: "0550",
          },
        ],
      },
      {
        name: "阜阳市",
        code: "341200",
        areaCode: "1558",
        cities: [
          {
            name: "阜阳市市辖区",
            code: "341201",
            areaCode: "1558",
          },
          {
            name: "颍州区",
            code: "341202",
            areaCode: "1558",
          },
          {
            name: "颍东区",
            code: "341203",
            areaCode: "1558",
          },
          {
            name: "颍泉区",
            code: "341204",
            areaCode: "1558",
          },
          {
            name: "临泉县",
            code: "341221",
            areaCode: "1558",
          },
          {
            name: "太和县",
            code: "341222",
            areaCode: "1558",
          },
          {
            name: "阜南县",
            code: "341225",
            areaCode: "1558",
          },
          {
            name: "颍上县",
            code: "341226",
            areaCode: "1558",
          },
          {
            name: "界首市",
            code: "341282",
            areaCode: "1558",
          },
        ],
      },
      {
        name: "宿州市",
        code: "341300",
        areaCode: "0557",
        cities: [
          {
            name: "宿州市市辖区",
            code: "341301",
            areaCode: "0557",
          },
          {
            name: "埇桥区",
            code: "341302",
            areaCode: "0557",
          },
          {
            name: "砀山县",
            code: "341321",
            areaCode: "0557",
          },
          {
            name: "萧县",
            code: "341322",
            areaCode: "0557",
          },
          {
            name: "灵璧县",
            code: "341323",
            areaCode: "0557",
          },
          {
            name: "泗县",
            code: "341324",
            areaCode: "0557",
          },
        ],
      },
      {
        name: "六安市",
        code: "341500",
        areaCode: "0564",
        cities: [
          {
            name: "六安市市辖区",
            code: "341501",
            areaCode: "0564",
          },
          {
            name: "金安区",
            code: "341502",
            areaCode: "0564",
          },
          {
            name: "裕安区",
            code: "341503",
            areaCode: "0564",
          },
          {
            name: "叶集区",
            code: "341504",
            areaCode: "0564",
          },
          {
            name: "霍邱县",
            code: "341522",
            areaCode: "0564",
          },
          {
            name: "舒城县",
            code: "341523",
            areaCode: "0564",
          },
          {
            name: "金寨县",
            code: "341524",
            areaCode: "0564",
          },
          {
            name: "霍山县",
            code: "341525",
            areaCode: "0564",
          },
        ],
      },
      {
        name: "亳州市",
        code: "341600",
        areaCode: "0558",
        cities: [
          {
            name: "亳州市市辖区",
            code: "341601",
            areaCode: "0558",
          },
          {
            name: "谯城区",
            code: "341602",
            areaCode: "0558",
          },
          {
            name: "涡阳县",
            code: "341621",
            areaCode: "0558",
          },
          {
            name: "蒙城县",
            code: "341622",
            areaCode: "0558",
          },
          {
            name: "利辛县",
            code: "341623",
            areaCode: "0558",
          },
        ],
      },
      {
        name: "池州市",
        code: "341700",
        areaCode: "0566",
        cities: [
          {
            name: "池州市市辖区",
            code: "341701",
            areaCode: "0566",
          },
          {
            name: "贵池区",
            code: "341702",
            areaCode: "0566",
          },
          {
            name: "东至县",
            code: "341721",
            areaCode: "0566",
          },
          {
            name: "石台县",
            code: "341722",
            areaCode: "0566",
          },
          {
            name: "青阳县",
            code: "341723",
            areaCode: "0566",
          },
        ],
      },
      {
        name: "宣城市",
        code: "341800",
        areaCode: "0563",
        cities: [
          {
            name: "宣城市市辖区",
            code: "341801",
            areaCode: "0563",
          },
          {
            name: "宣州区",
            code: "341802",
            areaCode: "0563",
          },
          {
            name: "郎溪县",
            code: "341821",
            areaCode: "0563",
          },
          {
            name: "广德市",
            code: "341882",
            areaCode: "0563",
          },
          {
            name: "泾县",
            code: "341823",
            areaCode: "0563",
          },
          {
            name: "绩溪县",
            code: "341824",
            areaCode: "0563",
          },
          {
            name: "旌德县",
            code: "341825",
            areaCode: "0563",
          },
          {
            name: "宁国市",
            code: "341881",
            areaCode: "0563",
          },
        ],
      },
    ],
  },
  {
    name: "福建省",
    code: "350000",
    areaCode: "",
    cities: [
      {
        name: "福州市",
        code: "350100",
        areaCode: "0591",
        cities: [
          {
            name: "福州市市辖区",
            code: "350101",
            areaCode: "0591",
          },
          {
            name: "鼓楼区",
            code: "350102",
            areaCode: "0591",
          },
          {
            name: "台江区",
            code: "350103",
            areaCode: "0591",
          },
          {
            name: "仓山区",
            code: "350104",
            areaCode: "0591",
          },
          {
            name: "马尾区",
            code: "350105",
            areaCode: "0591",
          },
          {
            name: "晋安区",
            code: "350111",
            areaCode: "0591",
          },
          {
            name: "长乐区",
            code: "350112",
            areaCode: "0591",
          },
          {
            name: "闽侯县",
            code: "350121",
            areaCode: "0591",
          },
          {
            name: "连江县",
            code: "350122",
            areaCode: "0591",
          },
          {
            name: "罗源县",
            code: "350123",
            areaCode: "0591",
          },
          {
            name: "闽清县",
            code: "350124",
            areaCode: "0591",
          },
          {
            name: "永泰县",
            code: "350125",
            areaCode: "0591",
          },
          {
            name: "平潭县",
            code: "350128",
            areaCode: "0591",
          },
          {
            name: "福清市",
            code: "350181",
            areaCode: "0591",
          },
        ],
      },
      {
        name: "厦门市",
        code: "350200",
        areaCode: "0592",
        cities: [
          {
            name: "厦门市市辖区",
            code: "350201",
            areaCode: "0592",
          },
          {
            name: "思明区",
            code: "350203",
            areaCode: "0592",
          },
          {
            name: "海沧区",
            code: "350205",
            areaCode: "0592",
          },
          {
            name: "湖里区",
            code: "350206",
            areaCode: "0592",
          },
          {
            name: "集美区",
            code: "350211",
            areaCode: "0592",
          },
          {
            name: "同安区",
            code: "350212",
            areaCode: "0592",
          },
          {
            name: "翔安区",
            code: "350213",
            areaCode: "0592",
          },
        ],
      },
      {
        name: "莆田市",
        code: "350300",
        areaCode: "0594",
        cities: [
          {
            name: "莆田市市辖区",
            code: "350301",
            areaCode: "0594",
          },
          {
            name: "城厢区",
            code: "350302",
            areaCode: "0594",
          },
          {
            name: "涵江区",
            code: "350303",
            areaCode: "0594",
          },
          {
            name: "荔城区",
            code: "350304",
            areaCode: "0594",
          },
          {
            name: "秀屿区",
            code: "350305",
            areaCode: "0594",
          },
          {
            name: "仙游县",
            code: "350322",
            areaCode: "0594",
          },
        ],
      },
      {
        name: "三明市",
        code: "350400",
        areaCode: "0598",
        cities: [
          {
            name: "三明市市辖区",
            code: "350401",
            areaCode: "0598",
          },
          {
            name: "梅列区",
            code: "350402",
            areaCode: "0598",
          },
          {
            name: "三元区",
            code: "350403",
            areaCode: "0598",
          },
          {
            name: "明溪县",
            code: "350421",
            areaCode: "0598",
          },
          {
            name: "清流县",
            code: "350423",
            areaCode: "0598",
          },
          {
            name: "宁化县",
            code: "350424",
            areaCode: "0598",
          },
          {
            name: "大田县",
            code: "350425",
            areaCode: "0598",
          },
          {
            name: "尤溪县",
            code: "350426",
            areaCode: "0598",
          },
          {
            name: "沙县",
            code: "350427",
            areaCode: "0598",
          },
          {
            name: "将乐县",
            code: "350428",
            areaCode: "0598",
          },
          {
            name: "泰宁县",
            code: "350429",
            areaCode: "0598",
          },
          {
            name: "建宁县",
            code: "350430",
            areaCode: "0598",
          },
          {
            name: "永安市",
            code: "350481",
            areaCode: "0598",
          },
        ],
      },
      {
        name: "泉州市",
        code: "350500",
        areaCode: "0595",
        cities: [
          {
            name: "泉州市市辖区",
            code: "350501",
            areaCode: "0595",
          },
          {
            name: "鲤城区",
            code: "350502",
            areaCode: "0595",
          },
          {
            name: "丰泽区",
            code: "350503",
            areaCode: "0595",
          },
          {
            name: "洛江区",
            code: "350504",
            areaCode: "0595",
          },
          {
            name: "泉港区",
            code: "350505",
            areaCode: "0595",
          },
          {
            name: "惠安县",
            code: "350521",
            areaCode: "0595",
          },
          {
            name: "安溪县",
            code: "350524",
            areaCode: "0595",
          },
          {
            name: "永春县",
            code: "350525",
            areaCode: "0595",
          },
          {
            name: "德化县",
            code: "350526",
            areaCode: "0595",
          },
          {
            name: "金门县",
            code: "350527",
            areaCode: "0595",
          },
          {
            name: "石狮市",
            code: "350581",
            areaCode: "0595",
          },
          {
            name: "晋江市",
            code: "350582",
            areaCode: "0595",
          },
          {
            name: "南安市",
            code: "350583",
            areaCode: "0595",
          },
        ],
      },
      {
        name: "漳州市",
        code: "350600",
        areaCode: "0596",
        cities: [
          {
            name: "漳州市市辖区",
            code: "350601",
            areaCode: "0596",
          },
          {
            name: "芗城区",
            code: "350602",
            areaCode: "0596",
          },
          {
            name: "龙文区",
            code: "350603",
            areaCode: "0596",
          },
          {
            name: "云霄县",
            code: "350622",
            areaCode: "0596",
          },
          {
            name: "漳浦县",
            code: "350623",
            areaCode: "0596",
          },
          {
            name: "诏安县",
            code: "350624",
            areaCode: "0596",
          },
          {
            name: "长泰县",
            code: "350625",
            areaCode: "0596",
          },
          {
            name: "东山县",
            code: "350626",
            areaCode: "0596",
          },
          {
            name: "南靖县",
            code: "350627",
            areaCode: "0596",
          },
          {
            name: "平和县",
            code: "350628",
            areaCode: "0596",
          },
          {
            name: "华安县",
            code: "350629",
            areaCode: "0596",
          },
          {
            name: "龙海市",
            code: "350681",
            areaCode: "0596",
          },
        ],
      },
      {
        name: "南平市",
        code: "350700",
        areaCode: "0599",
        cities: [
          {
            name: "南平市市辖区",
            code: "350701",
            areaCode: "0599",
          },
          {
            name: "延平区",
            code: "350702",
            areaCode: "0599",
          },
          {
            name: "建阳区",
            code: "350703",
            areaCode: "0599",
          },
          {
            name: "顺昌县",
            code: "350721",
            areaCode: "0599",
          },
          {
            name: "浦城县",
            code: "350722",
            areaCode: "0599",
          },
          {
            name: "光泽县",
            code: "350723",
            areaCode: "0599",
          },
          {
            name: "松溪县",
            code: "350724",
            areaCode: "0599",
          },
          {
            name: "政和县",
            code: "350725",
            areaCode: "0599",
          },
          {
            name: "邵武市",
            code: "350781",
            areaCode: "0599",
          },
          {
            name: "武夷山市",
            code: "350782",
            areaCode: "0599",
          },
          {
            name: "建瓯市",
            code: "350783",
            areaCode: "0599",
          },
        ],
      },
      {
        name: "龙岩市",
        code: "350800",
        areaCode: "0597",
        cities: [
          {
            name: "龙岩市市辖区",
            code: "350801",
            areaCode: "0597",
          },
          {
            name: "新罗区",
            code: "350802",
            areaCode: "0597",
          },
          {
            name: "永定区",
            code: "350803",
            areaCode: "0597",
          },
          {
            name: "长汀县",
            code: "350821",
            areaCode: "0597",
          },
          {
            name: "上杭县",
            code: "350823",
            areaCode: "0597",
          },
          {
            name: "武平县",
            code: "350824",
            areaCode: "0597",
          },
          {
            name: "连城县",
            code: "350825",
            areaCode: "0597",
          },
          {
            name: "漳平市",
            code: "350881",
            areaCode: "0597",
          },
        ],
      },
      {
        name: "宁德市",
        code: "350900",
        areaCode: "0593",
        cities: [
          {
            name: "宁德市市辖区",
            code: "350901",
            areaCode: "0593",
          },
          {
            name: "蕉城区",
            code: "350902",
            areaCode: "0593",
          },
          {
            name: "霞浦县",
            code: "350921",
            areaCode: "0593",
          },
          {
            name: "古田县",
            code: "350922",
            areaCode: "0593",
          },
          {
            name: "屏南县",
            code: "350923",
            areaCode: "0593",
          },
          {
            name: "寿宁县",
            code: "350924",
            areaCode: "0593",
          },
          {
            name: "周宁县",
            code: "350925",
            areaCode: "0593",
          },
          {
            name: "柘荣县",
            code: "350926",
            areaCode: "0593",
          },
          {
            name: "福安市",
            code: "350981",
            areaCode: "0593",
          },
          {
            name: "福鼎市",
            code: "350982",
            areaCode: "0593",
          },
        ],
      },
    ],
  },
  {
    name: "江西省",
    code: "360000",
    areaCode: "",
    cities: [
      {
        name: "南昌市",
        code: "360100",
        areaCode: "0791",
        cities: [
          {
            name: "南昌市市辖区",
            code: "360101",
            areaCode: "0791",
          },
          {
            name: "东湖区",
            code: "360102",
            areaCode: "0791",
          },
          {
            name: "西湖区",
            code: "360103",
            areaCode: "0791",
          },
          {
            name: "青云谱区",
            code: "360104",
            areaCode: "0791",
          },
          {
            name: "青山湖区",
            code: "360111",
            areaCode: "0791",
          },
          {
            name: "红谷滩区",
            code: "360113",
            areaCode: "0791",
          },
          {
            name: "新建区",
            code: "360112",
            areaCode: "0791",
          },
          {
            name: "南昌县",
            code: "360121",
            areaCode: "0791",
          },
          {
            name: "安义县",
            code: "360123",
            areaCode: "0791",
          },
          {
            name: "进贤县",
            code: "360124",
            areaCode: "0791",
          },
        ],
      },
      {
        name: "景德镇市",
        code: "360200",
        areaCode: "0798",
        cities: [
          {
            name: "景德镇市市辖区",
            code: "360201",
            areaCode: "0798",
          },
          {
            name: "昌江区",
            code: "360202",
            areaCode: "0798",
          },
          {
            name: "珠山区",
            code: "360203",
            areaCode: "0798",
          },
          {
            name: "浮梁县",
            code: "360222",
            areaCode: "0798",
          },
          {
            name: "乐平市",
            code: "360281",
            areaCode: "0798",
          },
        ],
      },
      {
        name: "萍乡市",
        code: "360300",
        areaCode: "0799",
        cities: [
          {
            name: "萍乡市市辖区",
            code: "360301",
            areaCode: "0799",
          },
          {
            name: "安源区",
            code: "360302",
            areaCode: "0799",
          },
          {
            name: "湘东区",
            code: "360313",
            areaCode: "0799",
          },
          {
            name: "莲花县",
            code: "360321",
            areaCode: "0799",
          },
          {
            name: "上栗县",
            code: "360322",
            areaCode: "0799",
          },
          {
            name: "芦溪县",
            code: "360323",
            areaCode: "0799",
          },
        ],
      },
      {
        name: "九江市",
        code: "360400",
        areaCode: "0792",
        cities: [
          {
            name: "九江市市辖区",
            code: "360401",
            areaCode: "0792",
          },
          {
            name: "濂溪区",
            code: "360402",
            areaCode: "0792",
          },
          {
            name: "浔阳区",
            code: "360403",
            areaCode: "0792",
          },
          {
            name: "柴桑区",
            code: "360404",
            areaCode: "0792",
          },
          {
            name: "武宁县",
            code: "360423",
            areaCode: "0792",
          },
          {
            name: "修水县",
            code: "360424",
            areaCode: "0792",
          },
          {
            name: "永修县",
            code: "360425",
            areaCode: "0792",
          },
          {
            name: "德安县",
            code: "360426",
            areaCode: "0792",
          },
          {
            name: "都昌县",
            code: "360428",
            areaCode: "0792",
          },
          {
            name: "湖口县",
            code: "360429",
            areaCode: "0792",
          },
          {
            name: "彭泽县",
            code: "360430",
            areaCode: "0792",
          },
          {
            name: "瑞昌市",
            code: "360481",
            areaCode: "0792",
          },
          {
            name: "共青城市",
            code: "360482",
            areaCode: "0792",
          },
          {
            name: "庐山市",
            code: "360483",
            areaCode: "0792",
          },
        ],
      },
      {
        name: "新余市",
        code: "360500",
        areaCode: "0790",
        cities: [
          {
            name: "新余市市辖区",
            code: "360501",
            areaCode: "0790",
          },
          {
            name: "渝水区",
            code: "360502",
            areaCode: "0790",
          },
          {
            name: "分宜县",
            code: "360521",
            areaCode: "0790",
          },
        ],
      },
      {
        name: "鹰潭市",
        code: "360600",
        areaCode: "0701",
        cities: [
          {
            name: "鹰潭市市辖区",
            code: "360601",
            areaCode: "0701",
          },
          {
            name: "月湖区",
            code: "360602",
            areaCode: "0701",
          },
          {
            name: "余江区",
            code: "360603",
            areaCode: "0701",
          },
          {
            name: "贵溪市",
            code: "360681",
            areaCode: "0701",
          },
        ],
      },
      {
        name: "赣州市",
        code: "360700",
        areaCode: "0797",
        cities: [
          {
            name: "赣州市市辖区",
            code: "360701",
            areaCode: "0797",
          },
          {
            name: "章贡区",
            code: "360702",
            areaCode: "0797",
          },
          {
            name: "南康区",
            code: "360703",
            areaCode: "0797",
          },
          {
            name: "赣县区",
            code: "360704",
            areaCode: "0797",
          },
          {
            name: "信丰县",
            code: "360722",
            areaCode: "0797",
          },
          {
            name: "大余县",
            code: "360723",
            areaCode: "0797",
          },
          {
            name: "上犹县",
            code: "360724",
            areaCode: "0797",
          },
          {
            name: "崇义县",
            code: "360725",
            areaCode: "0797",
          },
          {
            name: "安远县",
            code: "360726",
            areaCode: "0797",
          },
          {
            name: "龙南市",
            code: "360783",
            areaCode: "0797",
          },
          {
            name: "定南县",
            code: "360728",
            areaCode: "0797",
          },
          {
            name: "全南县",
            code: "360729",
            areaCode: "0797",
          },
          {
            name: "宁都县",
            code: "360730",
            areaCode: "0797",
          },
          {
            name: "于都县",
            code: "360731",
            areaCode: "0797",
          },
          {
            name: "兴国县",
            code: "360732",
            areaCode: "0797",
          },
          {
            name: "会昌县",
            code: "360733",
            areaCode: "0797",
          },
          {
            name: "寻乌县",
            code: "360734",
            areaCode: "0797",
          },
          {
            name: "石城县",
            code: "360735",
            areaCode: "0797",
          },
          {
            name: "瑞金市",
            code: "360781",
            areaCode: "0797",
          },
        ],
      },
      {
        name: "吉安市",
        code: "360800",
        areaCode: "0796",
        cities: [
          {
            name: "吉安市市辖区",
            code: "360801",
            areaCode: "0796",
          },
          {
            name: "吉州区",
            code: "360802",
            areaCode: "0796",
          },
          {
            name: "青原区",
            code: "360803",
            areaCode: "0796",
          },
          {
            name: "吉安县",
            code: "360821",
            areaCode: "0796",
          },
          {
            name: "吉水县",
            code: "360822",
            areaCode: "0796",
          },
          {
            name: "峡江县",
            code: "360823",
            areaCode: "0796",
          },
          {
            name: "新干县",
            code: "360824",
            areaCode: "0796",
          },
          {
            name: "永丰县",
            code: "360825",
            areaCode: "0796",
          },
          {
            name: "泰和县",
            code: "360826",
            areaCode: "0796",
          },
          {
            name: "遂川县",
            code: "360827",
            areaCode: "0796",
          },
          {
            name: "万安县",
            code: "360828",
            areaCode: "0796",
          },
          {
            name: "安福县",
            code: "360829",
            areaCode: "0796",
          },
          {
            name: "永新县",
            code: "360830",
            areaCode: "0796",
          },
          {
            name: "井冈山市",
            code: "360881",
            areaCode: "0796",
          },
        ],
      },
      {
        name: "宜春市",
        code: "360900",
        areaCode: "0795",
        cities: [
          {
            name: "宜春市市辖区",
            code: "360901",
            areaCode: "0795",
          },
          {
            name: "袁州区",
            code: "360902",
            areaCode: "0795",
          },
          {
            name: "奉新县",
            code: "360921",
            areaCode: "0795",
          },
          {
            name: "万载县",
            code: "360922",
            areaCode: "0795",
          },
          {
            name: "上高县",
            code: "360923",
            areaCode: "0795",
          },
          {
            name: "宜丰县",
            code: "360924",
            areaCode: "0795",
          },
          {
            name: "靖安县",
            code: "360925",
            areaCode: "0795",
          },
          {
            name: "铜鼓县",
            code: "360926",
            areaCode: "0795",
          },
          {
            name: "丰城市",
            code: "360981",
            areaCode: "0795",
          },
          {
            name: "樟树市",
            code: "360982",
            areaCode: "0795",
          },
          {
            name: "高安市",
            code: "360983",
            areaCode: "0795",
          },
        ],
      },
      {
        name: "抚州市",
        code: "361000",
        areaCode: "0794",
        cities: [
          {
            name: "抚州市市辖区",
            code: "361001",
            areaCode: "0794",
          },
          {
            name: "临川区",
            code: "361002",
            areaCode: "0794",
          },
          {
            name: "东乡区",
            code: "361003",
            areaCode: "0794",
          },
          {
            name: "南城县",
            code: "361021",
            areaCode: "0794",
          },
          {
            name: "黎川县",
            code: "361022",
            areaCode: "0794",
          },
          {
            name: "南丰县",
            code: "361023",
            areaCode: "0794",
          },
          {
            name: "崇仁县",
            code: "361024",
            areaCode: "0794",
          },
          {
            name: "乐安县",
            code: "361025",
            areaCode: "0794",
          },
          {
            name: "宜黄县",
            code: "361026",
            areaCode: "0794",
          },
          {
            name: "金溪县",
            code: "361027",
            areaCode: "0794",
          },
          {
            name: "资溪县",
            code: "361028",
            areaCode: "0794",
          },
          {
            name: "广昌县",
            code: "361030",
            areaCode: "0794",
          },
        ],
      },
      {
        name: "上饶市",
        code: "361100",
        areaCode: "0793",
        cities: [
          {
            name: "上饶市市辖区",
            code: "361101",
            areaCode: "0793",
          },
          {
            name: "信州区",
            code: "361102",
            areaCode: "0793",
          },
          {
            name: "广丰区",
            code: "361103",
            areaCode: "0793",
          },
          {
            name: "广信区",
            code: "361104",
            areaCode: "0793",
          },
          {
            name: "玉山县",
            code: "361123",
            areaCode: "0793",
          },
          {
            name: "铅山县",
            code: "361124",
            areaCode: "0793",
          },
          {
            name: "横峰县",
            code: "361125",
            areaCode: "0793",
          },
          {
            name: "弋阳县",
            code: "361126",
            areaCode: "0793",
          },
          {
            name: "余干县",
            code: "361127",
            areaCode: "0793",
          },
          {
            name: "鄱阳县",
            code: "361128",
            areaCode: "0793",
          },
          {
            name: "万年县",
            code: "361129",
            areaCode: "0793",
          },
          {
            name: "婺源县",
            code: "361130",
            areaCode: "0793",
          },
          {
            name: "德兴市",
            code: "361181",
            areaCode: "0793",
          },
        ],
      },
    ],
  },
  {
    name: "山东省",
    code: "370000",
    areaCode: "",
    cities: [
      {
        name: "济南市",
        code: "370100",
        areaCode: "0531",
        cities: [
          {
            name: "济南市市辖区",
            code: "370101",
            areaCode: "0531",
          },
          {
            name: "历下区",
            code: "370102",
            areaCode: "0531",
          },
          {
            name: "市中区",
            code: "370103",
            areaCode: "0531",
          },
          {
            name: "槐荫区",
            code: "370104",
            areaCode: "0531",
          },
          {
            name: "天桥区",
            code: "370105",
            areaCode: "0531",
          },
          {
            name: "历城区",
            code: "370112",
            areaCode: "0531",
          },
          {
            name: "长清区",
            code: "370113",
            areaCode: "0531",
          },
          {
            name: "章丘区",
            code: "370114",
            areaCode: "0531",
          },
          {
            name: "平阴县",
            code: "370124",
            areaCode: "0531",
          },
          {
            name: "济阳区",
            code: "370115",
            areaCode: "0531",
          },
          {
            name: "商河县",
            code: "370126",
            areaCode: "0531",
          },
          {
            name: "莱芜区",
            code: "370116",
            areaCode: "0531",
          },
          {
            name: "钢城区",
            code: "370117",
            areaCode: "0531",
          },
        ],
      },
      {
        name: "青岛市",
        code: "370200",
        areaCode: "0532",
        cities: [
          {
            name: "青岛市市辖区",
            code: "370201",
            areaCode: "0532",
          },
          {
            name: "市南区",
            code: "370202",
            areaCode: "0532",
          },
          {
            name: "市北区",
            code: "370203",
            areaCode: "0532",
          },
          {
            name: "黄岛区",
            code: "370211",
            areaCode: "0532",
          },
          {
            name: "崂山区",
            code: "370212",
            areaCode: "0532",
          },
          {
            name: "李沧区",
            code: "370213",
            areaCode: "0532",
          },
          {
            name: "城阳区",
            code: "370214",
            areaCode: "0532",
          },
          {
            name: "即墨区",
            code: "370215",
            areaCode: "0532",
          },
          {
            name: "胶州市",
            code: "370281",
            areaCode: "0532",
          },
          {
            name: "平度市",
            code: "370283",
            areaCode: "0532",
          },
          {
            name: "莱西市",
            code: "370285",
            areaCode: "0532",
          },
        ],
      },
      {
        name: "淄博市",
        code: "370300",
        areaCode: "0533",
        cities: [
          {
            name: "淄博市市辖区",
            code: "370301",
            areaCode: "0533",
          },
          {
            name: "淄川区",
            code: "370302",
            areaCode: "0533",
          },
          {
            name: "张店区",
            code: "370303",
            areaCode: "0533",
          },
          {
            name: "博山区",
            code: "370304",
            areaCode: "0533",
          },
          {
            name: "临淄区",
            code: "370305",
            areaCode: "0533",
          },
          {
            name: "周村区",
            code: "370306",
            areaCode: "0533",
          },
          {
            name: "桓台县",
            code: "370321",
            areaCode: "0533",
          },
          {
            name: "高青县",
            code: "370322",
            areaCode: "0533",
          },
          {
            name: "沂源县",
            code: "370323",
            areaCode: "0533",
          },
        ],
      },
      {
        name: "枣庄市",
        code: "370400",
        areaCode: "0632",
        cities: [
          {
            name: "枣庄市市辖区",
            code: "370401",
            areaCode: "0632",
          },
          {
            name: "市中区",
            code: "370402",
            areaCode: "0632",
          },
          {
            name: "薛城区",
            code: "370403",
            areaCode: "0632",
          },
          {
            name: "峄城区",
            code: "370404",
            areaCode: "0632",
          },
          {
            name: "台儿庄区",
            code: "370405",
            areaCode: "0632",
          },
          {
            name: "山亭区",
            code: "370406",
            areaCode: "0632",
          },
          {
            name: "滕州市",
            code: "370481",
            areaCode: "0632",
          },
        ],
      },
      {
        name: "东营市",
        code: "370500",
        areaCode: "0546",
        cities: [
          {
            name: "东营市市辖区",
            code: "370501",
            areaCode: "0546",
          },
          {
            name: "东营区",
            code: "370502",
            areaCode: "0546",
          },
          {
            name: "河口区",
            code: "370503",
            areaCode: "0546",
          },
          {
            name: "垦利区",
            code: "370505",
            areaCode: "0546",
          },
          {
            name: "利津县",
            code: "370522",
            areaCode: "0546",
          },
          {
            name: "广饶县",
            code: "370523",
            areaCode: "0546",
          },
        ],
      },
      {
        name: "烟台市",
        code: "370600",
        areaCode: "0535",
        cities: [
          {
            name: "烟台市市辖区",
            code: "370601",
            areaCode: "0535",
          },
          {
            name: "芝罘区",
            code: "370602",
            areaCode: "0535",
          },
          {
            name: "福山区",
            code: "370611",
            areaCode: "0535",
          },
          {
            name: "牟平区",
            code: "370612",
            areaCode: "0535",
          },
          {
            name: "莱山区",
            code: "370613",
            areaCode: "0535",
          },
          {
            name: "蓬莱区",
            code: "370614",
            areaCode: "0535",
          },
          {
            name: "龙口市",
            code: "370681",
            areaCode: "0535",
          },
          {
            name: "莱阳市",
            code: "370682",
            areaCode: "0535",
          },
          {
            name: "莱州市",
            code: "370683",
            areaCode: "0535",
          },
          {
            name: "招远市",
            code: "370685",
            areaCode: "0535",
          },
          {
            name: "栖霞市",
            code: "370686",
            areaCode: "0535",
          },
          {
            name: "海阳市",
            code: "370687",
            areaCode: "0535",
          },
        ],
      },
      {
        name: "潍坊市",
        code: "370700",
        areaCode: "0536",
        cities: [
          {
            name: "潍坊市市辖区",
            code: "370701",
            areaCode: "0536",
          },
          {
            name: "潍城区",
            code: "370702",
            areaCode: "0536",
          },
          {
            name: "寒亭区",
            code: "370703",
            areaCode: "0536",
          },
          {
            name: "坊子区",
            code: "370704",
            areaCode: "0536",
          },
          {
            name: "奎文区",
            code: "370705",
            areaCode: "0536",
          },
          {
            name: "临朐县",
            code: "370724",
            areaCode: "0536",
          },
          {
            name: "昌乐县",
            code: "370725",
            areaCode: "0536",
          },
          {
            name: "青州市",
            code: "370781",
            areaCode: "0536",
          },
          {
            name: "诸城市",
            code: "370782",
            areaCode: "0536",
          },
          {
            name: "寿光市",
            code: "370783",
            areaCode: "0536",
          },
          {
            name: "安丘市",
            code: "370784",
            areaCode: "0536",
          },
          {
            name: "高密市",
            code: "370785",
            areaCode: "0536",
          },
          {
            name: "昌邑市",
            code: "370786",
            areaCode: "0536",
          },
        ],
      },
      {
        name: "济宁市",
        code: "370800",
        areaCode: "0537",
        cities: [
          {
            name: "济宁市市辖区",
            code: "370801",
            areaCode: "0537",
          },
          {
            name: "任城区",
            code: "370811",
            areaCode: "0537",
          },
          {
            name: "兖州区",
            code: "370812",
            areaCode: "0537",
          },
          {
            name: "微山县",
            code: "370826",
            areaCode: "0537",
          },
          {
            name: "鱼台县",
            code: "370827",
            areaCode: "0537",
          },
          {
            name: "金乡县",
            code: "370828",
            areaCode: "0537",
          },
          {
            name: "嘉祥县",
            code: "370829",
            areaCode: "0537",
          },
          {
            name: "汶上县",
            code: "370830",
            areaCode: "0537",
          },
          {
            name: "泗水县",
            code: "370831",
            areaCode: "0537",
          },
          {
            name: "梁山县",
            code: "370832",
            areaCode: "0537",
          },
          {
            name: "曲阜市",
            code: "370881",
            areaCode: "0537",
          },
          {
            name: "邹城市",
            code: "370883",
            areaCode: "0537",
          },
        ],
      },
      {
        name: "泰安市",
        code: "370900",
        areaCode: "0538",
        cities: [
          {
            name: "泰安市市辖区",
            code: "370901",
            areaCode: "0538",
          },
          {
            name: "泰山区",
            code: "370902",
            areaCode: "0538",
          },
          {
            name: "岱岳区",
            code: "370911",
            areaCode: "0538",
          },
          {
            name: "宁阳县",
            code: "370921",
            areaCode: "0538",
          },
          {
            name: "东平县",
            code: "370923",
            areaCode: "0538",
          },
          {
            name: "新泰市",
            code: "370982",
            areaCode: "0538",
          },
          {
            name: "肥城市",
            code: "370983",
            areaCode: "0538",
          },
        ],
      },
      {
        name: "威海市",
        code: "371000",
        areaCode: "0631",
        cities: [
          {
            name: "威海市市辖区",
            code: "371001",
            areaCode: "0631",
          },
          {
            name: "环翠区",
            code: "371002",
            areaCode: "0631",
          },
          {
            name: "文登区",
            code: "371003",
            areaCode: "0631",
          },
          {
            name: "荣成市",
            code: "371082",
            areaCode: "0631",
          },
          {
            name: "乳山市",
            code: "371083",
            areaCode: "0631",
          },
        ],
      },
      {
        name: "日照市",
        code: "371100",
        areaCode: "0633",
        cities: [
          {
            name: "日照市市辖区",
            code: "371101",
            areaCode: "0633",
          },
          {
            name: "东港区",
            code: "371102",
            areaCode: "0633",
          },
          {
            name: "岚山区",
            code: "371103",
            areaCode: "0633",
          },
          {
            name: "五莲县",
            code: "371121",
            areaCode: "0633",
          },
          {
            name: "莒县",
            code: "371122",
            areaCode: "0633",
          },
        ],
      },
      {
        name: "临沂市",
        code: "371300",
        areaCode: "0539",
        cities: [
          {
            name: "临沂市市辖区",
            code: "371301",
            areaCode: "0539",
          },
          {
            name: "兰山区",
            code: "371302",
            areaCode: "0539",
          },
          {
            name: "罗庄区",
            code: "371311",
            areaCode: "0539",
          },
          {
            name: "河东区",
            code: "371312",
            areaCode: "0539",
          },
          {
            name: "沂南县",
            code: "371321",
            areaCode: "0539",
          },
          {
            name: "郯城县",
            code: "371322",
            areaCode: "0539",
          },
          {
            name: "沂水县",
            code: "371323",
            areaCode: "0539",
          },
          {
            name: "兰陵县",
            code: "371324",
            areaCode: "0539",
          },
          {
            name: "费县",
            code: "371325",
            areaCode: "0539",
          },
          {
            name: "平邑县",
            code: "371326",
            areaCode: "0539",
          },
          {
            name: "莒南县",
            code: "371327",
            areaCode: "0539",
          },
          {
            name: "蒙阴县",
            code: "371328",
            areaCode: "0539",
          },
          {
            name: "临沭县",
            code: "371329",
            areaCode: "0539",
          },
        ],
      },
      {
        name: "德州市",
        code: "371400",
        areaCode: "0534",
        cities: [
          {
            name: "德州市市辖区",
            code: "371401",
            areaCode: "0534",
          },
          {
            name: "德城区",
            code: "371402",
            areaCode: "0534",
          },
          {
            name: "陵城区",
            code: "371403",
            areaCode: "0534",
          },
          {
            name: "宁津县",
            code: "371422",
            areaCode: "0534",
          },
          {
            name: "庆云县",
            code: "371423",
            areaCode: "0534",
          },
          {
            name: "临邑县",
            code: "371424",
            areaCode: "0534",
          },
          {
            name: "齐河县",
            code: "371425",
            areaCode: "0534",
          },
          {
            name: "平原县",
            code: "371426",
            areaCode: "0534",
          },
          {
            name: "夏津县",
            code: "371427",
            areaCode: "0534",
          },
          {
            name: "武城县",
            code: "371428",
            areaCode: "0534",
          },
          {
            name: "乐陵市",
            code: "371481",
            areaCode: "0534",
          },
          {
            name: "禹城市",
            code: "371482",
            areaCode: "0534",
          },
        ],
      },
      {
        name: "聊城市",
        code: "371500",
        areaCode: "0635",
        cities: [
          {
            name: "聊城市市辖区",
            code: "371501",
            areaCode: "0635",
          },
          {
            name: "东昌府区",
            code: "371502",
            areaCode: "0635",
          },
          {
            name: "阳谷县",
            code: "371521",
            areaCode: "0635",
          },
          {
            name: "莘县",
            code: "371522",
            areaCode: "0635",
          },
          {
            name: "茌平区",
            code: "371503",
            areaCode: "0635",
          },
          {
            name: "东阿县",
            code: "371524",
            areaCode: "0635",
          },
          {
            name: "冠县",
            code: "371525",
            areaCode: "0635",
          },
          {
            name: "高唐县",
            code: "371526",
            areaCode: "0635",
          },
          {
            name: "临清市",
            code: "371581",
            areaCode: "0635",
          },
        ],
      },
      {
        name: "滨州市",
        code: "371600",
        areaCode: "0543",
        cities: [
          {
            name: "滨州市市辖区",
            code: "371601",
            areaCode: "0543",
          },
          {
            name: "滨城区",
            code: "371602",
            areaCode: "0543",
          },
          {
            name: "沾化区",
            code: "371603",
            areaCode: "0543",
          },
          {
            name: "惠民县",
            code: "371621",
            areaCode: "0543",
          },
          {
            name: "阳信县",
            code: "371622",
            areaCode: "0543",
          },
          {
            name: "无棣县",
            code: "371623",
            areaCode: "0543",
          },
          {
            name: "博兴县",
            code: "371625",
            areaCode: "0543",
          },
          {
            name: "邹平市",
            code: "371681",
            areaCode: "0543",
          },
        ],
      },
      {
        name: "菏泽市",
        code: "371700",
        areaCode: "0530",
        cities: [
          {
            name: "菏泽市市辖区",
            code: "371701",
            areaCode: "0530",
          },
          {
            name: "牡丹区",
            code: "371702",
            areaCode: "0530",
          },
          {
            name: "定陶区",
            code: "371703",
            areaCode: "0530",
          },
          {
            name: "曹县",
            code: "371721",
            areaCode: "0530",
          },
          {
            name: "单县",
            code: "371722",
            areaCode: "0530",
          },
          {
            name: "成武县",
            code: "371723",
            areaCode: "0530",
          },
          {
            name: "巨野县",
            code: "371724",
            areaCode: "0530",
          },
          {
            name: "郓城县",
            code: "371725",
            areaCode: "0530",
          },
          {
            name: "鄄城县",
            code: "371726",
            areaCode: "0530",
          },
          {
            name: "东明县",
            code: "371728",
            areaCode: "0530",
          },
        ],
      },
    ],
  },
  {
    name: "河南省",
    code: "410000",
    areaCode: "",
    cities: [
      {
        name: "郑州市",
        code: "410100",
        areaCode: "0371",
        cities: [
          {
            name: "郑州市市辖区",
            code: "410101",
            areaCode: "0371",
          },
          {
            name: "中原区",
            code: "410102",
            areaCode: "0371",
          },
          {
            name: "二七区",
            code: "410103",
            areaCode: "0371",
          },
          {
            name: "管城回族区",
            code: "410104",
            areaCode: "0371",
          },
          {
            name: "金水区",
            code: "410105",
            areaCode: "0371",
          },
          {
            name: "上街区",
            code: "410106",
            areaCode: "0371",
          },
          {
            name: "惠济区",
            code: "410108",
            areaCode: "0371",
          },
          {
            name: "中牟县",
            code: "410122",
            areaCode: "0371",
          },
          {
            name: "巩义市",
            code: "410181",
            areaCode: "0371",
          },
          {
            name: "荥阳市",
            code: "410182",
            areaCode: "0371",
          },
          {
            name: "新密市",
            code: "410183",
            areaCode: "0371",
          },
          {
            name: "新郑市",
            code: "410184",
            areaCode: "0371",
          },
          {
            name: "登封市",
            code: "410185",
            areaCode: "0371",
          },
        ],
      },
      {
        name: "开封市",
        code: "410200",
        areaCode: "0378",
        cities: [
          {
            name: "开封市市辖区",
            code: "410201",
            areaCode: "0378",
          },
          {
            name: "龙亭区",
            code: "410202",
            areaCode: "0378",
          },
          {
            name: "顺河回族区",
            code: "410203",
            areaCode: "0378",
          },
          {
            name: "鼓楼区",
            code: "410204",
            areaCode: "0378",
          },
          {
            name: "禹王台区",
            code: "410205",
            areaCode: "0378",
          },
          {
            name: "祥符区",
            code: "410212",
            areaCode: "0378",
          },
          {
            name: "杞县",
            code: "410221",
            areaCode: "0378",
          },
          {
            name: "通许县",
            code: "410222",
            areaCode: "0378",
          },
          {
            name: "尉氏县",
            code: "410223",
            areaCode: "0378",
          },
          {
            name: "兰考县",
            code: "410225",
            areaCode: "0378",
          },
        ],
      },
      {
        name: "洛阳市",
        code: "410300",
        areaCode: "0379",
        cities: [
          {
            name: "洛阳市市辖区",
            code: "410301",
            areaCode: "0379",
          },
          {
            name: "老城区",
            code: "410302",
            areaCode: "0379",
          },
          {
            name: "西工区",
            code: "410303",
            areaCode: "0379",
          },
          {
            name: "瀍河回族区",
            code: "410304",
            areaCode: "0379",
          },
          {
            name: "涧西区",
            code: "410305",
            areaCode: "0379",
          },
          {
            name: "吉利区",
            code: "410306",
            areaCode: "0379",
          },
          {
            name: "洛龙区",
            code: "410311",
            areaCode: "0379",
          },
          {
            name: "孟津县",
            code: "410322",
            areaCode: "0379",
          },
          {
            name: "新安县",
            code: "410323",
            areaCode: "0379",
          },
          {
            name: "栾川县",
            code: "410324",
            areaCode: "0379",
          },
          {
            name: "嵩县",
            code: "410325",
            areaCode: "0379",
          },
          {
            name: "汝阳县",
            code: "410326",
            areaCode: "0379",
          },
          {
            name: "宜阳县",
            code: "410327",
            areaCode: "0379",
          },
          {
            name: "洛宁县",
            code: "410328",
            areaCode: "0379",
          },
          {
            name: "伊川县",
            code: "410329",
            areaCode: "0379",
          },
          {
            name: "偃师市",
            code: "410381",
            areaCode: "0379",
          },
        ],
      },
      {
        name: "平顶山市",
        code: "410400",
        areaCode: "0375",
        cities: [
          {
            name: "平顶山市市辖区",
            code: "410401",
            areaCode: "0375",
          },
          {
            name: "新华区",
            code: "410402",
            areaCode: "0375",
          },
          {
            name: "卫东区",
            code: "410403",
            areaCode: "0375",
          },
          {
            name: "石龙区",
            code: "410404",
            areaCode: "0375",
          },
          {
            name: "湛河区",
            code: "410411",
            areaCode: "0375",
          },
          {
            name: "宝丰县",
            code: "410421",
            areaCode: "0375",
          },
          {
            name: "叶县",
            code: "410422",
            areaCode: "0375",
          },
          {
            name: "鲁山县",
            code: "410423",
            areaCode: "0375",
          },
          {
            name: "郏县",
            code: "410425",
            areaCode: "0375",
          },
          {
            name: "舞钢市",
            code: "410481",
            areaCode: "0375",
          },
          {
            name: "汝州市",
            code: "410482",
            areaCode: "0375",
          },
        ],
      },
      {
        name: "安阳市",
        code: "410500",
        areaCode: "0372",
        cities: [
          {
            name: "安阳市市辖区",
            code: "410501",
            areaCode: "0372",
          },
          {
            name: "文峰区",
            code: "410502",
            areaCode: "0372",
          },
          {
            name: "北关区",
            code: "410503",
            areaCode: "0372",
          },
          {
            name: "殷都区",
            code: "410505",
            areaCode: "0372",
          },
          {
            name: "龙安区",
            code: "410506",
            areaCode: "0372",
          },
          {
            name: "安阳县",
            code: "410522",
            areaCode: "0372",
          },
          {
            name: "汤阴县",
            code: "410523",
            areaCode: "0372",
          },
          {
            name: "滑县",
            code: "410526",
            areaCode: "0372",
          },
          {
            name: "内黄县",
            code: "410527",
            areaCode: "0372",
          },
          {
            name: "林州市",
            code: "410581",
            areaCode: "0372",
          },
        ],
      },
      {
        name: "鹤壁市",
        code: "410600",
        areaCode: "0392",
        cities: [
          {
            name: "鹤壁市市辖区",
            code: "410601",
            areaCode: "0392",
          },
          {
            name: "鹤山区",
            code: "410602",
            areaCode: "0392",
          },
          {
            name: "山城区",
            code: "410603",
            areaCode: "0392",
          },
          {
            name: "淇滨区",
            code: "410611",
            areaCode: "0392",
          },
          {
            name: "浚县",
            code: "410621",
            areaCode: "0392",
          },
          {
            name: "淇县",
            code: "410622",
            areaCode: "0392",
          },
        ],
      },
      {
        name: "新乡市",
        code: "410700",
        areaCode: "0373",
        cities: [
          {
            name: "新乡市市辖区",
            code: "410701",
            areaCode: "0373",
          },
          {
            name: "红旗区",
            code: "410702",
            areaCode: "0373",
          },
          {
            name: "卫滨区",
            code: "410703",
            areaCode: "0373",
          },
          {
            name: "凤泉区",
            code: "410704",
            areaCode: "0373",
          },
          {
            name: "牧野区",
            code: "410711",
            areaCode: "0373",
          },
          {
            name: "新乡县",
            code: "410721",
            areaCode: "0373",
          },
          {
            name: "获嘉县",
            code: "410724",
            areaCode: "0373",
          },
          {
            name: "原阳县",
            code: "410725",
            areaCode: "0373",
          },
          {
            name: "延津县",
            code: "410726",
            areaCode: "0373",
          },
          {
            name: "封丘县",
            code: "410727",
            areaCode: "0373",
          },
          {
            name: "长垣市",
            code: "410783",
            areaCode: "0373",
          },
          {
            name: "卫辉市",
            code: "410781",
            areaCode: "0373",
          },
          {
            name: "辉县市",
            code: "410782",
            areaCode: "0373",
          },
        ],
      },
      {
        name: "焦作市",
        code: "410800",
        areaCode: "0391",
        cities: [
          {
            name: "焦作市市辖区",
            code: "410801",
            areaCode: "0391",
          },
          {
            name: "解放区",
            code: "410802",
            areaCode: "0391",
          },
          {
            name: "中站区",
            code: "410803",
            areaCode: "0391",
          },
          {
            name: "马村区",
            code: "410804",
            areaCode: "0391",
          },
          {
            name: "山阳区",
            code: "410811",
            areaCode: "0391",
          },
          {
            name: "修武县",
            code: "410821",
            areaCode: "0391",
          },
          {
            name: "博爱县",
            code: "410822",
            areaCode: "0391",
          },
          {
            name: "武陟县",
            code: "410823",
            areaCode: "0391",
          },
          {
            name: "温县",
            code: "410825",
            areaCode: "0391",
          },
          {
            name: "沁阳市",
            code: "410882",
            areaCode: "0391",
          },
          {
            name: "孟州市",
            code: "410883",
            areaCode: "0391",
          },
        ],
      },
      {
        name: "濮阳市",
        code: "410900",
        areaCode: "0393",
        cities: [
          {
            name: "濮阳市市辖区",
            code: "410901",
            areaCode: "0393",
          },
          {
            name: "华龙区",
            code: "410902",
            areaCode: "0393",
          },
          {
            name: "清丰县",
            code: "410922",
            areaCode: "0393",
          },
          {
            name: "南乐县",
            code: "410923",
            areaCode: "0393",
          },
          {
            name: "范县",
            code: "410926",
            areaCode: "0393",
          },
          {
            name: "台前县",
            code: "410927",
            areaCode: "0393",
          },
          {
            name: "濮阳县",
            code: "410928",
            areaCode: "0393",
          },
        ],
      },
      {
        name: "许昌市",
        code: "411000",
        areaCode: "0374",
        cities: [
          {
            name: "许昌市市辖区",
            code: "411001",
            areaCode: "0374",
          },
          {
            name: "魏都区",
            code: "411002",
            areaCode: "0374",
          },
          {
            name: "建安区",
            code: "411003",
            areaCode: "0374",
          },
          {
            name: "鄢陵县",
            code: "411024",
            areaCode: "0374",
          },
          {
            name: "襄城县",
            code: "411025",
            areaCode: "0374",
          },
          {
            name: "禹州市",
            code: "411081",
            areaCode: "0374",
          },
          {
            name: "长葛市",
            code: "411082",
            areaCode: "0374",
          },
        ],
      },
      {
        name: "漯河市",
        code: "411100",
        areaCode: "0395",
        cities: [
          {
            name: "漯河市市辖区",
            code: "411101",
            areaCode: "0395",
          },
          {
            name: "源汇区",
            code: "411102",
            areaCode: "0395",
          },
          {
            name: "郾城区",
            code: "411103",
            areaCode: "0395",
          },
          {
            name: "召陵区",
            code: "411104",
            areaCode: "0395",
          },
          {
            name: "舞阳县",
            code: "411121",
            areaCode: "0395",
          },
          {
            name: "临颍县",
            code: "411122",
            areaCode: "0395",
          },
        ],
      },
      {
        name: "三门峡市",
        code: "411200",
        areaCode: "0398",
        cities: [
          {
            name: "三门峡市市辖区",
            code: "411201",
            areaCode: "0398",
          },
          {
            name: "湖滨区",
            code: "411202",
            areaCode: "0398",
          },
          {
            name: "陕州区",
            code: "411203",
            areaCode: "0398",
          },
          {
            name: "渑池县",
            code: "411221",
            areaCode: "0398",
          },
          {
            name: "卢氏县",
            code: "411224",
            areaCode: "0398",
          },
          {
            name: "义马市",
            code: "411281",
            areaCode: "0398",
          },
          {
            name: "灵宝市",
            code: "411282",
            areaCode: "0398",
          },
        ],
      },
      {
        name: "南阳市",
        code: "411300",
        areaCode: "0377",
        cities: [
          {
            name: "南阳市市辖区",
            code: "411301",
            areaCode: "0377",
          },
          {
            name: "宛城区",
            code: "411302",
            areaCode: "0377",
          },
          {
            name: "卧龙区",
            code: "411303",
            areaCode: "0377",
          },
          {
            name: "南召县",
            code: "411321",
            areaCode: "0377",
          },
          {
            name: "方城县",
            code: "411322",
            areaCode: "0377",
          },
          {
            name: "西峡县",
            code: "411323",
            areaCode: "0377",
          },
          {
            name: "镇平县",
            code: "411324",
            areaCode: "0377",
          },
          {
            name: "内乡县",
            code: "411325",
            areaCode: "0377",
          },
          {
            name: "淅川县",
            code: "411326",
            areaCode: "0377",
          },
          {
            name: "社旗县",
            code: "411327",
            areaCode: "0377",
          },
          {
            name: "唐河县",
            code: "411328",
            areaCode: "0377",
          },
          {
            name: "新野县",
            code: "411329",
            areaCode: "0377",
          },
          {
            name: "桐柏县",
            code: "411330",
            areaCode: "0377",
          },
          {
            name: "邓州市",
            code: "411381",
            areaCode: "0377",
          },
        ],
      },
      {
        name: "商丘市",
        code: "411400",
        areaCode: "0370",
        cities: [
          {
            name: "商丘市市辖区",
            code: "411401",
            areaCode: "0370",
          },
          {
            name: "梁园区",
            code: "411402",
            areaCode: "0370",
          },
          {
            name: "睢阳区",
            code: "411403",
            areaCode: "0370",
          },
          {
            name: "民权县",
            code: "411421",
            areaCode: "0370",
          },
          {
            name: "睢县",
            code: "411422",
            areaCode: "0370",
          },
          {
            name: "宁陵县",
            code: "411423",
            areaCode: "0370",
          },
          {
            name: "柘城县",
            code: "411424",
            areaCode: "0370",
          },
          {
            name: "虞城县",
            code: "411425",
            areaCode: "0370",
          },
          {
            name: "夏邑县",
            code: "411426",
            areaCode: "0370",
          },
          {
            name: "永城市",
            code: "411481",
            areaCode: "0370",
          },
        ],
      },
      {
        name: "信阳市",
        code: "411500",
        areaCode: "0376",
        cities: [
          {
            name: "信阳市市辖区",
            code: "411501",
            areaCode: "0376",
          },
          {
            name: "浉河区",
            code: "411502",
            areaCode: "0376",
          },
          {
            name: "平桥区",
            code: "411503",
            areaCode: "0376",
          },
          {
            name: "罗山县",
            code: "411521",
            areaCode: "0376",
          },
          {
            name: "光山县",
            code: "411522",
            areaCode: "0376",
          },
          {
            name: "新县",
            code: "411523",
            areaCode: "0376",
          },
          {
            name: "商城县",
            code: "411524",
            areaCode: "0376",
          },
          {
            name: "固始县",
            code: "411525",
            areaCode: "0376",
          },
          {
            name: "潢川县",
            code: "411526",
            areaCode: "0376",
          },
          {
            name: "淮滨县",
            code: "411527",
            areaCode: "0376",
          },
          {
            name: "息县",
            code: "411528",
            areaCode: "0376",
          },
        ],
      },
      {
        name: "周口市",
        code: "411600",
        areaCode: "0394",
        cities: [
          {
            name: "周口市市辖区",
            code: "411601",
            areaCode: "0394",
          },
          {
            name: "川汇区",
            code: "411602",
            areaCode: "0394",
          },
          {
            name: "扶沟县",
            code: "411621",
            areaCode: "0394",
          },
          {
            name: "西华县",
            code: "411622",
            areaCode: "0394",
          },
          {
            name: "商水县",
            code: "411623",
            areaCode: "0394",
          },
          {
            name: "沈丘县",
            code: "411624",
            areaCode: "0394",
          },
          {
            name: "郸城县",
            code: "411625",
            areaCode: "0394",
          },
          {
            name: "淮阳区",
            code: "411603",
            areaCode: "0394",
          },
          {
            name: "太康县",
            code: "411627",
            areaCode: "0394",
          },
          {
            name: "鹿邑县",
            code: "411628",
            areaCode: "0394",
          },
          {
            name: "项城市",
            code: "411681",
            areaCode: "0394",
          },
        ],
      },
      {
        name: "驻马店市",
        code: "411700",
        areaCode: "0396",
        cities: [
          {
            name: "驻马店市市辖区",
            code: "411701",
            areaCode: "0396",
          },
          {
            name: "驿城区",
            code: "411702",
            areaCode: "0396",
          },
          {
            name: "西平县",
            code: "411721",
            areaCode: "0396",
          },
          {
            name: "上蔡县",
            code: "411722",
            areaCode: "0396",
          },
          {
            name: "平舆县",
            code: "411723",
            areaCode: "0396",
          },
          {
            name: "正阳县",
            code: "411724",
            areaCode: "0396",
          },
          {
            name: "确山县",
            code: "411725",
            areaCode: "0396",
          },
          {
            name: "泌阳县",
            code: "411726",
            areaCode: "0396",
          },
          {
            name: "汝南县",
            code: "411727",
            areaCode: "0396",
          },
          {
            name: "遂平县",
            code: "411728",
            areaCode: "0396",
          },
          {
            name: "新蔡县",
            code: "411729",
            areaCode: "0396",
          },
        ],
      },
    ],
  },
  {
    name: "湖北省",
    code: "420000",
    areaCode: "",
    cities: [
      {
        name: "武汉市",
        code: "420100",
        areaCode: "027",
        cities: [
          {
            name: "武汉市市辖区",
            code: "420101",
            areaCode: "027",
          },
          {
            name: "江岸区",
            code: "420102",
            areaCode: "027",
          },
          {
            name: "江汉区",
            code: "420103",
            areaCode: "027",
          },
          {
            name: "硚口区",
            code: "420104",
            areaCode: "027",
          },
          {
            name: "汉阳区",
            code: "420105",
            areaCode: "027",
          },
          {
            name: "武昌区",
            code: "420106",
            areaCode: "027",
          },
          {
            name: "青山区",
            code: "420107",
            areaCode: "027",
          },
          {
            name: "洪山区",
            code: "420111",
            areaCode: "027",
          },
          {
            name: "东西湖区",
            code: "420112",
            areaCode: "027",
          },
          {
            name: "汉南区",
            code: "420113",
            areaCode: "027",
          },
          {
            name: "蔡甸区",
            code: "420114",
            areaCode: "027",
          },
          {
            name: "江夏区",
            code: "420115",
            areaCode: "027",
          },
          {
            name: "黄陂区",
            code: "420116",
            areaCode: "027",
          },
          {
            name: "新洲区",
            code: "420117",
            areaCode: "027",
          },
        ],
      },
      {
        name: "黄石市",
        code: "420200",
        areaCode: "0714",
        cities: [
          {
            name: "黄石市市辖区",
            code: "420201",
            areaCode: "0714",
          },
          {
            name: "黄石港区",
            code: "420202",
            areaCode: "0714",
          },
          {
            name: "西塞山区",
            code: "420203",
            areaCode: "0714",
          },
          {
            name: "下陆区",
            code: "420204",
            areaCode: "0714",
          },
          {
            name: "铁山区",
            code: "420205",
            areaCode: "0714",
          },
          {
            name: "阳新县",
            code: "420222",
            areaCode: "0714",
          },
          {
            name: "大冶市",
            code: "420281",
            areaCode: "0714",
          },
        ],
      },
      {
        name: "十堰市",
        code: "420300",
        areaCode: "0719",
        cities: [
          {
            name: "十堰市市辖区",
            code: "420301",
            areaCode: "0719",
          },
          {
            name: "茅箭区",
            code: "420302",
            areaCode: "0719",
          },
          {
            name: "张湾区",
            code: "420303",
            areaCode: "0719",
          },
          {
            name: "郧阳区",
            code: "420304",
            areaCode: "0719",
          },
          {
            name: "郧西县",
            code: "420322",
            areaCode: "0719",
          },
          {
            name: "竹山县",
            code: "420323",
            areaCode: "0719",
          },
          {
            name: "竹溪县",
            code: "420324",
            areaCode: "0719",
          },
          {
            name: "房县",
            code: "420325",
            areaCode: "0719",
          },
          {
            name: "丹江口市",
            code: "420381",
            areaCode: "0719",
          },
        ],
      },
      {
        name: "宜昌市",
        code: "420500",
        areaCode: "0717",
        cities: [
          {
            name: "宜昌市市辖区",
            code: "420501",
            areaCode: "0717",
          },
          {
            name: "西陵区",
            code: "420502",
            areaCode: "0717",
          },
          {
            name: "伍家岗区",
            code: "420503",
            areaCode: "0717",
          },
          {
            name: "点军区",
            code: "420504",
            areaCode: "0717",
          },
          {
            name: "猇亭区",
            code: "420505",
            areaCode: "0717",
          },
          {
            name: "夷陵区",
            code: "420506",
            areaCode: "0717",
          },
          {
            name: "远安县",
            code: "420525",
            areaCode: "0717",
          },
          {
            name: "兴山县",
            code: "420526",
            areaCode: "0717",
          },
          {
            name: "秭归县",
            code: "420527",
            areaCode: "0717",
          },
          {
            name: "长阳土家族自治县",
            code: "420528",
            areaCode: "0717",
          },
          {
            name: "五峰土家族自治县",
            code: "420529",
            areaCode: "0717",
          },
          {
            name: "宜都市",
            code: "420581",
            areaCode: "0717",
          },
          {
            name: "当阳市",
            code: "420582",
            areaCode: "0717",
          },
          {
            name: "枝江市",
            code: "420583",
            areaCode: "0717",
          },
        ],
      },
      {
        name: "襄阳市",
        code: "420600",
        areaCode: "0710",
        cities: [
          {
            name: "襄阳市市辖区",
            code: "420601",
            areaCode: "0710",
          },
          {
            name: "襄城区",
            code: "420602",
            areaCode: "0710",
          },
          {
            name: "樊城区",
            code: "420606",
            areaCode: "0710",
          },
          {
            name: "襄州区",
            code: "420607",
            areaCode: "0710",
          },
          {
            name: "南漳县",
            code: "420624",
            areaCode: "0710",
          },
          {
            name: "谷城县",
            code: "420625",
            areaCode: "0710",
          },
          {
            name: "保康县",
            code: "420626",
            areaCode: "0710",
          },
          {
            name: "老河口市",
            code: "420682",
            areaCode: "0710",
          },
          {
            name: "枣阳市",
            code: "420683",
            areaCode: "0710",
          },
          {
            name: "宜城市",
            code: "420684",
            areaCode: "0710",
          },
        ],
      },
      {
        name: "鄂州市",
        code: "420700",
        areaCode: "0711",
        cities: [
          {
            name: "鄂州市市辖区",
            code: "420701",
            areaCode: "0711",
          },
          {
            name: "梁子湖区",
            code: "420702",
            areaCode: "0711",
          },
          {
            name: "华容区",
            code: "420703",
            areaCode: "0711",
          },
          {
            name: "鄂城区",
            code: "420704",
            areaCode: "0711",
          },
        ],
      },
      {
        name: "荆门市",
        code: "420800",
        areaCode: "0724",
        cities: [
          {
            name: "荆门市市辖区",
            code: "420801",
            areaCode: "0724",
          },
          {
            name: "东宝区",
            code: "420802",
            areaCode: "0724",
          },
          {
            name: "掇刀区",
            code: "420804",
            areaCode: "0724",
          },
          {
            name: "京山市",
            code: "420882",
            areaCode: "0724",
          },
          {
            name: "沙洋县",
            code: "420822",
            areaCode: "0724",
          },
          {
            name: "钟祥市",
            code: "420881",
            areaCode: "0724",
          },
        ],
      },
      {
        name: "孝感市",
        code: "420900",
        areaCode: "0712",
        cities: [
          {
            name: "孝感市市辖区",
            code: "420901",
            areaCode: "0712",
          },
          {
            name: "孝南区",
            code: "420902",
            areaCode: "0712",
          },
          {
            name: "孝昌县",
            code: "420921",
            areaCode: "0712",
          },
          {
            name: "大悟县",
            code: "420922",
            areaCode: "0712",
          },
          {
            name: "云梦县",
            code: "420923",
            areaCode: "0712",
          },
          {
            name: "应城市",
            code: "420981",
            areaCode: "0712",
          },
          {
            name: "安陆市",
            code: "420982",
            areaCode: "0712",
          },
          {
            name: "汉川市",
            code: "420984",
            areaCode: "0712",
          },
        ],
      },
      {
        name: "荆州市",
        code: "421000",
        areaCode: "0716",
        cities: [
          {
            name: "荆州市市辖区",
            code: "421001",
            areaCode: "0716",
          },
          {
            name: "沙市区",
            code: "421002",
            areaCode: "0716",
          },
          {
            name: "荆州区",
            code: "421003",
            areaCode: "0716",
          },
          {
            name: "公安县",
            code: "421022",
            areaCode: "0716",
          },
          {
            name: "监利市",
            code: "421023",
            areaCode: "0716",
          },
          {
            name: "江陵县",
            code: "421024",
            areaCode: "0716",
          },
          {
            name: "石首市",
            code: "421081",
            areaCode: "0716",
          },
          {
            name: "洪湖市",
            code: "421083",
            areaCode: "0716",
          },
          {
            name: "松滋市",
            code: "421087",
            areaCode: "0716",
          },
        ],
      },
      {
        name: "黄冈市",
        code: "421100",
        areaCode: "0713",
        cities: [
          {
            name: "黄冈市市辖区",
            code: "421101",
            areaCode: "0713",
          },
          {
            name: "黄州区",
            code: "421102",
            areaCode: "0713",
          },
          {
            name: "团风县",
            code: "421121",
            areaCode: "0713",
          },
          {
            name: "红安县",
            code: "421122",
            areaCode: "0713",
          },
          {
            name: "罗田县",
            code: "421123",
            areaCode: "0713",
          },
          {
            name: "英山县",
            code: "421124",
            areaCode: "0713",
          },
          {
            name: "浠水县",
            code: "421125",
            areaCode: "0713",
          },
          {
            name: "蕲春县",
            code: "421126",
            areaCode: "0713",
          },
          {
            name: "黄梅县",
            code: "421127",
            areaCode: "0713",
          },
          {
            name: "麻城市",
            code: "421181",
            areaCode: "0713",
          },
          {
            name: "武穴市",
            code: "421182",
            areaCode: "0713",
          },
        ],
      },
      {
        name: "咸宁市",
        code: "421200",
        areaCode: "0715",
        cities: [
          {
            name: "咸宁市市辖区",
            code: "421201",
            areaCode: "0715",
          },
          {
            name: "咸安区",
            code: "421202",
            areaCode: "0715",
          },
          {
            name: "嘉鱼县",
            code: "421221",
            areaCode: "0715",
          },
          {
            name: "通城县",
            code: "421222",
            areaCode: "0715",
          },
          {
            name: "崇阳县",
            code: "421223",
            areaCode: "0715",
          },
          {
            name: "通山县",
            code: "421224",
            areaCode: "0715",
          },
          {
            name: "赤壁市",
            code: "421281",
            areaCode: "0715",
          },
        ],
      },
      {
        name: "随州市",
        code: "421300",
        areaCode: "0722",
        cities: [
          {
            name: "随州市市辖区",
            code: "421301",
            areaCode: "0722",
          },
          {
            name: "曾都区",
            code: "421303",
            areaCode: "0722",
          },
          {
            name: "随县",
            code: "421321",
            areaCode: "0722",
          },
          {
            name: "广水市",
            code: "421381",
            areaCode: "0722",
          },
        ],
      },
      {
        name: "恩施土家族苗族自治州",
        code: "422800",
        areaCode: "0718",
        cities: [
          {
            name: "恩施市",
            code: "422801",
            areaCode: "0718",
          },
          {
            name: "利川市",
            code: "422802",
            areaCode: "0718",
          },
          {
            name: "建始县",
            code: "422822",
            areaCode: "0718",
          },
          {
            name: "巴东县",
            code: "422823",
            areaCode: "0718",
          },
          {
            name: "宣恩县",
            code: "422825",
            areaCode: "0718",
          },
          {
            name: "咸丰县",
            code: "422826",
            areaCode: "0718",
          },
          {
            name: "来凤县",
            code: "422827",
            areaCode: "0718",
          },
          {
            name: "鹤峰县",
            code: "422828",
            areaCode: "0718",
          },
        ],
      },
    ],
  },
  {
    name: "湖南省",
    code: "430000",
    areaCode: "",
    cities: [
      {
        name: "长沙市",
        code: "430100",
        areaCode: "0731",
        cities: [
          {
            name: "长沙市市辖区",
            code: "430101",
            areaCode: "0731",
          },
          {
            name: "芙蓉区",
            code: "430102",
            areaCode: "0731",
          },
          {
            name: "天心区",
            code: "430103",
            areaCode: "0731",
          },
          {
            name: "岳麓区",
            code: "430104",
            areaCode: "0731",
          },
          {
            name: "开福区",
            code: "430105",
            areaCode: "0731",
          },
          {
            name: "雨花区",
            code: "430111",
            areaCode: "0731",
          },
          {
            name: "望城区",
            code: "430112",
            areaCode: "0731",
          },
          {
            name: "长沙县",
            code: "430121",
            areaCode: "0731",
          },
          {
            name: "浏阳市",
            code: "430181",
            areaCode: "0731",
          },
          {
            name: "宁乡市",
            code: "430182",
            areaCode: "0731",
          },
        ],
      },
      {
        name: "株洲市",
        code: "430200",
        areaCode: "0733",
        cities: [
          {
            name: "株洲市市辖区",
            code: "430201",
            areaCode: "0733",
          },
          {
            name: "荷塘区",
            code: "430202",
            areaCode: "0733",
          },
          {
            name: "芦淞区",
            code: "430203",
            areaCode: "0733",
          },
          {
            name: "石峰区",
            code: "430204",
            areaCode: "0733",
          },
          {
            name: "天元区",
            code: "430211",
            areaCode: "0733",
          },
          {
            name: "渌口区",
            code: "430212",
            areaCode: "0733",
          },
          {
            name: "攸县",
            code: "430223",
            areaCode: "0733",
          },
          {
            name: "茶陵县",
            code: "430224",
            areaCode: "0733",
          },
          {
            name: "炎陵县",
            code: "430225",
            areaCode: "0733",
          },
          {
            name: "醴陵市",
            code: "430281",
            areaCode: "0733",
          },
        ],
      },
      {
        name: "湘潭市",
        code: "430300",
        areaCode: "0732",
        cities: [
          {
            name: "湘潭市市辖区",
            code: "430301",
            areaCode: "0732",
          },
          {
            name: "雨湖区",
            code: "430302",
            areaCode: "0732",
          },
          {
            name: "岳塘区",
            code: "430304",
            areaCode: "0732",
          },
          {
            name: "湘潭县",
            code: "430321",
            areaCode: "0732",
          },
          {
            name: "湘乡市",
            code: "430381",
            areaCode: "0732",
          },
          {
            name: "韶山市",
            code: "430382",
            areaCode: "0732",
          },
        ],
      },
      {
        name: "衡阳市",
        code: "430400",
        areaCode: "0734",
        cities: [
          {
            name: "衡阳市市辖区",
            code: "430401",
            areaCode: "0734",
          },
          {
            name: "珠晖区",
            code: "430405",
            areaCode: "0734",
          },
          {
            name: "雁峰区",
            code: "430406",
            areaCode: "0734",
          },
          {
            name: "石鼓区",
            code: "430407",
            areaCode: "0734",
          },
          {
            name: "蒸湘区",
            code: "430408",
            areaCode: "0734",
          },
          {
            name: "南岳区",
            code: "430412",
            areaCode: "0734",
          },
          {
            name: "衡阳县",
            code: "430421",
            areaCode: "0734",
          },
          {
            name: "衡南县",
            code: "430422",
            areaCode: "0734",
          },
          {
            name: "衡山县",
            code: "430423",
            areaCode: "0734",
          },
          {
            name: "衡东县",
            code: "430424",
            areaCode: "0734",
          },
          {
            name: "祁东县",
            code: "430426",
            areaCode: "0734",
          },
          {
            name: "耒阳市",
            code: "430481",
            areaCode: "0734",
          },
          {
            name: "常宁市",
            code: "430482",
            areaCode: "0734",
          },
        ],
      },
      {
        name: "邵阳市",
        code: "430500",
        areaCode: "0739",
        cities: [
          {
            name: "邵阳市市辖区",
            code: "430501",
            areaCode: "0739",
          },
          {
            name: "双清区",
            code: "430502",
            areaCode: "0739",
          },
          {
            name: "大祥区",
            code: "430503",
            areaCode: "0739",
          },
          {
            name: "北塔区",
            code: "430511",
            areaCode: "0739",
          },
          {
            name: "邵东市",
            code: "430582",
            areaCode: "0739",
          },
          {
            name: "新邵县",
            code: "430522",
            areaCode: "0739",
          },
          {
            name: "邵阳县",
            code: "430523",
            areaCode: "0739",
          },
          {
            name: "隆回县",
            code: "430524",
            areaCode: "0739",
          },
          {
            name: "洞口县",
            code: "430525",
            areaCode: "0739",
          },
          {
            name: "绥宁县",
            code: "430527",
            areaCode: "0739",
          },
          {
            name: "新宁县",
            code: "430528",
            areaCode: "0739",
          },
          {
            name: "城步苗族自治县",
            code: "430529",
            areaCode: "0739",
          },
          {
            name: "武冈市",
            code: "430581",
            areaCode: "0739",
          },
        ],
      },
      {
        name: "岳阳市",
        code: "430600",
        areaCode: "0730",
        cities: [
          {
            name: "岳阳市市辖区",
            code: "430601",
            areaCode: "0730",
          },
          {
            name: "岳阳楼区",
            code: "430602",
            areaCode: "0730",
          },
          {
            name: "云溪区",
            code: "430603",
            areaCode: "0730",
          },
          {
            name: "君山区",
            code: "430611",
            areaCode: "0730",
          },
          {
            name: "岳阳县",
            code: "430621",
            areaCode: "0730",
          },
          {
            name: "华容县",
            code: "430623",
            areaCode: "0730",
          },
          {
            name: "湘阴县",
            code: "430624",
            areaCode: "0730",
          },
          {
            name: "平江县",
            code: "430626",
            areaCode: "0730",
          },
          {
            name: "汨罗市",
            code: "430681",
            areaCode: "0730",
          },
          {
            name: "临湘市",
            code: "430682",
            areaCode: "0730",
          },
        ],
      },
      {
        name: "常德市",
        code: "430700",
        areaCode: "0736",
        cities: [
          {
            name: "常德市市辖区",
            code: "430701",
            areaCode: "0736",
          },
          {
            name: "武陵区",
            code: "430702",
            areaCode: "0736",
          },
          {
            name: "鼎城区",
            code: "430703",
            areaCode: "0736",
          },
          {
            name: "安乡县",
            code: "430721",
            areaCode: "0736",
          },
          {
            name: "汉寿县",
            code: "430722",
            areaCode: "0736",
          },
          {
            name: "澧县",
            code: "430723",
            areaCode: "0736",
          },
          {
            name: "临澧县",
            code: "430724",
            areaCode: "0736",
          },
          {
            name: "桃源县",
            code: "430725",
            areaCode: "0736",
          },
          {
            name: "石门县",
            code: "430726",
            areaCode: "0736",
          },
          {
            name: "津市市",
            code: "430781",
            areaCode: "0736",
          },
        ],
      },
      {
        name: "张家界市",
        code: "430800",
        areaCode: "0744",
        cities: [
          {
            name: "张家界市市辖区",
            code: "430801",
            areaCode: "0744",
          },
          {
            name: "永定区",
            code: "430802",
            areaCode: "0744",
          },
          {
            name: "武陵源区",
            code: "430811",
            areaCode: "0744",
          },
          {
            name: "慈利县",
            code: "430821",
            areaCode: "0744",
          },
          {
            name: "桑植县",
            code: "430822",
            areaCode: "0744",
          },
        ],
      },
      {
        name: "益阳市",
        code: "430900",
        areaCode: "0737",
        cities: [
          {
            name: "益阳市市辖区",
            code: "430901",
            areaCode: "0737",
          },
          {
            name: "资阳区",
            code: "430902",
            areaCode: "0737",
          },
          {
            name: "赫山区",
            code: "430903",
            areaCode: "0737",
          },
          {
            name: "南县",
            code: "430921",
            areaCode: "0737",
          },
          {
            name: "桃江县",
            code: "430922",
            areaCode: "0737",
          },
          {
            name: "安化县",
            code: "430923",
            areaCode: "0737",
          },
          {
            name: "沅江市",
            code: "430981",
            areaCode: "0737",
          },
        ],
      },
      {
        name: "郴州市",
        code: "431000",
        areaCode: "0735",
        cities: [
          {
            name: "郴州市市辖区",
            code: "431001",
            areaCode: "0735",
          },
          {
            name: "北湖区",
            code: "431002",
            areaCode: "0735",
          },
          {
            name: "苏仙区",
            code: "431003",
            areaCode: "0735",
          },
          {
            name: "桂阳县",
            code: "431021",
            areaCode: "0735",
          },
          {
            name: "宜章县",
            code: "431022",
            areaCode: "0735",
          },
          {
            name: "永兴县",
            code: "431023",
            areaCode: "0735",
          },
          {
            name: "嘉禾县",
            code: "431024",
            areaCode: "0735",
          },
          {
            name: "临武县",
            code: "431025",
            areaCode: "0735",
          },
          {
            name: "汝城县",
            code: "431026",
            areaCode: "0735",
          },
          {
            name: "桂东县",
            code: "431027",
            areaCode: "0735",
          },
          {
            name: "安仁县",
            code: "431028",
            areaCode: "0735",
          },
          {
            name: "资兴市",
            code: "431081",
            areaCode: "0735",
          },
        ],
      },
      {
        name: "永州市",
        code: "431100",
        areaCode: "0746",
        cities: [
          {
            name: "永州市市辖区",
            code: "431101",
            areaCode: "0746",
          },
          {
            name: "零陵区",
            code: "431102",
            areaCode: "0746",
          },
          {
            name: "冷水滩区",
            code: "431103",
            areaCode: "0746",
          },
          {
            name: "祁阳县",
            code: "431121",
            areaCode: "0746",
          },
          {
            name: "东安县",
            code: "431122",
            areaCode: "0746",
          },
          {
            name: "双牌县",
            code: "431123",
            areaCode: "0746",
          },
          {
            name: "道县",
            code: "431124",
            areaCode: "0746",
          },
          {
            name: "江永县",
            code: "431125",
            areaCode: "0746",
          },
          {
            name: "宁远县",
            code: "431126",
            areaCode: "0746",
          },
          {
            name: "蓝山县",
            code: "431127",
            areaCode: "0746",
          },
          {
            name: "新田县",
            code: "431128",
            areaCode: "0746",
          },
          {
            name: "江华瑶族自治县",
            code: "431129",
            areaCode: "0746",
          },
        ],
      },
      {
        name: "怀化市",
        code: "431200",
        areaCode: "0745",
        cities: [
          {
            name: "怀化市市辖区",
            code: "431201",
            areaCode: "0745",
          },
          {
            name: "鹤城区",
            code: "431202",
            areaCode: "0745",
          },
          {
            name: "中方县",
            code: "431221",
            areaCode: "0745",
          },
          {
            name: "沅陵县",
            code: "431222",
            areaCode: "0745",
          },
          {
            name: "辰溪县",
            code: "431223",
            areaCode: "0745",
          },
          {
            name: "溆浦县",
            code: "431224",
            areaCode: "0745",
          },
          {
            name: "会同县",
            code: "431225",
            areaCode: "0745",
          },
          {
            name: "麻阳苗族自治县",
            code: "431226",
            areaCode: "0745",
          },
          {
            name: "新晃侗族自治县",
            code: "431227",
            areaCode: "0745",
          },
          {
            name: "芷江侗族自治县",
            code: "431228",
            areaCode: "0745",
          },
          {
            name: "靖州苗族侗族自治县",
            code: "431229",
            areaCode: "0745",
          },
          {
            name: "通道侗族自治县",
            code: "431230",
            areaCode: "0745",
          },
          {
            name: "洪江市",
            code: "431281",
            areaCode: "0745",
          },
        ],
      },
      {
        name: "娄底市",
        code: "431300",
        areaCode: "0738",
        cities: [
          {
            name: "娄底市市辖区",
            code: "431301",
            areaCode: "0738",
          },
          {
            name: "娄星区",
            code: "431302",
            areaCode: "0738",
          },
          {
            name: "双峰县",
            code: "431321",
            areaCode: "0738",
          },
          {
            name: "新化县",
            code: "431322",
            areaCode: "0738",
          },
          {
            name: "冷水江市",
            code: "431381",
            areaCode: "0738",
          },
          {
            name: "涟源市",
            code: "431382",
            areaCode: "0738",
          },
        ],
      },
      {
        name: "湘西土家族苗族自治州",
        code: "433100",
        areaCode: "0743",
        cities: [
          {
            name: "吉首市",
            code: "433101",
            areaCode: "0743",
          },
          {
            name: "泸溪县",
            code: "433122",
            areaCode: "0743",
          },
          {
            name: "凤凰县",
            code: "433123",
            areaCode: "0743",
          },
          {
            name: "花垣县",
            code: "433124",
            areaCode: "0743",
          },
          {
            name: "保靖县",
            code: "433125",
            areaCode: "0743",
          },
          {
            name: "古丈县",
            code: "433126",
            areaCode: "0743",
          },
          {
            name: "永顺县",
            code: "433127",
            areaCode: "0743",
          },
          {
            name: "龙山县",
            code: "433130",
            areaCode: "0743",
          },
        ],
      },
    ],
  },
  {
    name: "广东省",
    code: "440000",
    areaCode: "",
    cities: [
      {
        name: "广州市",
        code: "440100",
        areaCode: "020",
        cities: [
          {
            name: "广州市市辖区",
            code: "440101",
            areaCode: "020",
          },
          {
            name: "荔湾区",
            code: "440103",
            areaCode: "020",
          },
          {
            name: "越秀区",
            code: "440104",
            areaCode: "020",
          },
          {
            name: "海珠区",
            code: "440105",
            areaCode: "020",
          },
          {
            name: "天河区",
            code: "440106",
            areaCode: "020",
          },
          {
            name: "白云区",
            code: "440111",
            areaCode: "020",
          },
          {
            name: "黄埔区",
            code: "440112",
            areaCode: "020",
          },
          {
            name: "番禺区",
            code: "440113",
            areaCode: "020",
          },
          {
            name: "花都区",
            code: "440114",
            areaCode: "020",
          },
          {
            name: "南沙区",
            code: "440115",
            areaCode: "020",
          },
          {
            name: "从化区",
            code: "440117",
            areaCode: "020",
          },
          {
            name: "增城区",
            code: "440118",
            areaCode: "020",
          },
        ],
      },
      {
        name: "韶关市",
        code: "440200",
        areaCode: "0751",
        cities: [
          {
            name: "韶关市市辖区",
            code: "440201",
            areaCode: "0751",
          },
          {
            name: "武江区",
            code: "440203",
            areaCode: "0751",
          },
          {
            name: "浈江区",
            code: "440204",
            areaCode: "0751",
          },
          {
            name: "曲江区",
            code: "440205",
            areaCode: "0751",
          },
          {
            name: "始兴县",
            code: "440222",
            areaCode: "0751",
          },
          {
            name: "仁化县",
            code: "440224",
            areaCode: "0751",
          },
          {
            name: "翁源县",
            code: "440229",
            areaCode: "0751",
          },
          {
            name: "乳源瑶族自治县",
            code: "440232",
            areaCode: "0751",
          },
          {
            name: "新丰县",
            code: "440233",
            areaCode: "0751",
          },
          {
            name: "乐昌市",
            code: "440281",
            areaCode: "0751",
          },
          {
            name: "南雄市",
            code: "440282",
            areaCode: "0751",
          },
        ],
      },
      {
        name: "深圳市",
        code: "440300",
        areaCode: "0755",
        cities: [
          {
            name: "深圳市市辖区",
            code: "440301",
            areaCode: "0755",
          },
          {
            name: "罗湖区",
            code: "440303",
            areaCode: "0755",
          },
          {
            name: "福田区",
            code: "440304",
            areaCode: "0755",
          },
          {
            name: "南山区",
            code: "440305",
            areaCode: "0755",
          },
          {
            name: "宝安区",
            code: "440306",
            areaCode: "0755",
          },
          {
            name: "龙岗区",
            code: "440307",
            areaCode: "0755",
          },
          {
            name: "盐田区",
            code: "440308",
            areaCode: "0755",
          },
          {
            name: "龙华区",
            code: "440309",
            areaCode: "0755",
          },
          {
            name: "坪山区",
            code: "440310",
            areaCode: "0755",
          },
          {
            name: "光明区",
            code: "440311",
            areaCode: "0755",
          },
        ],
      },
      {
        name: "珠海市",
        code: "440400",
        areaCode: "0756",
        cities: [
          {
            name: "珠海市市辖区",
            code: "440401",
            areaCode: "0756",
          },
          {
            name: "香洲区",
            code: "440402",
            areaCode: "0756",
          },
          {
            name: "斗门区",
            code: "440403",
            areaCode: "0756",
          },
          {
            name: "金湾区",
            code: "440404",
            areaCode: "0756",
          },
        ],
      },
      {
        name: "汕头市",
        code: "440500",
        areaCode: "0754",
        cities: [
          {
            name: "汕头市市辖区",
            code: "440501",
            areaCode: "0754",
          },
          {
            name: "龙湖区",
            code: "440507",
            areaCode: "0754",
          },
          {
            name: "金平区",
            code: "440511",
            areaCode: "0754",
          },
          {
            name: "濠江区",
            code: "440512",
            areaCode: "0754",
          },
          {
            name: "潮阳区",
            code: "440513",
            areaCode: "0754",
          },
          {
            name: "潮南区",
            code: "440514",
            areaCode: "0754",
          },
          {
            name: "澄海区",
            code: "440515",
            areaCode: "0754",
          },
          {
            name: "南澳县",
            code: "440523",
            areaCode: "0754",
          },
        ],
      },
      {
        name: "佛山市",
        code: "440600",
        areaCode: "0757",
        cities: [
          {
            name: "佛山市市辖区",
            code: "440601",
            areaCode: "0757",
          },
          {
            name: "禅城区",
            code: "440604",
            areaCode: "0757",
          },
          {
            name: "南海区",
            code: "440605",
            areaCode: "0757",
          },
          {
            name: "顺德区",
            code: "440606",
            areaCode: "0757",
          },
          {
            name: "三水区",
            code: "440607",
            areaCode: "0757",
          },
          {
            name: "高明区",
            code: "440608",
            areaCode: "0757",
          },
        ],
      },
      {
        name: "江门市",
        code: "440700",
        areaCode: "0750",
        cities: [
          {
            name: "江门市市辖区",
            code: "440701",
            areaCode: "0750",
          },
          {
            name: "蓬江区",
            code: "440703",
            areaCode: "0750",
          },
          {
            name: "江海区",
            code: "440704",
            areaCode: "0750",
          },
          {
            name: "新会区",
            code: "440705",
            areaCode: "0750",
          },
          {
            name: "台山市",
            code: "440781",
            areaCode: "0750",
          },
          {
            name: "开平市",
            code: "440783",
            areaCode: "0750",
          },
          {
            name: "鹤山市",
            code: "440784",
            areaCode: "0750",
          },
          {
            name: "恩平市",
            code: "440785",
            areaCode: "0750",
          },
        ],
      },
      {
        name: "湛江市",
        code: "440800",
        areaCode: "0759",
        cities: [
          {
            name: "湛江市市辖区",
            code: "440801",
            areaCode: "0759",
          },
          {
            name: "赤坎区",
            code: "440802",
            areaCode: "0759",
          },
          {
            name: "霞山区",
            code: "440803",
            areaCode: "0759",
          },
          {
            name: "坡头区",
            code: "440804",
            areaCode: "0759",
          },
          {
            name: "麻章区",
            code: "440811",
            areaCode: "0759",
          },
          {
            name: "遂溪县",
            code: "440823",
            areaCode: "0759",
          },
          {
            name: "徐闻县",
            code: "440825",
            areaCode: "0759",
          },
          {
            name: "廉江市",
            code: "440881",
            areaCode: "0759",
          },
          {
            name: "雷州市",
            code: "440882",
            areaCode: "0759",
          },
          {
            name: "吴川市",
            code: "440883",
            areaCode: "0759",
          },
        ],
      },
      {
        name: "茂名市",
        code: "440900",
        areaCode: "0668",
        cities: [
          {
            name: "茂名市市辖区",
            code: "440901",
            areaCode: "0668",
          },
          {
            name: "茂南区",
            code: "440902",
            areaCode: "0668",
          },
          {
            name: "电白区",
            code: "440904",
            areaCode: "0668",
          },
          {
            name: "高州市",
            code: "440981",
            areaCode: "0668",
          },
          {
            name: "化州市",
            code: "440982",
            areaCode: "0668",
          },
          {
            name: "信宜市",
            code: "440983",
            areaCode: "0668",
          },
        ],
      },
      {
        name: "肇庆市",
        code: "441200",
        areaCode: "0758",
        cities: [
          {
            name: "肇庆市市辖区",
            code: "441201",
            areaCode: "0758",
          },
          {
            name: "端州区",
            code: "441202",
            areaCode: "0758",
          },
          {
            name: "鼎湖区",
            code: "441203",
            areaCode: "0758",
          },
          {
            name: "高要区",
            code: "441204",
            areaCode: "0758",
          },
          {
            name: "广宁县",
            code: "441223",
            areaCode: "0758",
          },
          {
            name: "怀集县",
            code: "441224",
            areaCode: "0758",
          },
          {
            name: "封开县",
            code: "441225",
            areaCode: "0758",
          },
          {
            name: "德庆县",
            code: "441226",
            areaCode: "0758",
          },
          {
            name: "四会市",
            code: "441284",
            areaCode: "0758",
          },
        ],
      },
      {
        name: "惠州市",
        code: "441300",
        areaCode: "0752",
        cities: [
          {
            name: "惠州市市辖区",
            code: "441301",
            areaCode: "0752",
          },
          {
            name: "惠城区",
            code: "441302",
            areaCode: "0752",
          },
          {
            name: "惠阳区",
            code: "441303",
            areaCode: "0752",
          },
          {
            name: "博罗县",
            code: "441322",
            areaCode: "0752",
          },
          {
            name: "惠东县",
            code: "441323",
            areaCode: "0752",
          },
          {
            name: "龙门县",
            code: "441324",
            areaCode: "0752",
          },
        ],
      },
      {
        name: "梅州市",
        code: "441400",
        areaCode: "0753",
        cities: [
          {
            name: "梅州市市辖区",
            code: "441401",
            areaCode: "0753",
          },
          {
            name: "梅江区",
            code: "441402",
            areaCode: "0753",
          },
          {
            name: "梅县区",
            code: "441403",
            areaCode: "0753",
          },
          {
            name: "大埔县",
            code: "441422",
            areaCode: "0753",
          },
          {
            name: "丰顺县",
            code: "441423",
            areaCode: "0753",
          },
          {
            name: "五华县",
            code: "441424",
            areaCode: "0753",
          },
          {
            name: "平远县",
            code: "441426",
            areaCode: "0753",
          },
          {
            name: "蕉岭县",
            code: "441427",
            areaCode: "0753",
          },
          {
            name: "兴宁市",
            code: "441481",
            areaCode: "0753",
          },
        ],
      },
      {
        name: "汕尾市",
        code: "441500",
        areaCode: "0660",
        cities: [
          {
            name: "汕尾市市辖区",
            code: "441501",
            areaCode: "0660",
          },
          {
            name: "城区",
            code: "441502",
            areaCode: "0660",
          },
          {
            name: "海丰县",
            code: "441521",
            areaCode: "0660",
          },
          {
            name: "陆河县",
            code: "441523",
            areaCode: "0660",
          },
          {
            name: "陆丰市",
            code: "441581",
            areaCode: "0660",
          },
        ],
      },
      {
        name: "河源市",
        code: "441600",
        areaCode: "0762",
        cities: [
          {
            name: "河源市市辖区",
            code: "441601",
            areaCode: "0762",
          },
          {
            name: "源城区",
            code: "441602",
            areaCode: "0762",
          },
          {
            name: "紫金县",
            code: "441621",
            areaCode: "0762",
          },
          {
            name: "龙川县",
            code: "441622",
            areaCode: "0762",
          },
          {
            name: "连平县",
            code: "441623",
            areaCode: "0762",
          },
          {
            name: "和平县",
            code: "441624",
            areaCode: "0762",
          },
          {
            name: "东源县",
            code: "441625",
            areaCode: "0762",
          },
        ],
      },
      {
        name: "阳江市",
        code: "441700",
        areaCode: "0662",
        cities: [
          {
            name: "阳江市市辖区",
            code: "441701",
            areaCode: "0662",
          },
          {
            name: "江城区",
            code: "441702",
            areaCode: "0662",
          },
          {
            name: "阳东区",
            code: "441704",
            areaCode: "0662",
          },
          {
            name: "阳西县",
            code: "441721",
            areaCode: "0662",
          },
          {
            name: "阳春市",
            code: "441781",
            areaCode: "0662",
          },
        ],
      },
      {
        name: "清远市",
        code: "441800",
        areaCode: "0763",
        cities: [
          {
            name: "清远市市辖区",
            code: "441801",
            areaCode: "0763",
          },
          {
            name: "清城区",
            code: "441802",
            areaCode: "0763",
          },
          {
            name: "清新区",
            code: "441803",
            areaCode: "0763",
          },
          {
            name: "佛冈县",
            code: "441821",
            areaCode: "0763",
          },
          {
            name: "阳山县",
            code: "441823",
            areaCode: "0763",
          },
          {
            name: "连山壮族瑶族自治县",
            code: "441825",
            areaCode: "0763",
          },
          {
            name: "连南瑶族自治县",
            code: "441826",
            areaCode: "0763",
          },
          {
            name: "英德市",
            code: "441881",
            areaCode: "0763",
          },
          {
            name: "连州市",
            code: "441882",
            areaCode: "0763",
          },
        ],
      },
      {
        name: "东莞市",
        code: "441900",
        areaCode: "0769",
        cities: [],
      },
      {
        name: "中山市",
        code: "442000",
        areaCode: "0760",
        cities: [],
      },
      {
        name: "潮州市",
        code: "445100",
        areaCode: "0768",
        cities: [
          {
            name: "潮州市市辖区",
            code: "445101",
            areaCode: "0768",
          },
          {
            name: "湘桥区",
            code: "445102",
            areaCode: "0768",
          },
          {
            name: "潮安区",
            code: "445103",
            areaCode: "0768",
          },
          {
            name: "饶平县",
            code: "445122",
            areaCode: "0768",
          },
        ],
      },
      {
        name: "揭阳市",
        code: "445200",
        areaCode: "0663",
        cities: [
          {
            name: "揭阳市市辖区",
            code: "445201",
            areaCode: "0663",
          },
          {
            name: "榕城区",
            code: "445202",
            areaCode: "0663",
          },
          {
            name: "揭东区",
            code: "445203",
            areaCode: "0663",
          },
          {
            name: "揭西县",
            code: "445222",
            areaCode: "0663",
          },
          {
            name: "惠来县",
            code: "445224",
            areaCode: "0663",
          },
          {
            name: "普宁市",
            code: "445281",
            areaCode: "0663",
          },
        ],
      },
      {
        name: "云浮市",
        code: "445300",
        areaCode: "0766",
        cities: [
          {
            name: "云浮市市辖区",
            code: "445301",
            areaCode: "0766",
          },
          {
            name: "云城区",
            code: "445302",
            areaCode: "0766",
          },
          {
            name: "云安区",
            code: "445303",
            areaCode: "0766",
          },
          {
            name: "新兴县",
            code: "445321",
            areaCode: "0766",
          },
          {
            name: "郁南县",
            code: "445322",
            areaCode: "0766",
          },
          {
            name: "罗定市",
            code: "445381",
            areaCode: "0766",
          },
        ],
      },
    ],
  },
  {
    name: "广西壮族自治区",
    code: "450000",
    areaCode: "",
    cities: [
      {
        name: "南宁市",
        code: "450100",
        areaCode: "0771",
        cities: [
          {
            name: "南宁市市辖区",
            code: "450101",
            areaCode: "0771",
          },
          {
            name: "兴宁区",
            code: "450102",
            areaCode: "0771",
          },
          {
            name: "青秀区",
            code: "450103",
            areaCode: "0771",
          },
          {
            name: "江南区",
            code: "450105",
            areaCode: "0771",
          },
          {
            name: "西乡塘区",
            code: "450107",
            areaCode: "0771",
          },
          {
            name: "良庆区",
            code: "450108",
            areaCode: "0771",
          },
          {
            name: "邕宁区",
            code: "450109",
            areaCode: "0771",
          },
          {
            name: "武鸣区",
            code: "450110",
            areaCode: "0771",
          },
          {
            name: "隆安县",
            code: "450123",
            areaCode: "0771",
          },
          {
            name: "马山县",
            code: "450124",
            areaCode: "0771",
          },
          {
            name: "上林县",
            code: "450125",
            areaCode: "0771",
          },
          {
            name: "宾阳县",
            code: "450126",
            areaCode: "0771",
          },
          {
            name: "横县",
            code: "450127",
            areaCode: "0771",
          },
        ],
      },
      {
        name: "柳州市",
        code: "450200",
        areaCode: "0772",
        cities: [
          {
            name: "柳州市市辖区",
            code: "450201",
            areaCode: "0772",
          },
          {
            name: "城中区",
            code: "450202",
            areaCode: "0772",
          },
          {
            name: "鱼峰区",
            code: "450203",
            areaCode: "0772",
          },
          {
            name: "柳南区",
            code: "450204",
            areaCode: "0772",
          },
          {
            name: "柳北区",
            code: "450205",
            areaCode: "0772",
          },
          {
            name: "柳江区",
            code: "450206",
            areaCode: "0772",
          },
          {
            name: "柳城县",
            code: "450222",
            areaCode: "0772",
          },
          {
            name: "鹿寨县",
            code: "450223",
            areaCode: "0772",
          },
          {
            name: "融安县",
            code: "450224",
            areaCode: "0772",
          },
          {
            name: "融水苗族自治县",
            code: "450225",
            areaCode: "0772",
          },
          {
            name: "三江侗族自治县",
            code: "450226",
            areaCode: "0772",
          },
        ],
      },
      {
        name: "桂林市",
        code: "450300",
        areaCode: "0773",
        cities: [
          {
            name: "桂林市市辖区",
            code: "450301",
            areaCode: "0773",
          },
          {
            name: "秀峰区",
            code: "450302",
            areaCode: "0773",
          },
          {
            name: "叠彩区",
            code: "450303",
            areaCode: "0773",
          },
          {
            name: "象山区",
            code: "450304",
            areaCode: "0773",
          },
          {
            name: "七星区",
            code: "450305",
            areaCode: "0773",
          },
          {
            name: "雁山区",
            code: "450311",
            areaCode: "0773",
          },
          {
            name: "临桂区",
            code: "450312",
            areaCode: "0773",
          },
          {
            name: "阳朔县",
            code: "450321",
            areaCode: "0773",
          },
          {
            name: "灵川县",
            code: "450323",
            areaCode: "0773",
          },
          {
            name: "全州县",
            code: "450324",
            areaCode: "0773",
          },
          {
            name: "兴安县",
            code: "450325",
            areaCode: "0773",
          },
          {
            name: "永福县",
            code: "450326",
            areaCode: "0773",
          },
          {
            name: "灌阳县",
            code: "450327",
            areaCode: "0773",
          },
          {
            name: "龙胜各族自治县",
            code: "450328",
            areaCode: "0773",
          },
          {
            name: "资源县",
            code: "450329",
            areaCode: "0773",
          },
          {
            name: "平乐县",
            code: "450330",
            areaCode: "0773",
          },
          {
            name: "荔浦市",
            code: "450381",
            areaCode: "0773",
          },
          {
            name: "恭城瑶族自治县",
            code: "450332",
            areaCode: "0773",
          },
        ],
      },
      {
        name: "梧州市",
        code: "450400",
        areaCode: "0774",
        cities: [
          {
            name: "梧州市市辖区",
            code: "450401",
            areaCode: "0774",
          },
          {
            name: "万秀区",
            code: "450403",
            areaCode: "0774",
          },
          {
            name: "长洲区",
            code: "450405",
            areaCode: "0774",
          },
          {
            name: "龙圩区",
            code: "450406",
            areaCode: "0774",
          },
          {
            name: "苍梧县",
            code: "450421",
            areaCode: "0774",
          },
          {
            name: "藤县",
            code: "450422",
            areaCode: "0774",
          },
          {
            name: "蒙山县",
            code: "450423",
            areaCode: "0774",
          },
          {
            name: "岑溪市",
            code: "450481",
            areaCode: "0774",
          },
        ],
      },
      {
        name: "北海市",
        code: "450500",
        areaCode: "0779",
        cities: [
          {
            name: "北海市市辖区",
            code: "450501",
            areaCode: "0779",
          },
          {
            name: "海城区",
            code: "450502",
            areaCode: "0779",
          },
          {
            name: "银海区",
            code: "450503",
            areaCode: "0779",
          },
          {
            name: "铁山港区",
            code: "450512",
            areaCode: "0779",
          },
          {
            name: "合浦县",
            code: "450521",
            areaCode: "0779",
          },
        ],
      },
      {
        name: "防城港市",
        code: "450600",
        areaCode: "0770",
        cities: [
          {
            name: "防城港市市辖区",
            code: "450601",
            areaCode: "0770",
          },
          {
            name: "港口区",
            code: "450602",
            areaCode: "0770",
          },
          {
            name: "防城区",
            code: "450603",
            areaCode: "0770",
          },
          {
            name: "上思县",
            code: "450621",
            areaCode: "0770",
          },
          {
            name: "东兴市",
            code: "450681",
            areaCode: "0770",
          },
        ],
      },
      {
        name: "钦州市",
        code: "450700",
        areaCode: "0777",
        cities: [
          {
            name: "钦州市市辖区",
            code: "450701",
            areaCode: "0777",
          },
          {
            name: "钦南区",
            code: "450702",
            areaCode: "0777",
          },
          {
            name: "钦北区",
            code: "450703",
            areaCode: "0777",
          },
          {
            name: "灵山县",
            code: "450721",
            areaCode: "0777",
          },
          {
            name: "浦北县",
            code: "450722",
            areaCode: "0777",
          },
        ],
      },
      {
        name: "贵港市",
        code: "450800",
        areaCode: "1755",
        cities: [
          {
            name: "贵港市市辖区",
            code: "450801",
            areaCode: "1755",
          },
          {
            name: "港北区",
            code: "450802",
            areaCode: "1755",
          },
          {
            name: "港南区",
            code: "450803",
            areaCode: "1755",
          },
          {
            name: "覃塘区",
            code: "450804",
            areaCode: "1755",
          },
          {
            name: "平南县",
            code: "450821",
            areaCode: "1755",
          },
          {
            name: "桂平市",
            code: "450881",
            areaCode: "1755",
          },
        ],
      },
      {
        name: "玉林市",
        code: "450900",
        areaCode: "0775",
        cities: [
          {
            name: "玉林市市辖区",
            code: "450901",
            areaCode: "0775",
          },
          {
            name: "玉州区",
            code: "450902",
            areaCode: "0775",
          },
          {
            name: "福绵区",
            code: "450903",
            areaCode: "0775",
          },
          {
            name: "容县",
            code: "450921",
            areaCode: "0775",
          },
          {
            name: "陆川县",
            code: "450922",
            areaCode: "0775",
          },
          {
            name: "博白县",
            code: "450923",
            areaCode: "0775",
          },
          {
            name: "兴业县",
            code: "450924",
            areaCode: "0775",
          },
          {
            name: "北流市",
            code: "450981",
            areaCode: "0775",
          },
        ],
      },
      {
        name: "百色市",
        code: "451000",
        areaCode: "0776",
        cities: [
          {
            name: "百色市市辖区",
            code: "451001",
            areaCode: "0776",
          },
          {
            name: "右江区",
            code: "451002",
            areaCode: "0776",
          },
          {
            name: "田阳区",
            code: "451003",
            areaCode: "0776",
          },
          {
            name: "田东县",
            code: "451022",
            areaCode: "0776",
          },
          {
            name: "平果市",
            code: "451082",
            areaCode: "0776",
          },
          {
            name: "德保县",
            code: "451024",
            areaCode: "0776",
          },
          {
            name: "那坡县",
            code: "451026",
            areaCode: "0776",
          },
          {
            name: "凌云县",
            code: "451027",
            areaCode: "0776",
          },
          {
            name: "乐业县",
            code: "451028",
            areaCode: "0776",
          },
          {
            name: "田林县",
            code: "451029",
            areaCode: "0776",
          },
          {
            name: "西林县",
            code: "451030",
            areaCode: "0776",
          },
          {
            name: "隆林各族自治县",
            code: "451031",
            areaCode: "0776",
          },
          {
            name: "靖西市",
            code: "451081",
            areaCode: "0776",
          },
        ],
      },
      {
        name: "贺州市",
        code: "451100",
        areaCode: "1774",
        cities: [
          {
            name: "贺州市市辖区",
            code: "451101",
            areaCode: "1774",
          },
          {
            name: "八步区",
            code: "451102",
            areaCode: "1774",
          },
          {
            name: "平桂区",
            code: "451103",
            areaCode: "1774",
          },
          {
            name: "昭平县",
            code: "451121",
            areaCode: "1774",
          },
          {
            name: "钟山县",
            code: "451122",
            areaCode: "1774",
          },
          {
            name: "富川瑶族自治县",
            code: "451123",
            areaCode: "1774",
          },
        ],
      },
      {
        name: "河池市",
        code: "451200",
        areaCode: "0778",
        cities: [
          {
            name: "河池市市辖区",
            code: "451201",
            areaCode: "0778",
          },
          {
            name: "金城江区",
            code: "451202",
            areaCode: "0778",
          },
          {
            name: "宜州区",
            code: "451203",
            areaCode: "0778",
          },
          {
            name: "南丹县",
            code: "451221",
            areaCode: "0778",
          },
          {
            name: "天峨县",
            code: "451222",
            areaCode: "0778",
          },
          {
            name: "凤山县",
            code: "451223",
            areaCode: "0778",
          },
          {
            name: "东兰县",
            code: "451224",
            areaCode: "0778",
          },
          {
            name: "罗城仫佬族自治县",
            code: "451225",
            areaCode: "0778",
          },
          {
            name: "环江毛南族自治县",
            code: "451226",
            areaCode: "0778",
          },
          {
            name: "巴马瑶族自治县",
            code: "451227",
            areaCode: "0778",
          },
          {
            name: "都安瑶族自治县",
            code: "451228",
            areaCode: "0778",
          },
          {
            name: "大化瑶族自治县",
            code: "451229",
            areaCode: "0778",
          },
        ],
      },
      {
        name: "来宾市",
        code: "451300",
        areaCode: "1772",
        cities: [
          {
            name: "来宾市市辖区",
            code: "451301",
            areaCode: "1772",
          },
          {
            name: "兴宾区",
            code: "451302",
            areaCode: "1772",
          },
          {
            name: "忻城县",
            code: "451321",
            areaCode: "1772",
          },
          {
            name: "象州县",
            code: "451322",
            areaCode: "1772",
          },
          {
            name: "武宣县",
            code: "451323",
            areaCode: "1772",
          },
          {
            name: "金秀瑶族自治县",
            code: "451324",
            areaCode: "1772",
          },
          {
            name: "合山市",
            code: "451381",
            areaCode: "1772",
          },
        ],
      },
      {
        name: "崇左市",
        code: "451400",
        areaCode: "1771",
        cities: [
          {
            name: "崇左市市辖区",
            code: "451401",
            areaCode: "1771",
          },
          {
            name: "江州区",
            code: "451402",
            areaCode: "1771",
          },
          {
            name: "扶绥县",
            code: "451421",
            areaCode: "1771",
          },
          {
            name: "宁明县",
            code: "451422",
            areaCode: "1771",
          },
          {
            name: "龙州县",
            code: "451423",
            areaCode: "1771",
          },
          {
            name: "大新县",
            code: "451424",
            areaCode: "1771",
          },
          {
            name: "天等县",
            code: "451425",
            areaCode: "1771",
          },
          {
            name: "凭祥市",
            code: "451481",
            areaCode: "1771",
          },
        ],
      },
    ],
  },
  {
    name: "海南省",
    code: "460000",
    areaCode: "",
    cities: [
      {
        name: "海口市",
        code: "460100",
        areaCode: "0898",
        cities: [
          {
            name: "海口市市辖区",
            code: "460101",
            areaCode: "0898",
          },
          {
            name: "秀英区",
            code: "460105",
            areaCode: "0898",
          },
          {
            name: "龙华区",
            code: "460106",
            areaCode: "0898",
          },
          {
            name: "琼山区",
            code: "460107",
            areaCode: "0898",
          },
          {
            name: "美兰区",
            code: "460108",
            areaCode: "0898",
          },
        ],
      },
      {
        name: "三亚市",
        code: "460200",
        areaCode: "0899",
        cities: [
          {
            name: "三亚市市辖区",
            code: "460201",
            areaCode: "0899",
          },
          {
            name: "海棠区",
            code: "460202",
            areaCode: "0899",
          },
          {
            name: "吉阳区",
            code: "460203",
            areaCode: "0899",
          },
          {
            name: "天涯区",
            code: "460204",
            areaCode: "0899",
          },
          {
            name: "崖州区",
            code: "460205",
            areaCode: "0899",
          },
        ],
      },
      {
        name: "三沙市",
        code: "460300",
        areaCode: "2898",
        cities: [
          {
            name: "西沙区",
            code: "460301",
            areaCode: "2898",
          },
          {
            name: "南沙区",
            code: "460302",
            areaCode: "2898",
          },
        ],
      },
      {
        name: "儋州市",
        code: "460400",
        areaCode: "0805",
        cities: [],
      },
    ],
  },
  {
    name: "重庆市",
    code: "500000",
    areaCode: "023",
    cities: [
      {
        name: "重庆市市辖区",
        code: "500100",
        areaCode: "023",
        cities: [
          {
            name: "万州区",
            code: "500101",
            areaCode: "023",
          },
          {
            name: "涪陵区",
            code: "500102",
            areaCode: "023",
          },
          {
            name: "渝中区",
            code: "500103",
            areaCode: "023",
          },
          {
            name: "大渡口区",
            code: "500104",
            areaCode: "023",
          },
          {
            name: "江北区",
            code: "500105",
            areaCode: "023",
          },
          {
            name: "沙坪坝区",
            code: "500106",
            areaCode: "023",
          },
          {
            name: "九龙坡区",
            code: "500107",
            areaCode: "023",
          },
          {
            name: "南岸区",
            code: "500108",
            areaCode: "023",
          },
          {
            name: "北碚区",
            code: "500109",
            areaCode: "023",
          },
          {
            name: "綦江区",
            code: "500110",
            areaCode: "023",
          },
          {
            name: "大足区",
            code: "500111",
            areaCode: "023",
          },
          {
            name: "渝北区",
            code: "500112",
            areaCode: "023",
          },
          {
            name: "巴南区",
            code: "500113",
            areaCode: "023",
          },
          {
            name: "黔江区",
            code: "500114",
            areaCode: "023",
          },
          {
            name: "长寿区",
            code: "500115",
            areaCode: "023",
          },
          {
            name: "江津区",
            code: "500116",
            areaCode: "023",
          },
          {
            name: "合川区",
            code: "500117",
            areaCode: "023",
          },
          {
            name: "永川区",
            code: "500118",
            areaCode: "023",
          },
          {
            name: "南川区",
            code: "500119",
            areaCode: "023",
          },
          {
            name: "璧山区",
            code: "500120",
            areaCode: "023",
          },
          {
            name: "铜梁区",
            code: "500151",
            areaCode: "023",
          },
          {
            name: "潼南区",
            code: "500152",
            areaCode: "023",
          },
          {
            name: "荣昌区",
            code: "500153",
            areaCode: "023",
          },
          {
            name: "开州区",
            code: "500154",
            areaCode: "023",
          },
          {
            name: "梁平区",
            code: "500155",
            areaCode: "023",
          },
          {
            name: "武隆区",
            code: "500156",
            areaCode: "023",
          },
        ],
      },
      {
        name: "重庆市郊县",
        code: "500200",
        areaCode: "023",
        cities: [
          {
            name: "城口县",
            code: "500229",
            areaCode: "023",
          },
          {
            name: "丰都县",
            code: "500230",
            areaCode: "023",
          },
          {
            name: "垫江县",
            code: "500231",
            areaCode: "023",
          },
          {
            name: "忠县",
            code: "500233",
            areaCode: "023",
          },
          {
            name: "云阳县",
            code: "500235",
            areaCode: "023",
          },
          {
            name: "奉节县",
            code: "500236",
            areaCode: "023",
          },
          {
            name: "巫山县",
            code: "500237",
            areaCode: "023",
          },
          {
            name: "巫溪县",
            code: "500238",
            areaCode: "023",
          },
          {
            name: "石柱土家族自治县",
            code: "500240",
            areaCode: "023",
          },
          {
            name: "秀山土家族苗族自治县",
            code: "500241",
            areaCode: "023",
          },
          {
            name: "酉阳土家族苗族自治县",
            code: "500242",
            areaCode: "023",
          },
          {
            name: "彭水苗族土家族自治县",
            code: "500243",
            areaCode: "023",
          },
        ],
      },
    ],
  },
  {
    name: "四川省",
    code: "510000",
    areaCode: "",
    cities: [
      {
        name: "成都市",
        code: "510100",
        areaCode: "028",
        cities: [
          {
            name: "成都市市辖区",
            code: "510101",
            areaCode: "028",
          },
          {
            name: "锦江区",
            code: "510104",
            areaCode: "028",
          },
          {
            name: "青羊区",
            code: "510105",
            areaCode: "028",
          },
          {
            name: "金牛区",
            code: "510106",
            areaCode: "028",
          },
          {
            name: "武侯区",
            code: "510107",
            areaCode: "028",
          },
          {
            name: "成华区",
            code: "510108",
            areaCode: "028",
          },
          {
            name: "龙泉驿区",
            code: "510112",
            areaCode: "028",
          },
          {
            name: "青白江区",
            code: "510113",
            areaCode: "028",
          },
          {
            name: "新都区",
            code: "510114",
            areaCode: "028",
          },
          {
            name: "温江区",
            code: "510115",
            areaCode: "028",
          },
          {
            name: "双流区",
            code: "510116",
            areaCode: "028",
          },
          {
            name: "郫都区",
            code: "510117",
            areaCode: "028",
          },
          {
            name: "金堂县",
            code: "510121",
            areaCode: "028",
          },
          {
            name: "大邑县",
            code: "510129",
            areaCode: "028",
          },
          {
            name: "蒲江县",
            code: "510131",
            areaCode: "028",
          },
          {
            name: "新津区",
            code: "510118",
            areaCode: "028",
          },
          {
            name: "都江堰市",
            code: "510181",
            areaCode: "028",
          },
          {
            name: "彭州市",
            code: "510182",
            areaCode: "028",
          },
          {
            name: "邛崃市",
            code: "510183",
            areaCode: "028",
          },
          {
            name: "崇州市",
            code: "510184",
            areaCode: "028",
          },
          {
            name: "简阳市",
            code: "510185",
            areaCode: "028",
          },
        ],
      },
      {
        name: "自贡市",
        code: "510300",
        areaCode: "0813",
        cities: [
          {
            name: "自贡市市辖区",
            code: "510301",
            areaCode: "0813",
          },
          {
            name: "自流井区",
            code: "510302",
            areaCode: "0813",
          },
          {
            name: "贡井区",
            code: "510303",
            areaCode: "0813",
          },
          {
            name: "大安区",
            code: "510304",
            areaCode: "0813",
          },
          {
            name: "沿滩区",
            code: "510311",
            areaCode: "0813",
          },
          {
            name: "荣县",
            code: "510321",
            areaCode: "0813",
          },
          {
            name: "富顺县",
            code: "510322",
            areaCode: "0813",
          },
        ],
      },
      {
        name: "攀枝花市",
        code: "510400",
        areaCode: "0812",
        cities: [
          {
            name: "攀枝花市市辖区",
            code: "510401",
            areaCode: "0812",
          },
          {
            name: "东区",
            code: "510402",
            areaCode: "0812",
          },
          {
            name: "西区",
            code: "510403",
            areaCode: "0812",
          },
          {
            name: "仁和区",
            code: "510411",
            areaCode: "0812",
          },
          {
            name: "米易县",
            code: "510421",
            areaCode: "0812",
          },
          {
            name: "盐边县",
            code: "510422",
            areaCode: "0812",
          },
        ],
      },
      {
        name: "泸州市",
        code: "510500",
        areaCode: "0830",
        cities: [
          {
            name: "泸州市市辖区",
            code: "510501",
            areaCode: "0830",
          },
          {
            name: "江阳区",
            code: "510502",
            areaCode: "0830",
          },
          {
            name: "纳溪区",
            code: "510503",
            areaCode: "0830",
          },
          {
            name: "龙马潭区",
            code: "510504",
            areaCode: "0830",
          },
          {
            name: "泸县",
            code: "510521",
            areaCode: "0830",
          },
          {
            name: "合江县",
            code: "510522",
            areaCode: "0830",
          },
          {
            name: "叙永县",
            code: "510524",
            areaCode: "0830",
          },
          {
            name: "古蔺县",
            code: "510525",
            areaCode: "0830",
          },
        ],
      },
      {
        name: "德阳市",
        code: "510600",
        areaCode: "0838",
        cities: [
          {
            name: "德阳市市辖区",
            code: "510601",
            areaCode: "0838",
          },
          {
            name: "旌阳区",
            code: "510603",
            areaCode: "0838",
          },
          {
            name: "中江县",
            code: "510623",
            areaCode: "0838",
          },
          {
            name: "罗江区",
            code: "510604",
            areaCode: "0838",
          },
          {
            name: "广汉市",
            code: "510681",
            areaCode: "0838",
          },
          {
            name: "什邡市",
            code: "510682",
            areaCode: "0838",
          },
          {
            name: "绵竹市",
            code: "510683",
            areaCode: "0838",
          },
        ],
      },
      {
        name: "绵阳市",
        code: "510700",
        areaCode: "0816",
        cities: [
          {
            name: "绵阳市市辖区",
            code: "510701",
            areaCode: "0816",
          },
          {
            name: "涪城区",
            code: "510703",
            areaCode: "0816",
          },
          {
            name: "游仙区",
            code: "510704",
            areaCode: "0816",
          },
          {
            name: "安州区",
            code: "510705",
            areaCode: "0816",
          },
          {
            name: "三台县",
            code: "510722",
            areaCode: "0816",
          },
          {
            name: "盐亭县",
            code: "510723",
            areaCode: "0816",
          },
          {
            name: "梓潼县",
            code: "510725",
            areaCode: "0816",
          },
          {
            name: "北川羌族自治县",
            code: "510726",
            areaCode: "0816",
          },
          {
            name: "平武县",
            code: "510727",
            areaCode: "0816",
          },
          {
            name: "江油市",
            code: "510781",
            areaCode: "0816",
          },
        ],
      },
      {
        name: "广元市",
        code: "510800",
        areaCode: "0839",
        cities: [
          {
            name: "广元市市辖区",
            code: "510801",
            areaCode: "0839",
          },
          {
            name: "利州区",
            code: "510802",
            areaCode: "0839",
          },
          {
            name: "昭化区",
            code: "510811",
            areaCode: "0839",
          },
          {
            name: "朝天区",
            code: "510812",
            areaCode: "0839",
          },
          {
            name: "旺苍县",
            code: "510821",
            areaCode: "0839",
          },
          {
            name: "青川县",
            code: "510822",
            areaCode: "0839",
          },
          {
            name: "剑阁县",
            code: "510823",
            areaCode: "0839",
          },
          {
            name: "苍溪县",
            code: "510824",
            areaCode: "0839",
          },
        ],
      },
      {
        name: "遂宁市",
        code: "510900",
        areaCode: "0825",
        cities: [
          {
            name: "遂宁市市辖区",
            code: "510901",
            areaCode: "0825",
          },
          {
            name: "船山区",
            code: "510903",
            areaCode: "0825",
          },
          {
            name: "安居区",
            code: "510904",
            areaCode: "0825",
          },
          {
            name: "蓬溪县",
            code: "510921",
            areaCode: "0825",
          },
          {
            name: "射洪市",
            code: "510981",
            areaCode: "0825",
          },
          {
            name: "大英县",
            code: "510923",
            areaCode: "0825",
          },
        ],
      },
      {
        name: "内江市",
        code: "511000",
        areaCode: "1832",
        cities: [
          {
            name: "内江市市辖区",
            code: "511001",
            areaCode: "1832",
          },
          {
            name: "市中区",
            code: "511002",
            areaCode: "1832",
          },
          {
            name: "东兴区",
            code: "511011",
            areaCode: "1832",
          },
          {
            name: "威远县",
            code: "511024",
            areaCode: "1832",
          },
          {
            name: "资中县",
            code: "511025",
            areaCode: "1832",
          },
          {
            name: "隆昌市",
            code: "511083",
            areaCode: "1832",
          },
        ],
      },
      {
        name: "乐山市",
        code: "511100",
        areaCode: "0833",
        cities: [
          {
            name: "乐山市市辖区",
            code: "511101",
            areaCode: "0833",
          },
          {
            name: "市中区",
            code: "511102",
            areaCode: "0833",
          },
          {
            name: "沙湾区",
            code: "511111",
            areaCode: "0833",
          },
          {
            name: "五通桥区",
            code: "511112",
            areaCode: "0833",
          },
          {
            name: "金口河区",
            code: "511113",
            areaCode: "0833",
          },
          {
            name: "犍为县",
            code: "511123",
            areaCode: "0833",
          },
          {
            name: "井研县",
            code: "511124",
            areaCode: "0833",
          },
          {
            name: "夹江县",
            code: "511126",
            areaCode: "0833",
          },
          {
            name: "沐川县",
            code: "511129",
            areaCode: "0833",
          },
          {
            name: "峨边彝族自治县",
            code: "511132",
            areaCode: "0833",
          },
          {
            name: "马边彝族自治县",
            code: "511133",
            areaCode: "0833",
          },
          {
            name: "峨眉山市",
            code: "511181",
            areaCode: "0833",
          },
        ],
      },
      {
        name: "南充市",
        code: "511300",
        areaCode: "0817",
        cities: [
          {
            name: "南充市市辖区",
            code: "511301",
            areaCode: "0817",
          },
          {
            name: "顺庆区",
            code: "511302",
            areaCode: "0817",
          },
          {
            name: "高坪区",
            code: "511303",
            areaCode: "0817",
          },
          {
            name: "嘉陵区",
            code: "511304",
            areaCode: "0817",
          },
          {
            name: "南部县",
            code: "511321",
            areaCode: "0817",
          },
          {
            name: "营山县",
            code: "511322",
            areaCode: "0817",
          },
          {
            name: "蓬安县",
            code: "511323",
            areaCode: "0817",
          },
          {
            name: "仪陇县",
            code: "511324",
            areaCode: "0817",
          },
          {
            name: "西充县",
            code: "511325",
            areaCode: "0817",
          },
          {
            name: "阆中市",
            code: "511381",
            areaCode: "0817",
          },
        ],
      },
      {
        name: "眉山市",
        code: "511400",
        areaCode: "1833",
        cities: [
          {
            name: "眉山市市辖区",
            code: "511401",
            areaCode: "1833",
          },
          {
            name: "东坡区",
            code: "511402",
            areaCode: "1833",
          },
          {
            name: "彭山区",
            code: "511403",
            areaCode: "1833",
          },
          {
            name: "仁寿县",
            code: "511421",
            areaCode: "1833",
          },
          {
            name: "洪雅县",
            code: "511423",
            areaCode: "1833",
          },
          {
            name: "丹棱县",
            code: "511424",
            areaCode: "1833",
          },
          {
            name: "青神县",
            code: "511425",
            areaCode: "1833",
          },
        ],
      },
      {
        name: "宜宾市",
        code: "511500",
        areaCode: "0831",
        cities: [
          {
            name: "宜宾市市辖区",
            code: "511501",
            areaCode: "0831",
          },
          {
            name: "翠屏区",
            code: "511502",
            areaCode: "0831",
          },
          {
            name: "南溪区",
            code: "511503",
            areaCode: "0831",
          },
          {
            name: "叙州区",
            code: "511504",
            areaCode: "0831",
          },
          {
            name: "江安县",
            code: "511523",
            areaCode: "0831",
          },
          {
            name: "长宁县",
            code: "511524",
            areaCode: "0831",
          },
          {
            name: "高县",
            code: "511525",
            areaCode: "0831",
          },
          {
            name: "珙县",
            code: "511526",
            areaCode: "0831",
          },
          {
            name: "筠连县",
            code: "511527",
            areaCode: "0831",
          },
          {
            name: "兴文县",
            code: "511528",
            areaCode: "0831",
          },
          {
            name: "屏山县",
            code: "511529",
            areaCode: "0831",
          },
        ],
      },
      {
        name: "广安市",
        code: "511600",
        areaCode: "0826",
        cities: [
          {
            name: "广安市市辖区",
            code: "511601",
            areaCode: "0826",
          },
          {
            name: "广安区",
            code: "511602",
            areaCode: "0826",
          },
          {
            name: "前锋区",
            code: "511603",
            areaCode: "0826",
          },
          {
            name: "岳池县",
            code: "511621",
            areaCode: "0826",
          },
          {
            name: "武胜县",
            code: "511622",
            areaCode: "0826",
          },
          {
            name: "邻水县",
            code: "511623",
            areaCode: "0826",
          },
          {
            name: "华蓥市",
            code: "511681",
            areaCode: "0826",
          },
        ],
      },
      {
        name: "达州市",
        code: "511700",
        areaCode: "0818",
        cities: [
          {
            name: "达州市市辖区",
            code: "511701",
            areaCode: "0818",
          },
          {
            name: "通川区",
            code: "511702",
            areaCode: "0818",
          },
          {
            name: "达川区",
            code: "511703",
            areaCode: "0818",
          },
          {
            name: "宣汉县",
            code: "511722",
            areaCode: "0818",
          },
          {
            name: "开江县",
            code: "511723",
            areaCode: "0818",
          },
          {
            name: "大竹县",
            code: "511724",
            areaCode: "0818",
          },
          {
            name: "渠县",
            code: "511725",
            areaCode: "0818",
          },
          {
            name: "万源市",
            code: "511781",
            areaCode: "0818",
          },
        ],
      },
      {
        name: "雅安市",
        code: "511800",
        areaCode: "0835",
        cities: [
          {
            name: "雅安市市辖区",
            code: "511801",
            areaCode: "0835",
          },
          {
            name: "雨城区",
            code: "511802",
            areaCode: "0835",
          },
          {
            name: "名山区",
            code: "511803",
            areaCode: "0835",
          },
          {
            name: "荥经县",
            code: "511822",
            areaCode: "0835",
          },
          {
            name: "汉源县",
            code: "511823",
            areaCode: "0835",
          },
          {
            name: "石棉县",
            code: "511824",
            areaCode: "0835",
          },
          {
            name: "天全县",
            code: "511825",
            areaCode: "0835",
          },
          {
            name: "芦山县",
            code: "511826",
            areaCode: "0835",
          },
          {
            name: "宝兴县",
            code: "511827",
            areaCode: "0835",
          },
        ],
      },
      {
        name: "巴中市",
        code: "511900",
        areaCode: "0827",
        cities: [
          {
            name: "巴中市市辖区",
            code: "511901",
            areaCode: "0827",
          },
          {
            name: "巴州区",
            code: "511902",
            areaCode: "0827",
          },
          {
            name: "恩阳区",
            code: "511903",
            areaCode: "0827",
          },
          {
            name: "通江县",
            code: "511921",
            areaCode: "0827",
          },
          {
            name: "南江县",
            code: "511922",
            areaCode: "0827",
          },
          {
            name: "平昌县",
            code: "511923",
            areaCode: "0827",
          },
        ],
      },
      {
        name: "资阳市",
        code: "512000",
        areaCode: "0832",
        cities: [
          {
            name: "资阳市市辖区",
            code: "512001",
            areaCode: "0832",
          },
          {
            name: "雁江区",
            code: "512002",
            areaCode: "0832",
          },
          {
            name: "安岳县",
            code: "512021",
            areaCode: "0832",
          },
          {
            name: "乐至县",
            code: "512022",
            areaCode: "0832",
          },
        ],
      },
      {
        name: "阿坝藏族羌族自治州",
        code: "513200",
        areaCode: "0837",
        cities: [
          {
            name: "马尔康市",
            code: "513201",
            areaCode: "0837",
          },
          {
            name: "汶川县",
            code: "513221",
            areaCode: "0837",
          },
          {
            name: "理县",
            code: "513222",
            areaCode: "0837",
          },
          {
            name: "茂县",
            code: "513223",
            areaCode: "0837",
          },
          {
            name: "松潘县",
            code: "513224",
            areaCode: "0837",
          },
          {
            name: "九寨沟县",
            code: "513225",
            areaCode: "0837",
          },
          {
            name: "金川县",
            code: "513226",
            areaCode: "0837",
          },
          {
            name: "小金县",
            code: "513227",
            areaCode: "0837",
          },
          {
            name: "黑水县",
            code: "513228",
            areaCode: "0837",
          },
          {
            name: "壤塘县",
            code: "513230",
            areaCode: "0837",
          },
          {
            name: "阿坝县",
            code: "513231",
            areaCode: "0837",
          },
          {
            name: "若尔盖县",
            code: "513232",
            areaCode: "0837",
          },
          {
            name: "红原县",
            code: "513233",
            areaCode: "0837",
          },
        ],
      },
      {
        name: "甘孜藏族自治州",
        code: "513300",
        areaCode: "0836",
        cities: [
          {
            name: "康定市",
            code: "513301",
            areaCode: "0836",
          },
          {
            name: "泸定县",
            code: "513322",
            areaCode: "0836",
          },
          {
            name: "丹巴县",
            code: "513323",
            areaCode: "0836",
          },
          {
            name: "九龙县",
            code: "513324",
            areaCode: "0836",
          },
          {
            name: "雅江县",
            code: "513325",
            areaCode: "0836",
          },
          {
            name: "道孚县",
            code: "513326",
            areaCode: "0836",
          },
          {
            name: "炉霍县",
            code: "513327",
            areaCode: "0836",
          },
          {
            name: "甘孜县",
            code: "513328",
            areaCode: "0836",
          },
          {
            name: "新龙县",
            code: "513329",
            areaCode: "0836",
          },
          {
            name: "德格县",
            code: "513330",
            areaCode: "0836",
          },
          {
            name: "白玉县",
            code: "513331",
            areaCode: "0836",
          },
          {
            name: "石渠县",
            code: "513332",
            areaCode: "0836",
          },
          {
            name: "色达县",
            code: "513333",
            areaCode: "0836",
          },
          {
            name: "理塘县",
            code: "513334",
            areaCode: "0836",
          },
          {
            name: "巴塘县",
            code: "513335",
            areaCode: "0836",
          },
          {
            name: "乡城县",
            code: "513336",
            areaCode: "0836",
          },
          {
            name: "稻城县",
            code: "513337",
            areaCode: "0836",
          },
          {
            name: "得荣县",
            code: "513338",
            areaCode: "0836",
          },
        ],
      },
      {
        name: "凉山彝族自治州",
        code: "513400",
        areaCode: "0834",
        cities: [
          {
            name: "西昌市",
            code: "513401",
            areaCode: "0834",
          },
          {
            name: "木里藏族自治县",
            code: "513422",
            areaCode: "0834",
          },
          {
            name: "盐源县",
            code: "513423",
            areaCode: "0834",
          },
          {
            name: "德昌县",
            code: "513424",
            areaCode: "0834",
          },
          {
            name: "会理县",
            code: "513425",
            areaCode: "0834",
          },
          {
            name: "会东县",
            code: "513426",
            areaCode: "0834",
          },
          {
            name: "宁南县",
            code: "513427",
            areaCode: "0834",
          },
          {
            name: "普格县",
            code: "513428",
            areaCode: "0834",
          },
          {
            name: "布拖县",
            code: "513429",
            areaCode: "0834",
          },
          {
            name: "金阳县",
            code: "513430",
            areaCode: "0834",
          },
          {
            name: "昭觉县",
            code: "513431",
            areaCode: "0834",
          },
          {
            name: "喜德县",
            code: "513432",
            areaCode: "0834",
          },
          {
            name: "冕宁县",
            code: "513433",
            areaCode: "0834",
          },
          {
            name: "越西县",
            code: "513434",
            areaCode: "0834",
          },
          {
            name: "甘洛县",
            code: "513435",
            areaCode: "0834",
          },
          {
            name: "美姑县",
            code: "513436",
            areaCode: "0834",
          },
          {
            name: "雷波县",
            code: "513437",
            areaCode: "0834",
          },
        ],
      },
    ],
  },
  {
    name: "贵州省",
    code: "520000",
    areaCode: "",
    cities: [
      {
        name: "贵阳市",
        code: "520100",
        areaCode: "0851",
        cities: [
          {
            name: "贵阳市市辖区",
            code: "520101",
            areaCode: "0851",
          },
          {
            name: "南明区",
            code: "520102",
            areaCode: "0851",
          },
          {
            name: "云岩区",
            code: "520103",
            areaCode: "0851",
          },
          {
            name: "花溪区",
            code: "520111",
            areaCode: "0851",
          },
          {
            name: "乌当区",
            code: "520112",
            areaCode: "0851",
          },
          {
            name: "白云区",
            code: "520113",
            areaCode: "0851",
          },
          {
            name: "观山湖区",
            code: "520115",
            areaCode: "0851",
          },
          {
            name: "开阳县",
            code: "520121",
            areaCode: "0851",
          },
          {
            name: "息烽县",
            code: "520122",
            areaCode: "0851",
          },
          {
            name: "修文县",
            code: "520123",
            areaCode: "0851",
          },
          {
            name: "清镇市",
            code: "520181",
            areaCode: "0851",
          },
        ],
      },
      {
        name: "六盘水市",
        code: "520200",
        areaCode: "0858",
        cities: [
          {
            name: "钟山区",
            code: "520201",
            areaCode: "0858",
          },
          {
            name: "六枝特区",
            code: "520203",
            areaCode: "0858",
          },
          {
            name: "水城区",
            code: "520221",
            areaCode: "0858",
          },
          {
            name: "盘州市",
            code: "520281",
            areaCode: "0858",
          },
        ],
      },
      {
        name: "遵义市",
        code: "520300",
        areaCode: "0852",
        cities: [
          {
            name: "遵义市市辖区",
            code: "520301",
            areaCode: "0852",
          },
          {
            name: "红花岗区",
            code: "520302",
            areaCode: "0852",
          },
          {
            name: "汇川区",
            code: "520303",
            areaCode: "0852",
          },
          {
            name: "播州区",
            code: "520304",
            areaCode: "0852",
          },
          {
            name: "桐梓县",
            code: "520322",
            areaCode: "0852",
          },
          {
            name: "绥阳县",
            code: "520323",
            areaCode: "0852",
          },
          {
            name: "正安县",
            code: "520324",
            areaCode: "0852",
          },
          {
            name: "道真仡佬族苗族自治县",
            code: "520325",
            areaCode: "0852",
          },
          {
            name: "务川仡佬族苗族自治县",
            code: "520326",
            areaCode: "0852",
          },
          {
            name: "凤冈县",
            code: "520327",
            areaCode: "0852",
          },
          {
            name: "湄潭县",
            code: "520328",
            areaCode: "0852",
          },
          {
            name: "余庆县",
            code: "520329",
            areaCode: "0852",
          },
          {
            name: "习水县",
            code: "520330",
            areaCode: "0852",
          },
          {
            name: "赤水市",
            code: "520381",
            areaCode: "0852",
          },
          {
            name: "仁怀市",
            code: "520382",
            areaCode: "0852",
          },
        ],
      },
      {
        name: "安顺市",
        code: "520400",
        areaCode: "0853",
        cities: [
          {
            name: "安顺市市辖区",
            code: "520401",
            areaCode: "0853",
          },
          {
            name: "西秀区",
            code: "520402",
            areaCode: "0853",
          },
          {
            name: "平坝区",
            code: "520403",
            areaCode: "0853",
          },
          {
            name: "普定县",
            code: "520422",
            areaCode: "0853",
          },
          {
            name: "镇宁布依族苗族自治县",
            code: "520423",
            areaCode: "0853",
          },
          {
            name: "关岭布依族苗族自治县",
            code: "520424",
            areaCode: "0853",
          },
          {
            name: "紫云苗族布依族自治县",
            code: "520425",
            areaCode: "0853",
          },
        ],
      },
      {
        name: "毕节市",
        code: "520500",
        areaCode: "0857",
        cities: [
          {
            name: "七星关区",
            code: "520502",
            areaCode: "0857",
          },
          {
            name: "大方县",
            code: "520521",
            areaCode: "0857",
          },
          {
            name: "黔西县",
            code: "520522",
            areaCode: "0857",
          },
          {
            name: "金沙县",
            code: "520523",
            areaCode: "0857",
          },
          {
            name: "织金县",
            code: "520524",
            areaCode: "0857",
          },
          {
            name: "纳雍县",
            code: "520525",
            areaCode: "0857",
          },
          {
            name: "威宁彝族回族苗族自治县",
            code: "520526",
            areaCode: "0857",
          },
          {
            name: "赫章县",
            code: "520527",
            areaCode: "0857",
          },
        ],
      },
      {
        name: "铜仁市",
        code: "520600",
        areaCode: "0856",
        cities: [
          {
            name: "碧江区",
            code: "520602",
            areaCode: "0856",
          },
          {
            name: "万山区",
            code: "520603",
            areaCode: "0856",
          },
          {
            name: "江口县",
            code: "520621",
            areaCode: "0856",
          },
          {
            name: "玉屏侗族自治县",
            code: "520622",
            areaCode: "0856",
          },
          {
            name: "石阡县",
            code: "520623",
            areaCode: "0856",
          },
          {
            name: "思南县",
            code: "520624",
            areaCode: "0856",
          },
          {
            name: "印江土家族苗族自治县",
            code: "520625",
            areaCode: "0856",
          },
          {
            name: "德江县",
            code: "520626",
            areaCode: "0856",
          },
          {
            name: "沿河土家族自治县",
            code: "520627",
            areaCode: "0856",
          },
          {
            name: "松桃苗族自治县",
            code: "520628",
            areaCode: "0856",
          },
        ],
      },
      {
        name: "黔西南布依族苗族自治州",
        code: "522300",
        areaCode: "0859",
        cities: [
          {
            name: "兴义市",
            code: "522301",
            areaCode: "0859",
          },
          {
            name: "兴仁市",
            code: "522302",
            areaCode: "0859",
          },
          {
            name: "普安县",
            code: "522323",
            areaCode: "0859",
          },
          {
            name: "晴隆县",
            code: "522324",
            areaCode: "0859",
          },
          {
            name: "贞丰县",
            code: "522325",
            areaCode: "0859",
          },
          {
            name: "望谟县",
            code: "522326",
            areaCode: "0859",
          },
          {
            name: "册亨县",
            code: "522327",
            areaCode: "0859",
          },
          {
            name: "安龙县",
            code: "522328",
            areaCode: "0859",
          },
        ],
      },
      {
        name: "黔东南苗族侗族自治州",
        code: "522600",
        areaCode: "0855",
        cities: [
          {
            name: "凯里市",
            code: "522601",
            areaCode: "0855",
          },
          {
            name: "黄平县",
            code: "522622",
            areaCode: "0855",
          },
          {
            name: "施秉县",
            code: "522623",
            areaCode: "0855",
          },
          {
            name: "三穗县",
            code: "522624",
            areaCode: "0855",
          },
          {
            name: "镇远县",
            code: "522625",
            areaCode: "0855",
          },
          {
            name: "岑巩县",
            code: "522626",
            areaCode: "0855",
          },
          {
            name: "天柱县",
            code: "522627",
            areaCode: "0855",
          },
          {
            name: "锦屏县",
            code: "522628",
            areaCode: "0855",
          },
          {
            name: "剑河县",
            code: "522629",
            areaCode: "0855",
          },
          {
            name: "台江县",
            code: "522630",
            areaCode: "0855",
          },
          {
            name: "黎平县",
            code: "522631",
            areaCode: "0855",
          },
          {
            name: "榕江县",
            code: "522632",
            areaCode: "0855",
          },
          {
            name: "从江县",
            code: "522633",
            areaCode: "0855",
          },
          {
            name: "雷山县",
            code: "522634",
            areaCode: "0855",
          },
          {
            name: "麻江县",
            code: "522635",
            areaCode: "0855",
          },
          {
            name: "丹寨县",
            code: "522636",
            areaCode: "0855",
          },
        ],
      },
      {
        name: "黔南布依族苗族自治州",
        code: "522700",
        areaCode: "0854",
        cities: [
          {
            name: "都匀市",
            code: "522701",
            areaCode: "0854",
          },
          {
            name: "福泉市",
            code: "522702",
            areaCode: "0854",
          },
          {
            name: "荔波县",
            code: "522722",
            areaCode: "0854",
          },
          {
            name: "贵定县",
            code: "522723",
            areaCode: "0854",
          },
          {
            name: "瓮安县",
            code: "522725",
            areaCode: "0854",
          },
          {
            name: "独山县",
            code: "522726",
            areaCode: "0854",
          },
          {
            name: "平塘县",
            code: "522727",
            areaCode: "0854",
          },
          {
            name: "罗甸县",
            code: "522728",
            areaCode: "0854",
          },
          {
            name: "长顺县",
            code: "522729",
            areaCode: "0854",
          },
          {
            name: "龙里县",
            code: "522730",
            areaCode: "0854",
          },
          {
            name: "惠水县",
            code: "522731",
            areaCode: "0854",
          },
          {
            name: "三都水族自治县",
            code: "522732",
            areaCode: "0854",
          },
        ],
      },
    ],
  },
  {
    name: "云南省",
    code: "530000",
    areaCode: "",
    cities: [
      {
        name: "昆明市",
        code: "530100",
        areaCode: "0871",
        cities: [
          {
            name: "昆明市市辖区",
            code: "530101",
            areaCode: "0871",
          },
          {
            name: "五华区",
            code: "530102",
            areaCode: "0871",
          },
          {
            name: "盘龙区",
            code: "530103",
            areaCode: "0871",
          },
          {
            name: "官渡区",
            code: "530111",
            areaCode: "0871",
          },
          {
            name: "西山区",
            code: "530112",
            areaCode: "0871",
          },
          {
            name: "东川区",
            code: "530113",
            areaCode: "0871",
          },
          {
            name: "呈贡区",
            code: "530114",
            areaCode: "0871",
          },
          {
            name: "晋宁区",
            code: "530115",
            areaCode: "0871",
          },
          {
            name: "富民县",
            code: "530124",
            areaCode: "0871",
          },
          {
            name: "宜良县",
            code: "530125",
            areaCode: "0871",
          },
          {
            name: "石林彝族自治县",
            code: "530126",
            areaCode: "0871",
          },
          {
            name: "嵩明县",
            code: "530127",
            areaCode: "0871",
          },
          {
            name: "禄劝彝族苗族自治县",
            code: "530128",
            areaCode: "0871",
          },
          {
            name: "寻甸回族彝族自治县",
            code: "530129",
            areaCode: "0871",
          },
          {
            name: "安宁市",
            code: "530181",
            areaCode: "0871",
          },
        ],
      },
      {
        name: "曲靖市",
        code: "530300",
        areaCode: "0874",
        cities: [
          {
            name: "曲靖市市辖区",
            code: "530301",
            areaCode: "0874",
          },
          {
            name: "麒麟区",
            code: "530302",
            areaCode: "0874",
          },
          {
            name: "沾益区",
            code: "530303",
            areaCode: "0874",
          },
          {
            name: "马龙区",
            code: "530304",
            areaCode: "0874",
          },
          {
            name: "陆良县",
            code: "530322",
            areaCode: "0874",
          },
          {
            name: "师宗县",
            code: "530323",
            areaCode: "0874",
          },
          {
            name: "罗平县",
            code: "530324",
            areaCode: "0874",
          },
          {
            name: "富源县",
            code: "530325",
            areaCode: "0874",
          },
          {
            name: "会泽县",
            code: "530326",
            areaCode: "0874",
          },
          {
            name: "宣威市",
            code: "530381",
            areaCode: "0874",
          },
        ],
      },
      {
        name: "玉溪市",
        code: "530400",
        areaCode: "0877",
        cities: [
          {
            name: "玉溪市市辖区",
            code: "530401",
            areaCode: "0877",
          },
          {
            name: "红塔区",
            code: "530402",
            areaCode: "0877",
          },
          {
            name: "江川区",
            code: "530403",
            areaCode: "0877",
          },
          {
            name: "澄江市",
            code: "530481",
            areaCode: "0877",
          },
          {
            name: "通海县",
            code: "530423",
            areaCode: "0877",
          },
          {
            name: "华宁县",
            code: "530424",
            areaCode: "0877",
          },
          {
            name: "易门县",
            code: "530425",
            areaCode: "0877",
          },
          {
            name: "峨山彝族自治县",
            code: "530426",
            areaCode: "0877",
          },
          {
            name: "新平彝族傣族自治县",
            code: "530427",
            areaCode: "0877",
          },
          {
            name: "元江哈尼族彝族傣族自治县",
            code: "530428",
            areaCode: "0877",
          },
        ],
      },
      {
        name: "保山市",
        code: "530500",
        areaCode: "0875",
        cities: [
          {
            name: "保山市市辖区",
            code: "530501",
            areaCode: "0875",
          },
          {
            name: "隆阳区",
            code: "530502",
            areaCode: "0875",
          },
          {
            name: "施甸县",
            code: "530521",
            areaCode: "0875",
          },
          {
            name: "龙陵县",
            code: "530523",
            areaCode: "0875",
          },
          {
            name: "昌宁县",
            code: "530524",
            areaCode: "0875",
          },
          {
            name: "腾冲市",
            code: "530581",
            areaCode: "0875",
          },
        ],
      },
      {
        name: "昭通市",
        code: "530600",
        areaCode: "0870",
        cities: [
          {
            name: "昭通市市辖区",
            code: "530601",
            areaCode: "0870",
          },
          {
            name: "昭阳区",
            code: "530602",
            areaCode: "0870",
          },
          {
            name: "鲁甸县",
            code: "530621",
            areaCode: "0870",
          },
          {
            name: "巧家县",
            code: "530622",
            areaCode: "0870",
          },
          {
            name: "盐津县",
            code: "530623",
            areaCode: "0870",
          },
          {
            name: "大关县",
            code: "530624",
            areaCode: "0870",
          },
          {
            name: "永善县",
            code: "530625",
            areaCode: "0870",
          },
          {
            name: "绥江县",
            code: "530626",
            areaCode: "0870",
          },
          {
            name: "镇雄县",
            code: "530627",
            areaCode: "0870",
          },
          {
            name: "彝良县",
            code: "530628",
            areaCode: "0870",
          },
          {
            name: "威信县",
            code: "530629",
            areaCode: "0870",
          },
          {
            name: "水富市",
            code: "530681",
            areaCode: "0870",
          },
        ],
      },
      {
        name: "丽江市",
        code: "530700",
        areaCode: "0888",
        cities: [
          {
            name: "丽江市市辖区",
            code: "530701",
            areaCode: "0888",
          },
          {
            name: "古城区",
            code: "530702",
            areaCode: "0888",
          },
          {
            name: "玉龙纳西族自治县",
            code: "530721",
            areaCode: "0888",
          },
          {
            name: "永胜县",
            code: "530722",
            areaCode: "0888",
          },
          {
            name: "华坪县",
            code: "530723",
            areaCode: "0888",
          },
          {
            name: "宁蒗彝族自治县",
            code: "530724",
            areaCode: "0888",
          },
        ],
      },
      {
        name: "普洱市",
        code: "530800",
        areaCode: "0879",
        cities: [
          {
            name: "普洱市市辖区",
            code: "530801",
            areaCode: "0879",
          },
          {
            name: "思茅区",
            code: "530802",
            areaCode: "0879",
          },
          {
            name: "宁洱哈尼族彝族自治县",
            code: "530821",
            areaCode: "0879",
          },
          {
            name: "墨江哈尼族自治县",
            code: "530822",
            areaCode: "0879",
          },
          {
            name: "景东彝族自治县",
            code: "530823",
            areaCode: "0879",
          },
          {
            name: "景谷傣族彝族自治县",
            code: "530824",
            areaCode: "0879",
          },
          {
            name: "镇沅彝族哈尼族拉祜族自治县",
            code: "530825",
            areaCode: "0879",
          },
          {
            name: "江城哈尼族彝族自治县",
            code: "530826",
            areaCode: "0879",
          },
          {
            name: "孟连傣族拉祜族佤族自治县",
            code: "530827",
            areaCode: "0879",
          },
          {
            name: "澜沧拉祜族自治县",
            code: "530828",
            areaCode: "0879",
          },
          {
            name: "西盟佤族自治县",
            code: "530829",
            areaCode: "0879",
          },
        ],
      },
      {
        name: "临沧市",
        code: "530900",
        areaCode: "0883",
        cities: [
          {
            name: "临沧市市辖区",
            code: "530901",
            areaCode: "0883",
          },
          {
            name: "临翔区",
            code: "530902",
            areaCode: "0883",
          },
          {
            name: "凤庆县",
            code: "530921",
            areaCode: "0883",
          },
          {
            name: "云县",
            code: "530922",
            areaCode: "0883",
          },
          {
            name: "永德县",
            code: "530923",
            areaCode: "0883",
          },
          {
            name: "镇康县",
            code: "530924",
            areaCode: "0883",
          },
          {
            name: "双江拉祜族佤族布朗族傣族自治县",
            code: "530925",
            areaCode: "0883",
          },
          {
            name: "耿马傣族佤族自治县",
            code: "530926",
            areaCode: "0883",
          },
          {
            name: "沧源佤族自治县",
            code: "530927",
            areaCode: "0883",
          },
        ],
      },
      {
        name: "楚雄彝族自治州",
        code: "532300",
        areaCode: "0878",
        cities: [
          {
            name: "楚雄市",
            code: "532301",
            areaCode: "0878",
          },
          {
            name: "双柏县",
            code: "532322",
            areaCode: "0878",
          },
          {
            name: "牟定县",
            code: "532323",
            areaCode: "0878",
          },
          {
            name: "南华县",
            code: "532324",
            areaCode: "0878",
          },
          {
            name: "姚安县",
            code: "532325",
            areaCode: "0878",
          },
          {
            name: "大姚县",
            code: "532326",
            areaCode: "0878",
          },
          {
            name: "永仁县",
            code: "532327",
            areaCode: "0878",
          },
          {
            name: "元谋县",
            code: "532328",
            areaCode: "0878",
          },
          {
            name: "武定县",
            code: "532329",
            areaCode: "0878",
          },
          {
            name: "禄丰县",
            code: "532331",
            areaCode: "0878",
          },
        ],
      },
      {
        name: "红河哈尼族彝族自治州",
        code: "532500",
        areaCode: "0873",
        cities: [
          {
            name: "个旧市",
            code: "532501",
            areaCode: "0873",
          },
          {
            name: "开远市",
            code: "532502",
            areaCode: "0873",
          },
          {
            name: "蒙自市",
            code: "532503",
            areaCode: "0873",
          },
          {
            name: "弥勒市",
            code: "532504",
            areaCode: "0873",
          },
          {
            name: "屏边苗族自治县",
            code: "532523",
            areaCode: "0873",
          },
          {
            name: "建水县",
            code: "532524",
            areaCode: "0873",
          },
          {
            name: "石屏县",
            code: "532525",
            areaCode: "0873",
          },
          {
            name: "泸西县",
            code: "532527",
            areaCode: "0873",
          },
          {
            name: "元阳县",
            code: "532528",
            areaCode: "0873",
          },
          {
            name: "红河县",
            code: "532529",
            areaCode: "0873",
          },
          {
            name: "金平苗族瑶族傣族自治县",
            code: "532530",
            areaCode: "0873",
          },
          {
            name: "绿春县",
            code: "532531",
            areaCode: "0873",
          },
          {
            name: "河口瑶族自治县",
            code: "532532",
            areaCode: "0873",
          },
        ],
      },
      {
        name: "文山壮族苗族自治州",
        code: "532600",
        areaCode: "0876",
        cities: [
          {
            name: "文山市",
            code: "532601",
            areaCode: "0876",
          },
          {
            name: "砚山县",
            code: "532622",
            areaCode: "0876",
          },
          {
            name: "西畴县",
            code: "532623",
            areaCode: "0876",
          },
          {
            name: "麻栗坡县",
            code: "532624",
            areaCode: "0876",
          },
          {
            name: "马关县",
            code: "532625",
            areaCode: "0876",
          },
          {
            name: "丘北县",
            code: "532626",
            areaCode: "0876",
          },
          {
            name: "广南县",
            code: "532627",
            areaCode: "0876",
          },
          {
            name: "富宁县",
            code: "532628",
            areaCode: "0876",
          },
        ],
      },
      {
        name: "西双版纳傣族自治州",
        code: "532800",
        areaCode: "0691",
        cities: [
          {
            name: "景洪市",
            code: "532801",
            areaCode: "0691",
          },
          {
            name: "勐海县",
            code: "532822",
            areaCode: "0691",
          },
          {
            name: "勐腊县",
            code: "532823",
            areaCode: "0691",
          },
        ],
      },
      {
        name: "大理白族自治州",
        code: "532900",
        areaCode: "0872",
        cities: [
          {
            name: "大理市",
            code: "532901",
            areaCode: "0872",
          },
          {
            name: "漾濞彝族自治县",
            code: "532922",
            areaCode: "0872",
          },
          {
            name: "祥云县",
            code: "532923",
            areaCode: "0872",
          },
          {
            name: "宾川县",
            code: "532924",
            areaCode: "0872",
          },
          {
            name: "弥渡县",
            code: "532925",
            areaCode: "0872",
          },
          {
            name: "南涧彝族自治县",
            code: "532926",
            areaCode: "0872",
          },
          {
            name: "巍山彝族回族自治县",
            code: "532927",
            areaCode: "0872",
          },
          {
            name: "永平县",
            code: "532928",
            areaCode: "0872",
          },
          {
            name: "云龙县",
            code: "532929",
            areaCode: "0872",
          },
          {
            name: "洱源县",
            code: "532930",
            areaCode: "0872",
          },
          {
            name: "剑川县",
            code: "532931",
            areaCode: "0872",
          },
          {
            name: "鹤庆县",
            code: "532932",
            areaCode: "0872",
          },
        ],
      },
      {
        name: "德宏傣族景颇族自治州",
        code: "533100",
        areaCode: "0692",
        cities: [
          {
            name: "瑞丽市",
            code: "533102",
            areaCode: "0692",
          },
          {
            name: "芒市",
            code: "533103",
            areaCode: "0692",
          },
          {
            name: "梁河县",
            code: "533122",
            areaCode: "0692",
          },
          {
            name: "盈江县",
            code: "533123",
            areaCode: "0692",
          },
          {
            name: "陇川县",
            code: "533124",
            areaCode: "0692",
          },
        ],
      },
      {
        name: "怒江傈僳族自治州",
        code: "533300",
        areaCode: "0886",
        cities: [
          {
            name: "泸水市",
            code: "533301",
            areaCode: "0886",
          },
          {
            name: "福贡县",
            code: "533323",
            areaCode: "0886",
          },
          {
            name: "贡山独龙族怒族自治县",
            code: "533324",
            areaCode: "0886",
          },
          {
            name: "兰坪白族普米族自治县",
            code: "533325",
            areaCode: "0886",
          },
        ],
      },
      {
        name: "迪庆藏族自治州",
        code: "533400",
        areaCode: "0887",
        cities: [
          {
            name: "香格里拉市",
            code: "533401",
            areaCode: "0887",
          },
          {
            name: "德钦县",
            code: "533422",
            areaCode: "0887",
          },
          {
            name: "维西傈僳族自治县",
            code: "533423",
            areaCode: "0887",
          },
        ],
      },
    ],
  },
  {
    name: "西藏自治区",
    code: "540000",
    areaCode: "",
    cities: [
      {
        name: "拉萨市",
        code: "540100",
        areaCode: "0891",
        cities: [
          {
            name: "拉萨市市辖区",
            code: "540101",
            areaCode: "0891",
          },
          {
            name: "城关区",
            code: "540102",
            areaCode: "0891",
          },
          {
            name: "堆龙德庆区",
            code: "540103",
            areaCode: "0891",
          },
          {
            name: "达孜区",
            code: "540104",
            areaCode: "0891",
          },
          {
            name: "林周县",
            code: "540121",
            areaCode: "0891",
          },
          {
            name: "当雄县",
            code: "540122",
            areaCode: "0891",
          },
          {
            name: "尼木县",
            code: "540123",
            areaCode: "0891",
          },
          {
            name: "曲水县",
            code: "540124",
            areaCode: "0891",
          },
          {
            name: "墨竹工卡县",
            code: "540127",
            areaCode: "0891",
          },
        ],
      },
      {
        name: "日喀则市",
        code: "540200",
        areaCode: "0892",
        cities: [
          {
            name: "桑珠孜区",
            code: "540202",
            areaCode: "0892",
          },
          {
            name: "南木林县",
            code: "540221",
            areaCode: "0892",
          },
          {
            name: "江孜县",
            code: "540222",
            areaCode: "0892",
          },
          {
            name: "定日县",
            code: "540223",
            areaCode: "0892",
          },
          {
            name: "萨迦县",
            code: "540224",
            areaCode: "0892",
          },
          {
            name: "拉孜县",
            code: "540225",
            areaCode: "0892",
          },
          {
            name: "昂仁县",
            code: "540226",
            areaCode: "0892",
          },
          {
            name: "谢通门县",
            code: "540227",
            areaCode: "0892",
          },
          {
            name: "白朗县",
            code: "540228",
            areaCode: "0892",
          },
          {
            name: "仁布县",
            code: "540229",
            areaCode: "0892",
          },
          {
            name: "康马县",
            code: "540230",
            areaCode: "0892",
          },
          {
            name: "定结县",
            code: "540231",
            areaCode: "0892",
          },
          {
            name: "仲巴县",
            code: "540232",
            areaCode: "0892",
          },
          {
            name: "亚东县",
            code: "540233",
            areaCode: "0892",
          },
          {
            name: "吉隆县",
            code: "540234",
            areaCode: "0892",
          },
          {
            name: "聂拉木县",
            code: "540235",
            areaCode: "0892",
          },
          {
            name: "萨嘎县",
            code: "540236",
            areaCode: "0892",
          },
          {
            name: "岗巴县",
            code: "540237",
            areaCode: "0892",
          },
        ],
      },
      {
        name: "昌都市",
        code: "540300",
        areaCode: "0895",
        cities: [
          {
            name: "卡若区",
            code: "540302",
            areaCode: "0895",
          },
          {
            name: "江达县",
            code: "540321",
            areaCode: "0895",
          },
          {
            name: "贡觉县",
            code: "540322",
            areaCode: "0895",
          },
          {
            name: "类乌齐县",
            code: "540323",
            areaCode: "0895",
          },
          {
            name: "丁青县",
            code: "540324",
            areaCode: "0895",
          },
          {
            name: "察雅县",
            code: "540325",
            areaCode: "0895",
          },
          {
            name: "八宿县",
            code: "540326",
            areaCode: "0895",
          },
          {
            name: "左贡县",
            code: "540327",
            areaCode: "0895",
          },
          {
            name: "芒康县",
            code: "540328",
            areaCode: "0895",
          },
          {
            name: "洛隆县",
            code: "540329",
            areaCode: "0895",
          },
          {
            name: "边坝县",
            code: "540330",
            areaCode: "0895",
          },
        ],
      },
      {
        name: "林芝市",
        code: "540400",
        areaCode: "0894",
        cities: [
          {
            name: "巴宜区",
            code: "540402",
            areaCode: "0894",
          },
          {
            name: "工布江达县",
            code: "540421",
            areaCode: "0894",
          },
          {
            name: "米林县",
            code: "540422",
            areaCode: "0894",
          },
          {
            name: "墨脱县",
            code: "540423",
            areaCode: "0894",
          },
          {
            name: "波密县",
            code: "540424",
            areaCode: "0894",
          },
          {
            name: "察隅县",
            code: "540425",
            areaCode: "0894",
          },
          {
            name: "朗县",
            code: "540426",
            areaCode: "0894",
          },
        ],
      },
      {
        name: "山南市",
        code: "540500",
        areaCode: "0893",
        cities: [
          {
            name: "乃东区",
            code: "540502",
            areaCode: "0893",
          },
          {
            name: "扎囊县",
            code: "540521",
            areaCode: "0893",
          },
          {
            name: "贡嘎县",
            code: "540522",
            areaCode: "0893",
          },
          {
            name: "桑日县",
            code: "540523",
            areaCode: "0893",
          },
          {
            name: "琼结县",
            code: "540524",
            areaCode: "0893",
          },
          {
            name: "曲松县",
            code: "540525",
            areaCode: "0893",
          },
          {
            name: "措美县",
            code: "540526",
            areaCode: "0893",
          },
          {
            name: "洛扎县",
            code: "540527",
            areaCode: "0893",
          },
          {
            name: "加查县",
            code: "540528",
            areaCode: "0893",
          },
          {
            name: "隆子县",
            code: "540529",
            areaCode: "0893",
          },
          {
            name: "错那县",
            code: "540530",
            areaCode: "0893",
          },
          {
            name: "浪卡子县",
            code: "540531",
            areaCode: "0893",
          },
        ],
      },
      {
        name: "那曲市",
        code: "540600",
        areaCode: "0896",
        cities: [
          {
            name: "色尼区",
            code: "540602",
            areaCode: "0896",
          },
          {
            name: "嘉黎县",
            code: "540621",
            areaCode: "0896",
          },
          {
            name: "比如县",
            code: "540622",
            areaCode: "0896",
          },
          {
            name: "聂荣县",
            code: "540623",
            areaCode: "0896",
          },
          {
            name: "安多县",
            code: "540624",
            areaCode: "0896",
          },
          {
            name: "申扎县",
            code: "540625",
            areaCode: "0896",
          },
          {
            name: "索县",
            code: "540626",
            areaCode: "0896",
          },
          {
            name: "班戈县",
            code: "540627",
            areaCode: "0896",
          },
          {
            name: "巴青县",
            code: "540628",
            areaCode: "0896",
          },
          {
            name: "尼玛县",
            code: "540629",
            areaCode: "0896",
          },
          {
            name: "双湖县",
            code: "540630",
            areaCode: "0896",
          },
        ],
      },
      {
        name: "阿里地区",
        code: "542500",
        areaCode: "0897",
        cities: [
          {
            name: "普兰县",
            code: "542521",
            areaCode: "0897",
          },
          {
            name: "札达县",
            code: "542522",
            areaCode: "0897",
          },
          {
            name: "噶尔县",
            code: "542523",
            areaCode: "0897",
          },
          {
            name: "日土县",
            code: "542524",
            areaCode: "0897",
          },
          {
            name: "革吉县",
            code: "542525",
            areaCode: "0897",
          },
          {
            name: "改则县",
            code: "542526",
            areaCode: "0897",
          },
          {
            name: "措勤县",
            code: "542527",
            areaCode: "0897",
          },
        ],
      },
    ],
  },
  {
    name: "陕西省",
    code: "610000",
    areaCode: "",
    cities: [
      {
        name: "西安市",
        code: "610100",
        areaCode: "029",
        cities: [
          {
            name: "西安市市辖区",
            code: "610101",
            areaCode: "029",
          },
          {
            name: "新城区",
            code: "610102",
            areaCode: "029",
          },
          {
            name: "碑林区",
            code: "610103",
            areaCode: "029",
          },
          {
            name: "莲湖区",
            code: "610104",
            areaCode: "029",
          },
          {
            name: "灞桥区",
            code: "610111",
            areaCode: "029",
          },
          {
            name: "未央区",
            code: "610112",
            areaCode: "029",
          },
          {
            name: "雁塔区",
            code: "610113",
            areaCode: "029",
          },
          {
            name: "阎良区",
            code: "610114",
            areaCode: "029",
          },
          {
            name: "临潼区",
            code: "610115",
            areaCode: "029",
          },
          {
            name: "长安区",
            code: "610116",
            areaCode: "029",
          },
          {
            name: "高陵区",
            code: "610117",
            areaCode: "029",
          },
          {
            name: "鄠邑区",
            code: "610118",
            areaCode: "029",
          },
          {
            name: "蓝田县",
            code: "610122",
            areaCode: "029",
          },
          {
            name: "周至县",
            code: "610124",
            areaCode: "029",
          },
        ],
      },
      {
        name: "铜川市",
        code: "610200",
        areaCode: "0919",
        cities: [
          {
            name: "铜川市市辖区",
            code: "610201",
            areaCode: "0919",
          },
          {
            name: "王益区",
            code: "610202",
            areaCode: "0919",
          },
          {
            name: "印台区",
            code: "610203",
            areaCode: "0919",
          },
          {
            name: "耀州区",
            code: "610204",
            areaCode: "0919",
          },
          {
            name: "宜君县",
            code: "610222",
            areaCode: "0919",
          },
        ],
      },
      {
        name: "宝鸡市",
        code: "610300",
        areaCode: "0917",
        cities: [
          {
            name: "宝鸡市市辖区",
            code: "610301",
            areaCode: "0917",
          },
          {
            name: "渭滨区",
            code: "610302",
            areaCode: "0917",
          },
          {
            name: "金台区",
            code: "610303",
            areaCode: "0917",
          },
          {
            name: "陈仓区",
            code: "610304",
            areaCode: "0917",
          },
          {
            name: "凤翔县",
            code: "610322",
            areaCode: "0917",
          },
          {
            name: "岐山县",
            code: "610323",
            areaCode: "0917",
          },
          {
            name: "扶风县",
            code: "610324",
            areaCode: "0917",
          },
          {
            name: "眉县",
            code: "610326",
            areaCode: "0917",
          },
          {
            name: "陇县",
            code: "610327",
            areaCode: "0917",
          },
          {
            name: "千阳县",
            code: "610328",
            areaCode: "0917",
          },
          {
            name: "麟游县",
            code: "610329",
            areaCode: "0917",
          },
          {
            name: "凤县",
            code: "610330",
            areaCode: "0917",
          },
          {
            name: "太白县",
            code: "610331",
            areaCode: "0917",
          },
        ],
      },
      {
        name: "咸阳市",
        code: "610400",
        areaCode: "0910",
        cities: [
          {
            name: "咸阳市市辖区",
            code: "610401",
            areaCode: "0910",
          },
          {
            name: "秦都区",
            code: "610402",
            areaCode: "0910",
          },
          {
            name: "杨陵区",
            code: "610403",
            areaCode: "0910",
          },
          {
            name: "渭城区",
            code: "610404",
            areaCode: "0910",
          },
          {
            name: "三原县",
            code: "610422",
            areaCode: "0910",
          },
          {
            name: "泾阳县",
            code: "610423",
            areaCode: "0910",
          },
          {
            name: "乾县",
            code: "610424",
            areaCode: "0910",
          },
          {
            name: "礼泉县",
            code: "610425",
            areaCode: "0910",
          },
          {
            name: "永寿县",
            code: "610426",
            areaCode: "0910",
          },
          {
            name: "彬州市",
            code: "610482",
            areaCode: "0910",
          },
          {
            name: "长武县",
            code: "610428",
            areaCode: "0910",
          },
          {
            name: "旬邑县",
            code: "610429",
            areaCode: "0910",
          },
          {
            name: "淳化县",
            code: "610430",
            areaCode: "0910",
          },
          {
            name: "武功县",
            code: "610431",
            areaCode: "0910",
          },
          {
            name: "兴平市",
            code: "610481",
            areaCode: "0910",
          },
        ],
      },
      {
        name: "渭南市",
        code: "610500",
        areaCode: "0913",
        cities: [
          {
            name: "渭南市市辖区",
            code: "610501",
            areaCode: "0913",
          },
          {
            name: "临渭区",
            code: "610502",
            areaCode: "0913",
          },
          {
            name: "华州区",
            code: "610503",
            areaCode: "0913",
          },
          {
            name: "潼关县",
            code: "610522",
            areaCode: "0913",
          },
          {
            name: "大荔县",
            code: "610523",
            areaCode: "0913",
          },
          {
            name: "合阳县",
            code: "610524",
            areaCode: "0913",
          },
          {
            name: "澄城县",
            code: "610525",
            areaCode: "0913",
          },
          {
            name: "蒲城县",
            code: "610526",
            areaCode: "0913",
          },
          {
            name: "白水县",
            code: "610527",
            areaCode: "0913",
          },
          {
            name: "富平县",
            code: "610528",
            areaCode: "0913",
          },
          {
            name: "韩城市",
            code: "610581",
            areaCode: "0913",
          },
          {
            name: "华阴市",
            code: "610582",
            areaCode: "0913",
          },
        ],
      },
      {
        name: "延安市",
        code: "610600",
        areaCode: "0911",
        cities: [
          {
            name: "延安市市辖区",
            code: "610601",
            areaCode: "0911",
          },
          {
            name: "宝塔区",
            code: "610602",
            areaCode: "0911",
          },
          {
            name: "安塞区",
            code: "610603",
            areaCode: "0911",
          },
          {
            name: "延长县",
            code: "610621",
            areaCode: "0911",
          },
          {
            name: "延川县",
            code: "610622",
            areaCode: "0911",
          },
          {
            name: "子长市",
            code: "610681",
            areaCode: "0911",
          },
          {
            name: "志丹县",
            code: "610625",
            areaCode: "0911",
          },
          {
            name: "吴起县",
            code: "610626",
            areaCode: "0911",
          },
          {
            name: "甘泉县",
            code: "610627",
            areaCode: "0911",
          },
          {
            name: "富县",
            code: "610628",
            areaCode: "0911",
          },
          {
            name: "洛川县",
            code: "610629",
            areaCode: "0911",
          },
          {
            name: "宜川县",
            code: "610630",
            areaCode: "0911",
          },
          {
            name: "黄龙县",
            code: "610631",
            areaCode: "0911",
          },
          {
            name: "黄陵县",
            code: "610632",
            areaCode: "0911",
          },
        ],
      },
      {
        name: "汉中市",
        code: "610700",
        areaCode: "0916",
        cities: [
          {
            name: "汉中市市辖区",
            code: "610701",
            areaCode: "0916",
          },
          {
            name: "汉台区",
            code: "610702",
            areaCode: "0916",
          },
          {
            name: "南郑区",
            code: "610703",
            areaCode: "0916",
          },
          {
            name: "城固县",
            code: "610722",
            areaCode: "0916",
          },
          {
            name: "洋县",
            code: "610723",
            areaCode: "0916",
          },
          {
            name: "西乡县",
            code: "610724",
            areaCode: "0916",
          },
          {
            name: "勉县",
            code: "610725",
            areaCode: "0916",
          },
          {
            name: "宁强县",
            code: "610726",
            areaCode: "0916",
          },
          {
            name: "略阳县",
            code: "610727",
            areaCode: "0916",
          },
          {
            name: "镇巴县",
            code: "610728",
            areaCode: "0916",
          },
          {
            name: "留坝县",
            code: "610729",
            areaCode: "0916",
          },
          {
            name: "佛坪县",
            code: "610730",
            areaCode: "0916",
          },
        ],
      },
      {
        name: "榆林市",
        code: "610800",
        areaCode: "0912",
        cities: [
          {
            name: "榆林市市辖区",
            code: "610801",
            areaCode: "0912",
          },
          {
            name: "榆阳区",
            code: "610802",
            areaCode: "0912",
          },
          {
            name: "横山区",
            code: "610803",
            areaCode: "0912",
          },
          {
            name: "府谷县",
            code: "610822",
            areaCode: "0912",
          },
          {
            name: "靖边县",
            code: "610824",
            areaCode: "0912",
          },
          {
            name: "定边县",
            code: "610825",
            areaCode: "0912",
          },
          {
            name: "绥德县",
            code: "610826",
            areaCode: "0912",
          },
          {
            name: "米脂县",
            code: "610827",
            areaCode: "0912",
          },
          {
            name: "佳县",
            code: "610828",
            areaCode: "0912",
          },
          {
            name: "吴堡县",
            code: "610829",
            areaCode: "0912",
          },
          {
            name: "清涧县",
            code: "610830",
            areaCode: "0912",
          },
          {
            name: "子洲县",
            code: "610831",
            areaCode: "0912",
          },
          {
            name: "神木市",
            code: "610881",
            areaCode: "0912",
          },
        ],
      },
      {
        name: "安康市",
        code: "610900",
        areaCode: "0915",
        cities: [
          {
            name: "安康市市辖区",
            code: "610901",
            areaCode: "0915",
          },
          {
            name: "汉滨区",
            code: "610902",
            areaCode: "0915",
          },
          {
            name: "汉阴县",
            code: "610921",
            areaCode: "0915",
          },
          {
            name: "石泉县",
            code: "610922",
            areaCode: "0915",
          },
          {
            name: "宁陕县",
            code: "610923",
            areaCode: "0915",
          },
          {
            name: "紫阳县",
            code: "610924",
            areaCode: "0915",
          },
          {
            name: "岚皋县",
            code: "610925",
            areaCode: "0915",
          },
          {
            name: "平利县",
            code: "610926",
            areaCode: "0915",
          },
          {
            name: "镇坪县",
            code: "610927",
            areaCode: "0915",
          },
          {
            name: "旬阳县",
            code: "610928",
            areaCode: "0915",
          },
          {
            name: "白河县",
            code: "610929",
            areaCode: "0915",
          },
        ],
      },
      {
        name: "商洛市",
        code: "611000",
        areaCode: "0914",
        cities: [
          {
            name: "商洛市市辖区",
            code: "611001",
            areaCode: "0914",
          },
          {
            name: "商州区",
            code: "611002",
            areaCode: "0914",
          },
          {
            name: "洛南县",
            code: "611021",
            areaCode: "0914",
          },
          {
            name: "丹凤县",
            code: "611022",
            areaCode: "0914",
          },
          {
            name: "商南县",
            code: "611023",
            areaCode: "0914",
          },
          {
            name: "山阳县",
            code: "611024",
            areaCode: "0914",
          },
          {
            name: "镇安县",
            code: "611025",
            areaCode: "0914",
          },
          {
            name: "柞水县",
            code: "611026",
            areaCode: "0914",
          },
        ],
      },
    ],
  },
  {
    name: "甘肃省",
    code: "620000",
    areaCode: "",
    cities: [
      {
        name: "兰州市",
        code: "620100",
        areaCode: "0931",
        cities: [
          {
            name: "兰州市市辖区",
            code: "620101",
            areaCode: "0931",
          },
          {
            name: "城关区",
            code: "620102",
            areaCode: "0931",
          },
          {
            name: "七里河区",
            code: "620103",
            areaCode: "0931",
          },
          {
            name: "西固区",
            code: "620104",
            areaCode: "0931",
          },
          {
            name: "安宁区",
            code: "620105",
            areaCode: "0931",
          },
          {
            name: "红古区",
            code: "620111",
            areaCode: "0931",
          },
          {
            name: "永登县",
            code: "620121",
            areaCode: "0931",
          },
          {
            name: "皋兰县",
            code: "620122",
            areaCode: "0931",
          },
          {
            name: "榆中县",
            code: "620123",
            areaCode: "0931",
          },
        ],
      },
      {
        name: "嘉峪关市",
        code: "620200",
        areaCode: "1937",
        cities: [
          {
            name: "嘉峪关市市辖区",
            code: "620201",
            areaCode: "1937",
          },
        ],
      },
      {
        name: "金昌市",
        code: "620300",
        areaCode: "0935",
        cities: [
          {
            name: "金昌市市辖区",
            code: "620301",
            areaCode: "0935",
          },
          {
            name: "金川区",
            code: "620302",
            areaCode: "0935",
          },
          {
            name: "永昌县",
            code: "620321",
            areaCode: "0935",
          },
        ],
      },
      {
        name: "白银市",
        code: "620400",
        areaCode: "0943",
        cities: [
          {
            name: "白银市市辖区",
            code: "620401",
            areaCode: "0943",
          },
          {
            name: "白银区",
            code: "620402",
            areaCode: "0943",
          },
          {
            name: "平川区",
            code: "620403",
            areaCode: "0943",
          },
          {
            name: "靖远县",
            code: "620421",
            areaCode: "0943",
          },
          {
            name: "会宁县",
            code: "620422",
            areaCode: "0943",
          },
          {
            name: "景泰县",
            code: "620423",
            areaCode: "0943",
          },
        ],
      },
      {
        name: "天水市",
        code: "620500",
        areaCode: "0938",
        cities: [
          {
            name: "天水市市辖区",
            code: "620501",
            areaCode: "0938",
          },
          {
            name: "秦州区",
            code: "620502",
            areaCode: "0938",
          },
          {
            name: "麦积区",
            code: "620503",
            areaCode: "0938",
          },
          {
            name: "清水县",
            code: "620521",
            areaCode: "0938",
          },
          {
            name: "秦安县",
            code: "620522",
            areaCode: "0938",
          },
          {
            name: "甘谷县",
            code: "620523",
            areaCode: "0938",
          },
          {
            name: "武山县",
            code: "620524",
            areaCode: "0938",
          },
          {
            name: "张家川回族自治县",
            code: "620525",
            areaCode: "0938",
          },
        ],
      },
      {
        name: "武威市",
        code: "620600",
        areaCode: "1935",
        cities: [
          {
            name: "武威市市辖区",
            code: "620601",
            areaCode: "1935",
          },
          {
            name: "凉州区",
            code: "620602",
            areaCode: "1935",
          },
          {
            name: "民勤县",
            code: "620621",
            areaCode: "1935",
          },
          {
            name: "古浪县",
            code: "620622",
            areaCode: "1935",
          },
          {
            name: "天祝藏族自治县",
            code: "620623",
            areaCode: "1935",
          },
        ],
      },
      {
        name: "张掖市",
        code: "620700",
        areaCode: "0936",
        cities: [
          {
            name: "张掖市市辖区",
            code: "620701",
            areaCode: "0936",
          },
          {
            name: "甘州区",
            code: "620702",
            areaCode: "0936",
          },
          {
            name: "肃南裕固族自治县",
            code: "620721",
            areaCode: "0936",
          },
          {
            name: "民乐县",
            code: "620722",
            areaCode: "0936",
          },
          {
            name: "临泽县",
            code: "620723",
            areaCode: "0936",
          },
          {
            name: "高台县",
            code: "620724",
            areaCode: "0936",
          },
          {
            name: "山丹县",
            code: "620725",
            areaCode: "0936",
          },
        ],
      },
      {
        name: "平凉市",
        code: "620800",
        areaCode: "0933",
        cities: [
          {
            name: "平凉市市辖区",
            code: "620801",
            areaCode: "0933",
          },
          {
            name: "崆峒区",
            code: "620802",
            areaCode: "0933",
          },
          {
            name: "泾川县",
            code: "620821",
            areaCode: "0933",
          },
          {
            name: "灵台县",
            code: "620822",
            areaCode: "0933",
          },
          {
            name: "崇信县",
            code: "620823",
            areaCode: "0933",
          },
          {
            name: "华亭市",
            code: "620881",
            areaCode: "0933",
          },
          {
            name: "庄浪县",
            code: "620825",
            areaCode: "0933",
          },
          {
            name: "静宁县",
            code: "620826",
            areaCode: "0933",
          },
        ],
      },
      {
        name: "酒泉市",
        code: "620900",
        areaCode: "0937",
        cities: [
          {
            name: "酒泉市市辖区",
            code: "620901",
            areaCode: "0937",
          },
          {
            name: "肃州区",
            code: "620902",
            areaCode: "0937",
          },
          {
            name: "金塔县",
            code: "620921",
            areaCode: "0937",
          },
          {
            name: "瓜州县",
            code: "620922",
            areaCode: "0937",
          },
          {
            name: "肃北蒙古族自治县",
            code: "620923",
            areaCode: "0937",
          },
          {
            name: "阿克塞哈萨克族自治县",
            code: "620924",
            areaCode: "0937",
          },
          {
            name: "玉门市",
            code: "620981",
            areaCode: "0937",
          },
          {
            name: "敦煌市",
            code: "620982",
            areaCode: "0937",
          },
        ],
      },
      {
        name: "庆阳市",
        code: "621000",
        areaCode: "0934",
        cities: [
          {
            name: "庆阳市市辖区",
            code: "621001",
            areaCode: "0934",
          },
          {
            name: "西峰区",
            code: "621002",
            areaCode: "0934",
          },
          {
            name: "庆城县",
            code: "621021",
            areaCode: "0934",
          },
          {
            name: "环县",
            code: "621022",
            areaCode: "0934",
          },
          {
            name: "华池县",
            code: "621023",
            areaCode: "0934",
          },
          {
            name: "合水县",
            code: "621024",
            areaCode: "0934",
          },
          {
            name: "正宁县",
            code: "621025",
            areaCode: "0934",
          },
          {
            name: "宁县",
            code: "621026",
            areaCode: "0934",
          },
          {
            name: "镇原县",
            code: "621027",
            areaCode: "0934",
          },
        ],
      },
      {
        name: "定西市",
        code: "621100",
        areaCode: "0932",
        cities: [
          {
            name: "定西市市辖区",
            code: "621101",
            areaCode: "0932",
          },
          {
            name: "安定区",
            code: "621102",
            areaCode: "0932",
          },
          {
            name: "通渭县",
            code: "621121",
            areaCode: "0932",
          },
          {
            name: "陇西县",
            code: "621122",
            areaCode: "0932",
          },
          {
            name: "渭源县",
            code: "621123",
            areaCode: "0932",
          },
          {
            name: "临洮县",
            code: "621124",
            areaCode: "0932",
          },
          {
            name: "漳县",
            code: "621125",
            areaCode: "0932",
          },
          {
            name: "岷县",
            code: "621126",
            areaCode: "0932",
          },
        ],
      },
      {
        name: "陇南市",
        code: "621200",
        areaCode: "2935",
        cities: [
          {
            name: "陇南市市辖区",
            code: "621201",
            areaCode: "2935",
          },
          {
            name: "武都区",
            code: "621202",
            areaCode: "2935",
          },
          {
            name: "成县",
            code: "621221",
            areaCode: "2935",
          },
          {
            name: "文县",
            code: "621222",
            areaCode: "2935",
          },
          {
            name: "宕昌县",
            code: "621223",
            areaCode: "2935",
          },
          {
            name: "康县",
            code: "621224",
            areaCode: "2935",
          },
          {
            name: "西和县",
            code: "621225",
            areaCode: "2935",
          },
          {
            name: "礼县",
            code: "621226",
            areaCode: "2935",
          },
          {
            name: "徽县",
            code: "621227",
            areaCode: "2935",
          },
          {
            name: "两当县",
            code: "621228",
            areaCode: "2935",
          },
        ],
      },
      {
        name: "临夏回族自治州",
        code: "622900",
        areaCode: "0930",
        cities: [
          {
            name: "临夏市",
            code: "622901",
            areaCode: "0930",
          },
          {
            name: "临夏县",
            code: "622921",
            areaCode: "0930",
          },
          {
            name: "康乐县",
            code: "622922",
            areaCode: "0930",
          },
          {
            name: "永靖县",
            code: "622923",
            areaCode: "0930",
          },
          {
            name: "广河县",
            code: "622924",
            areaCode: "0930",
          },
          {
            name: "和政县",
            code: "622925",
            areaCode: "0930",
          },
          {
            name: "东乡族自治县",
            code: "622926",
            areaCode: "0930",
          },
          {
            name: "积石山保安族东乡族撒拉族自治县",
            code: "622927",
            areaCode: "0930",
          },
        ],
      },
      {
        name: "甘南藏族自治州",
        code: "623000",
        areaCode: "0941",
        cities: [
          {
            name: "合作市",
            code: "623001",
            areaCode: "0941",
          },
          {
            name: "临潭县",
            code: "623021",
            areaCode: "0941",
          },
          {
            name: "卓尼县",
            code: "623022",
            areaCode: "0941",
          },
          {
            name: "舟曲县",
            code: "623023",
            areaCode: "0941",
          },
          {
            name: "迭部县",
            code: "623024",
            areaCode: "0941",
          },
          {
            name: "玛曲县",
            code: "623025",
            areaCode: "0941",
          },
          {
            name: "碌曲县",
            code: "623026",
            areaCode: "0941",
          },
          {
            name: "夏河县",
            code: "623027",
            areaCode: "0941",
          },
        ],
      },
    ],
  },
  {
    name: "青海省",
    code: "630000",
    areaCode: "",
    cities: [
      {
        name: "西宁市",
        code: "630100",
        areaCode: "0971",
        cities: [
          {
            name: "西宁市市辖区",
            code: "630101",
            areaCode: "0971",
          },
          {
            name: "城东区",
            code: "630102",
            areaCode: "0971",
          },
          {
            name: "城中区",
            code: "630103",
            areaCode: "0971",
          },
          {
            name: "城西区",
            code: "630104",
            areaCode: "0971",
          },
          {
            name: "城北区",
            code: "630105",
            areaCode: "0971",
          },
          {
            name: "大通回族土族自治县",
            code: "630121",
            areaCode: "0971",
          },
          {
            name: "湟中区",
            code: "630106",
            areaCode: "0971",
          },
          {
            name: "湟源县",
            code: "630123",
            areaCode: "0971",
          },
        ],
      },
      {
        name: "海东市",
        code: "630200",
        areaCode: "0972",
        cities: [
          {
            name: "乐都区",
            code: "630202",
            areaCode: "0972",
          },
          {
            name: "平安区",
            code: "630203",
            areaCode: "0972",
          },
          {
            name: "民和回族土族自治县",
            code: "630222",
            areaCode: "0972",
          },
          {
            name: "互助土族自治县",
            code: "630223",
            areaCode: "0972",
          },
          {
            name: "化隆回族自治县",
            code: "630224",
            areaCode: "0972",
          },
          {
            name: "循化撒拉族自治县",
            code: "630225",
            areaCode: "0972",
          },
        ],
      },
      {
        name: "海北藏族自治州",
        code: "632200",
        areaCode: "0970",
        cities: [
          {
            name: "门源回族自治县",
            code: "632221",
            areaCode: "0970",
          },
          {
            name: "祁连县",
            code: "632222",
            areaCode: "0970",
          },
          {
            name: "海晏县",
            code: "632223",
            areaCode: "0970",
          },
          {
            name: "刚察县",
            code: "632224",
            areaCode: "0970",
          },
        ],
      },
      {
        name: "黄南藏族自治州",
        code: "632300",
        areaCode: "0973",
        cities: [
          {
            name: "同仁市",
            code: "632301",
            areaCode: "0973",
          },
          {
            name: "尖扎县",
            code: "632322",
            areaCode: "0973",
          },
          {
            name: "泽库县",
            code: "632323",
            areaCode: "0973",
          },
          {
            name: "河南蒙古族自治县",
            code: "632324",
            areaCode: "0973",
          },
        ],
      },
      {
        name: "海南藏族自治州",
        code: "632500",
        areaCode: "0974",
        cities: [
          {
            name: "共和县",
            code: "632521",
            areaCode: "0974",
          },
          {
            name: "同德县",
            code: "632522",
            areaCode: "0974",
          },
          {
            name: "贵德县",
            code: "632523",
            areaCode: "0974",
          },
          {
            name: "兴海县",
            code: "632524",
            areaCode: "0974",
          },
          {
            name: "贵南县",
            code: "632525",
            areaCode: "0974",
          },
        ],
      },
      {
        name: "果洛藏族自治州",
        code: "632600",
        areaCode: "0975",
        cities: [
          {
            name: "玛沁县",
            code: "632621",
            areaCode: "0975",
          },
          {
            name: "班玛县",
            code: "632622",
            areaCode: "0975",
          },
          {
            name: "甘德县",
            code: "632623",
            areaCode: "0975",
          },
          {
            name: "达日县",
            code: "632624",
            areaCode: "0975",
          },
          {
            name: "久治县",
            code: "632625",
            areaCode: "0975",
          },
          {
            name: "玛多县",
            code: "632626",
            areaCode: "0975",
          },
        ],
      },
      {
        name: "玉树藏族自治州",
        code: "632700",
        areaCode: "0976",
        cities: [
          {
            name: "玉树市",
            code: "632701",
            areaCode: "0976",
          },
          {
            name: "杂多县",
            code: "632722",
            areaCode: "0976",
          },
          {
            name: "称多县",
            code: "632723",
            areaCode: "0976",
          },
          {
            name: "治多县",
            code: "632724",
            areaCode: "0976",
          },
          {
            name: "囊谦县",
            code: "632725",
            areaCode: "0976",
          },
          {
            name: "曲麻莱县",
            code: "632726",
            areaCode: "0976",
          },
        ],
      },
      {
        name: "海西蒙古族藏族自治州",
        code: "632800",
        areaCode: "0977",
        cities: [
          {
            name: "格尔木市",
            code: "632801",
            areaCode: "0977",
          },
          {
            name: "德令哈市",
            code: "632802",
            areaCode: "0977",
          },
          {
            name: "茫崖市",
            code: "632803",
            areaCode: "0977",
          },
          {
            name: "乌兰县",
            code: "632821",
            areaCode: "0977",
          },
          {
            name: "都兰县",
            code: "632822",
            areaCode: "0977",
          },
          {
            name: "天峻县",
            code: "632823",
            areaCode: "0977",
          },
          {
            name: "海西蒙古族藏族自治州直辖",
            code: "632825",
            areaCode: "0977",
          },
        ],
      },
    ],
  },
  {
    name: "宁夏回族自治区",
    code: "640000",
    areaCode: "",
    cities: [
      {
        name: "银川市",
        code: "640100",
        areaCode: "0951",
        cities: [
          {
            name: "银川市市辖区",
            code: "640101",
            areaCode: "0951",
          },
          {
            name: "兴庆区",
            code: "640104",
            areaCode: "0951",
          },
          {
            name: "西夏区",
            code: "640105",
            areaCode: "0951",
          },
          {
            name: "金凤区",
            code: "640106",
            areaCode: "0951",
          },
          {
            name: "永宁县",
            code: "640121",
            areaCode: "0951",
          },
          {
            name: "贺兰县",
            code: "640122",
            areaCode: "0951",
          },
          {
            name: "灵武市",
            code: "640181",
            areaCode: "0951",
          },
        ],
      },
      {
        name: "石嘴山市",
        code: "640200",
        areaCode: "0952",
        cities: [
          {
            name: "石嘴山市市辖区",
            code: "640201",
            areaCode: "0952",
          },
          {
            name: "大武口区",
            code: "640202",
            areaCode: "0952",
          },
          {
            name: "惠农区",
            code: "640205",
            areaCode: "0952",
          },
          {
            name: "平罗县",
            code: "640221",
            areaCode: "0952",
          },
        ],
      },
      {
        name: "吴忠市",
        code: "640300",
        areaCode: "0953",
        cities: [
          {
            name: "吴忠市市辖区",
            code: "640301",
            areaCode: "0953",
          },
          {
            name: "利通区",
            code: "640302",
            areaCode: "0953",
          },
          {
            name: "红寺堡区",
            code: "640303",
            areaCode: "0953",
          },
          {
            name: "盐池县",
            code: "640323",
            areaCode: "0953",
          },
          {
            name: "同心县",
            code: "640324",
            areaCode: "0953",
          },
          {
            name: "青铜峡市",
            code: "640381",
            areaCode: "0953",
          },
        ],
      },
      {
        name: "固原市",
        code: "640400",
        areaCode: "0954",
        cities: [
          {
            name: "固原市市辖区",
            code: "640401",
            areaCode: "0954",
          },
          {
            name: "原州区",
            code: "640402",
            areaCode: "0954",
          },
          {
            name: "西吉县",
            code: "640422",
            areaCode: "0954",
          },
          {
            name: "隆德县",
            code: "640423",
            areaCode: "0954",
          },
          {
            name: "泾源县",
            code: "640424",
            areaCode: "0954",
          },
          {
            name: "彭阳县",
            code: "640425",
            areaCode: "0954",
          },
        ],
      },
      {
        name: "中卫市",
        code: "640500",
        areaCode: "1953",
        cities: [
          {
            name: "中卫市市辖区",
            code: "640501",
            areaCode: "1953",
          },
          {
            name: "沙坡头区",
            code: "640502",
            areaCode: "1953",
          },
          {
            name: "中宁县",
            code: "640521",
            areaCode: "1953",
          },
          {
            name: "海原县",
            code: "640522",
            areaCode: "1953",
          },
        ],
      },
    ],
  },
  {
    name: "新疆维吾尔自治区",
    code: "650000",
    areaCode: "",
    cities: [
      {
        name: "乌鲁木齐市",
        code: "650100",
        areaCode: "0991",
        cities: [
          {
            name: "乌鲁木齐市市辖区",
            code: "650101",
            areaCode: "0991",
          },
          {
            name: "天山区",
            code: "650102",
            areaCode: "0991",
          },
          {
            name: "沙依巴克区",
            code: "650103",
            areaCode: "0991",
          },
          {
            name: "新市区",
            code: "650104",
            areaCode: "0991",
          },
          {
            name: "水磨沟区",
            code: "650105",
            areaCode: "0991",
          },
          {
            name: "头屯河区",
            code: "650106",
            areaCode: "0991",
          },
          {
            name: "达坂城区",
            code: "650107",
            areaCode: "0991",
          },
          {
            name: "米东区",
            code: "650109",
            areaCode: "0991",
          },
          {
            name: "乌鲁木齐县",
            code: "650121",
            areaCode: "0991",
          },
        ],
      },
      {
        name: "克拉玛依市",
        code: "650200",
        areaCode: "0990",
        cities: [
          {
            name: "克拉玛依市市辖区",
            code: "650201",
            areaCode: "0990",
          },
          {
            name: "独山子区",
            code: "650202",
            areaCode: "0990",
          },
          {
            name: "克拉玛依区",
            code: "650203",
            areaCode: "0990",
          },
          {
            name: "白碱滩区",
            code: "650204",
            areaCode: "0990",
          },
          {
            name: "乌尔禾区",
            code: "650205",
            areaCode: "0990",
          },
        ],
      },
      {
        name: "吐鲁番市",
        code: "650400",
        areaCode: "0995",
        cities: [
          {
            name: "高昌区",
            code: "650402",
            areaCode: "0995",
          },
          {
            name: "鄯善县",
            code: "650421",
            areaCode: "0995",
          },
          {
            name: "托克逊县",
            code: "650422",
            areaCode: "0995",
          },
        ],
      },
      {
        name: "哈密市",
        code: "650500",
        areaCode: "0902",
        cities: [
          {
            name: "伊州区",
            code: "650502",
            areaCode: "0902",
          },
          {
            name: "巴里坤哈萨克自治县",
            code: "650521",
            areaCode: "0902",
          },
          {
            name: "伊吾县",
            code: "650522",
            areaCode: "0902",
          },
        ],
      },
      {
        name: "昌吉回族自治州",
        code: "652300",
        areaCode: "0994",
        cities: [
          {
            name: "昌吉市",
            code: "652301",
            areaCode: "0994",
          },
          {
            name: "阜康市",
            code: "652302",
            areaCode: "0994",
          },
          {
            name: "呼图壁县",
            code: "652323",
            areaCode: "0994",
          },
          {
            name: "玛纳斯县",
            code: "652324",
            areaCode: "0994",
          },
          {
            name: "奇台县",
            code: "652325",
            areaCode: "0994",
          },
          {
            name: "吉木萨尔县",
            code: "652327",
            areaCode: "0994",
          },
          {
            name: "木垒哈萨克自治县",
            code: "652328",
            areaCode: "0994",
          },
        ],
      },
      {
        name: "博尔塔拉蒙古自治州",
        code: "652700",
        areaCode: "0909",
        cities: [
          {
            name: "博乐市",
            code: "652701",
            areaCode: "0909",
          },
          {
            name: "阿拉山口市",
            code: "652702",
            areaCode: "0909",
          },
          {
            name: "精河县",
            code: "652722",
            areaCode: "0909",
          },
          {
            name: "温泉县",
            code: "652723",
            areaCode: "0909",
          },
        ],
      },
      {
        name: "巴音郭楞蒙古自治州",
        code: "652800",
        areaCode: "0996",
        cities: [
          {
            name: "库尔勒市",
            code: "652801",
            areaCode: "0996",
          },
          {
            name: "轮台县",
            code: "652822",
            areaCode: "0996",
          },
          {
            name: "尉犁县",
            code: "652823",
            areaCode: "0996",
          },
          {
            name: "若羌县",
            code: "652824",
            areaCode: "0996",
          },
          {
            name: "且末县",
            code: "652825",
            areaCode: "0996",
          },
          {
            name: "焉耆回族自治县",
            code: "652826",
            areaCode: "0996",
          },
          {
            name: "和静县",
            code: "652827",
            areaCode: "0996",
          },
          {
            name: "和硕县",
            code: "652828",
            areaCode: "0996",
          },
          {
            name: "博湖县",
            code: "652829",
            areaCode: "0996",
          },
        ],
      },
      {
        name: "阿克苏地区",
        code: "652900",
        areaCode: "0997",
        cities: [
          {
            name: "阿克苏市",
            code: "652901",
            areaCode: "0997",
          },
          {
            name: "温宿县",
            code: "652922",
            areaCode: "0997",
          },
          {
            name: "库车市",
            code: "652902",
            areaCode: "0997",
          },
          {
            name: "沙雅县",
            code: "652924",
            areaCode: "0997",
          },
          {
            name: "新和县",
            code: "652925",
            areaCode: "0997",
          },
          {
            name: "拜城县",
            code: "652926",
            areaCode: "0997",
          },
          {
            name: "乌什县",
            code: "652927",
            areaCode: "0997",
          },
          {
            name: "阿瓦提县",
            code: "652928",
            areaCode: "0997",
          },
          {
            name: "柯坪县",
            code: "652929",
            areaCode: "0997",
          },
        ],
      },
      {
        name: "克孜勒苏柯尔克孜自治州",
        code: "653000",
        areaCode: "0908",
        cities: [
          {
            name: "阿图什市",
            code: "653001",
            areaCode: "0908",
          },
          {
            name: "阿克陶县",
            code: "653022",
            areaCode: "0908",
          },
          {
            name: "阿合奇县",
            code: "653023",
            areaCode: "0908",
          },
          {
            name: "乌恰县",
            code: "653024",
            areaCode: "0908",
          },
        ],
      },
      {
        name: "喀什地区",
        code: "653100",
        areaCode: "0998",
        cities: [
          {
            name: "喀什市",
            code: "653101",
            areaCode: "0998",
          },
          {
            name: "疏附县",
            code: "653121",
            areaCode: "0998",
          },
          {
            name: "疏勒县",
            code: "653122",
            areaCode: "0998",
          },
          {
            name: "英吉沙县",
            code: "653123",
            areaCode: "0998",
          },
          {
            name: "泽普县",
            code: "653124",
            areaCode: "0998",
          },
          {
            name: "莎车县",
            code: "653125",
            areaCode: "0998",
          },
          {
            name: "叶城县",
            code: "653126",
            areaCode: "0998",
          },
          {
            name: "麦盖提县",
            code: "653127",
            areaCode: "0998",
          },
          {
            name: "岳普湖县",
            code: "653128",
            areaCode: "0998",
          },
          {
            name: "伽师县",
            code: "653129",
            areaCode: "0998",
          },
          {
            name: "巴楚县",
            code: "653130",
            areaCode: "0998",
          },
          {
            name: "塔什库尔干塔吉克自治县",
            code: "653131",
            areaCode: "0998",
          },
        ],
      },
      {
        name: "和田地区",
        code: "653200",
        areaCode: "0903",
        cities: [
          {
            name: "和田市",
            code: "653201",
            areaCode: "0903",
          },
          {
            name: "和田县",
            code: "653221",
            areaCode: "0903",
          },
          {
            name: "墨玉县",
            code: "653222",
            areaCode: "0903",
          },
          {
            name: "皮山县",
            code: "653223",
            areaCode: "0903",
          },
          {
            name: "洛浦县",
            code: "653224",
            areaCode: "0903",
          },
          {
            name: "策勒县",
            code: "653225",
            areaCode: "0903",
          },
          {
            name: "于田县",
            code: "653226",
            areaCode: "0903",
          },
          {
            name: "民丰县",
            code: "653227",
            areaCode: "0903",
          },
        ],
      },
      {
        name: "伊犁哈萨克自治州",
        code: "654000",
        areaCode: "0999",
        cities: [
          {
            name: "伊宁市",
            code: "654002",
            areaCode: "0999",
          },
          {
            name: "奎屯市",
            code: "654003",
            areaCode: "0999",
          },
          {
            name: "霍尔果斯市",
            code: "654004",
            areaCode: "0999",
          },
          {
            name: "伊宁县",
            code: "654021",
            areaCode: "0999",
          },
          {
            name: "察布查尔锡伯自治县",
            code: "654022",
            areaCode: "0999",
          },
          {
            name: "霍城县",
            code: "654023",
            areaCode: "0999",
          },
          {
            name: "巩留县",
            code: "654024",
            areaCode: "0999",
          },
          {
            name: "新源县",
            code: "654025",
            areaCode: "0999",
          },
          {
            name: "昭苏县",
            code: "654026",
            areaCode: "0999",
          },
          {
            name: "特克斯县",
            code: "654027",
            areaCode: "0999",
          },
          {
            name: "尼勒克县",
            code: "654028",
            areaCode: "0999",
          },
        ],
      },
      {
        name: "塔城地区",
        code: "654200",
        areaCode: "0901",
        cities: [
          {
            name: "塔城市",
            code: "654201",
            areaCode: "0901",
          },
          {
            name: "乌苏市",
            code: "654202",
            areaCode: "0901",
          },
          {
            name: "额敏县",
            code: "654221",
            areaCode: "0901",
          },
          {
            name: "沙湾县",
            code: "654223",
            areaCode: "0901",
          },
          {
            name: "托里县",
            code: "654224",
            areaCode: "0901",
          },
          {
            name: "裕民县",
            code: "654225",
            areaCode: "0901",
          },
          {
            name: "和布克赛尔蒙古自治县",
            code: "654226",
            areaCode: "0901",
          },
        ],
      },
      {
        name: "阿勒泰地区",
        code: "654300",
        areaCode: "0906",
        cities: [
          {
            name: "阿勒泰市",
            code: "654301",
            areaCode: "0906",
          },
          {
            name: "布尔津县",
            code: "654321",
            areaCode: "0906",
          },
          {
            name: "富蕴县",
            code: "654322",
            areaCode: "0906",
          },
          {
            name: "福海县",
            code: "654323",
            areaCode: "0906",
          },
          {
            name: "哈巴河县",
            code: "654324",
            areaCode: "0906",
          },
          {
            name: "青河县",
            code: "654325",
            areaCode: "0906",
          },
          {
            name: "吉木乃县",
            code: "654326",
            areaCode: "0906",
          },
        ],
      },
    ],
  },
  {
    name: "台湾省",
    code: "710000",
    areaCode: "1886",
    cities: [],
  },
  {
    name: "香港特别行政区",
    code: "810000",
    areaCode: "1852",
    cities: [],
  },
  {
    name: "澳门特别行政区",
    code: "820000",
    areaCode: "1853",
    cities: [],
  },
  {
    name: "外国",
    code: "900000",
    areaCode: "1900",
    cities: [],
  },
];
